import React from 'react';

export function LogoPropforce(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 228 52" fill="none" {...props}>
      <path
        d="M42.932 42.67V27.392l-8.893-6.244-9.894 6.244V52h1.48V27.856l6.718-3.933V49.78l10.59-7.11Z"
        fill="#009F2B"
      />
      <path
        d="M38.036 22.194V8.008L26.313 0 13.574 8.008v9.333l1.806 1.235v-9.53l8.796-5.34v22.132l9.742-6.008 4.118 2.364Z"
        fill="#2C2C2C"
      />
      <path
        d="M0 42.283V22.27l9.806-6.005 8.836 6.005v29.525L8.199 47.813V19.012l-6.554 3.992v21.303L0 42.283Z"
        fill="#009F2B"
      />
      <path
        d="M56.932 52V22.6h3.15l.21 3.864V52h-3.36Zm10.458-7.896c-1.764 0-3.318-.462-4.662-1.386-1.316-.924-2.338-2.212-3.066-3.864-.728-1.68-1.092-3.598-1.092-5.754 0-2.184.364-4.102 1.092-5.754.728-1.652 1.75-2.94 3.066-3.864 1.344-.924 2.898-1.386 4.662-1.386 1.876 0 3.528.462 4.956 1.386 1.428.924 2.534 2.212 3.318 3.864.812 1.652 1.218 3.57 1.218 5.754 0 2.156-.406 4.074-1.218 5.754-.784 1.652-1.89 2.94-3.318 3.864-1.428.924-3.08 1.386-4.956 1.386Zm-.756-3.066c1.316 0 2.478-.336 3.486-1.008 1.036-.672 1.848-1.61 2.436-2.814.616-1.204.924-2.576.924-4.116 0-1.54-.294-2.912-.882-4.116-.56-1.204-1.358-2.142-2.394-2.814-1.036-.672-2.212-1.008-3.528-1.008-1.232 0-2.338.336-3.318 1.008-.952.672-1.708 1.61-2.268 2.814-.532 1.204-.798 2.576-.798 4.116 0 1.54.266 2.912.798 4.116.56 1.204 1.316 2.142 2.268 2.814.952.672 2.044 1.008 3.276 1.008Zm15.071-8.82c0-2.268.434-4.102 1.302-5.502.868-1.428 1.974-2.478 3.318-3.15a9.395 9.395 0 0 1 4.326-1.05v3.15c-1.232 0-2.422.21-3.57.63a5.966 5.966 0 0 0-2.772 1.974c-.728.924-1.092 2.184-1.092 3.78l-1.512.168ZM79.857 43.6v-21h3.36v21h-3.36Zm21.793.504c-2.044 0-3.864-.462-5.46-1.386-1.568-.952-2.8-2.254-3.696-3.906-.896-1.652-1.344-3.556-1.344-5.712 0-2.156.434-4.06 1.302-5.712.896-1.652 2.128-2.94 3.696-3.864 1.596-.952 3.402-1.428 5.418-1.428 2.072 0 3.892.476 5.46 1.428a9.452 9.452 0 0 1 3.696 3.864c.896 1.652 1.344 3.556 1.344 5.712 0 2.156-.448 4.06-1.344 5.712-.868 1.652-2.086 2.954-3.654 3.906-1.568.924-3.374 1.386-5.418 1.386Zm0-3.108c1.4 0 2.618-.336 3.654-1.008 1.036-.672 1.848-1.596 2.436-2.772.616-1.176.924-2.548.924-4.116 0-1.568-.308-2.94-.924-4.116-.588-1.176-1.414-2.1-2.478-2.772-1.064-.672-2.296-1.008-3.696-1.008-1.372 0-2.59.336-3.654 1.008-1.036.672-1.862 1.596-2.478 2.772-.588 1.176-.882 2.548-.882 4.116 0 1.54.294 2.912.882 4.116.616 1.176 1.456 2.1 2.52 2.772 1.092.672 2.324 1.008 3.696 1.008ZM115.261 52V22.6h3.15l.21 3.864V52h-3.36Zm10.458-7.896c-1.764 0-3.318-.462-4.662-1.386-1.316-.924-2.338-2.212-3.066-3.864-.728-1.68-1.092-3.598-1.092-5.754 0-2.184.364-4.102 1.092-5.754.728-1.652 1.75-2.94 3.066-3.864 1.344-.924 2.898-1.386 4.662-1.386 1.876 0 3.528.462 4.956 1.386 1.428.924 2.534 2.212 3.318 3.864.812 1.652 1.218 3.57 1.218 5.754 0 2.156-.406 4.074-1.218 5.754-.784 1.652-1.89 2.94-3.318 3.864-1.428.924-3.08 1.386-4.956 1.386Zm-.756-3.066c1.316 0 2.478-.336 3.486-1.008 1.036-.672 1.848-1.61 2.436-2.814.616-1.204.924-2.576.924-4.116 0-1.54-.294-2.912-.882-4.116-.56-1.204-1.358-2.142-2.394-2.814-1.036-.672-2.212-1.008-3.528-1.008-1.232 0-2.338.336-3.318 1.008-.952.672-1.708 1.61-2.268 2.814-.532 1.204-.798 2.576-.798 4.116 0 1.54.266 2.912.798 4.116.56 1.204 1.316 2.142 2.268 2.814.952.672 2.044 1.008 3.276 1.008Z"
        fill="#333"
      />
      <path
        d="M141.075 43.6V20.206c0-2.184.504-3.822 1.512-4.914 1.036-1.12 2.604-1.68 4.704-1.68.56 0 1.19.098 1.89.294.7.196 1.442.476 2.226.84l-1.26 2.646a25.531 25.531 0 0 0-1.638-.588c-.448-.14-.826-.21-1.134-.21-.98 0-1.722.322-2.226.966-.476.616-.714 1.582-.714 2.898V43.6h-3.36Zm-3.864-18.102V22.6h13.314v2.898h-13.314Zm24.747 18.606c-2.044 0-3.864-.462-5.46-1.386-1.568-.952-2.8-2.254-3.696-3.906-.896-1.652-1.344-3.556-1.344-5.712 0-2.156.434-4.06 1.302-5.712.896-1.652 2.128-2.94 3.696-3.864 1.596-.952 3.402-1.428 5.418-1.428 2.072 0 3.892.476 5.46 1.428a9.452 9.452 0 0 1 3.696 3.864c.896 1.652 1.344 3.556 1.344 5.712 0 2.156-.448 4.06-1.344 5.712-.868 1.652-2.086 2.954-3.654 3.906-1.568.924-3.374 1.386-5.418 1.386Zm0-3.108c1.4 0 2.618-.336 3.654-1.008 1.036-.672 1.848-1.596 2.436-2.772.616-1.176.924-2.548.924-4.116 0-1.568-.308-2.94-.924-4.116-.588-1.176-1.414-2.1-2.478-2.772-1.064-.672-2.296-1.008-3.696-1.008-1.372 0-2.59.336-3.654 1.008-1.036.672-1.862 1.596-2.478 2.772-.588 1.176-.882 2.548-.882 4.116 0 1.54.294 2.912.882 4.116.616 1.176 1.456 2.1 2.52 2.772 1.092.672 2.324 1.008 3.696 1.008Zm15.25-8.778c0-2.268.434-4.102 1.302-5.502.868-1.428 1.974-2.478 3.318-3.15a9.395 9.395 0 0 1 4.326-1.05v3.15c-1.232 0-2.422.21-3.57.63a5.966 5.966 0 0 0-2.772 1.974c-.728.924-1.092 2.184-1.092 3.78l-1.512.168ZM175.36 43.6v-21h3.36v21h-3.36Zm21.877.504c-2.072 0-3.906-.462-5.502-1.386a10.03 10.03 0 0 1-3.738-3.906c-.896-1.652-1.344-3.556-1.344-5.712 0-2.156.434-4.06 1.302-5.712.896-1.652 2.142-2.94 3.738-3.864 1.596-.952 3.416-1.428 5.46-1.428 2.016 0 3.822.462 5.418 1.386 1.596.924 2.814 2.226 3.654 3.906l-3.066 1.386a6.083 6.083 0 0 0-2.436-2.604c-1.064-.644-2.282-.966-3.654-.966-1.372 0-2.59.336-3.654 1.008-1.036.672-1.862 1.61-2.478 2.814-.588 1.176-.882 2.534-.882 4.074s.294 2.912.882 4.116c.616 1.176 1.456 2.1 2.52 2.772 1.092.672 2.324 1.008 3.696 1.008 1.372 0 2.59-.35 3.654-1.05 1.092-.7 1.918-1.68 2.478-2.94l3.066 1.386c-.84 1.792-2.058 3.192-3.654 4.2s-3.416 1.512-5.46 1.512Zm20.875 0c-2.044 0-3.85-.462-5.418-1.386-1.568-.952-2.8-2.254-3.696-3.906-.868-1.652-1.302-3.556-1.302-5.712 0-2.156.434-4.06 1.302-5.712.896-1.652 2.114-2.94 3.654-3.864 1.568-.952 3.36-1.428 5.376-1.428 1.932 0 3.612.49 5.04 1.47 1.456.952 2.576 2.296 3.36 4.032.784 1.736 1.176 3.78 1.176 6.132h-3.36c0-1.792-.238-3.318-.714-4.578-.476-1.288-1.19-2.282-2.142-2.982-.924-.7-2.058-1.05-3.402-1.05-1.372 0-2.59.336-3.654 1.008-1.036.644-1.834 1.568-2.394 2.772-.56 1.204-.84 2.618-.84 4.242 0 1.596.308 2.982.924 4.158a7.07 7.07 0 0 0 2.562 2.73c1.092.644 2.324.966 3.696.966 1.456 0 2.688-.35 3.696-1.05a7.525 7.525 0 0 0 2.394-2.73l2.94 1.47a9.338 9.338 0 0 1-2.142 2.856c-.868.812-1.904 1.442-3.108 1.89-1.176.448-2.492.672-3.948.672Zm-8.19-10.374.042-2.898h15.582v2.898h-15.624Z"
        fill="#009F2B"
      />
    </svg>
  );
}

export function LogoIcon(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 25 25" fill="none" {...props}>
      <path d="m14.265 7.964 5.777 3.45v8.35l-5.778 3.391V7.964Z" fill="#009F2B" />
      <path d="M11.617 23.697V9.723l2.65-1.747 2.9 1.719V5.781L9.653 1.302v21.321l1.963 1.074Z" fill="#333" />
      <path d="m7.177 13.751-2.22-1.4v7.357l2.22 1.4v-7.357Z" fill="#009F2B" />
    </svg>
  );
}

export function LogoPropone(props) {
  return (
    <svg 
      width={props.width || props.size || '849'} 
      height={props.height || props.size || '148'} 
      viewBox="0 0 849 148" 
      xmlns="http://www.w3.org/2000/svg" 
      {...props}
    >
      <g clipPath="url(#logo-propone__a)">
        <path 
          d="M172.35 27.13v18.72h.32c25.78-40.24 88.09-19 87.2 27.68.85 46.54-61.69 67.79-87.2 27.52h-.32v46.08h-10.88v-120h10.88Zm0 46.4c1.46 50.51 74.89 50.66 76.32 0-1.33-50.94-74.89-50.65-76.32 0Zm141.76-49.12v11.84c-14.21.41-26.84 12-27.36 26.4v57.12h-10.88V27.13h10.88v14.72h.32c5.59-9.55 15.93-16.62 27.04-17.44Zm51.68 87.52c50.17-1.18 50.19-75.8 0-77-50.27 1.59-50.1 75.4 0 77Zm0 10.56c-65.19-2.17-65-95.78 0-98.08 65.1 2.21 65.08 95.87 0 98.08ZM442 27.13v18.72h.32c25.78-40.24 88.09-19 87.2 27.68.85 46.54-61.69 67.79-87.2 27.52H442v46.08h-10.93v-120H442Zm0 46.4c1.46 50.51 74.89 50.66 76.32 0-1.33-50.94-74.89-50.65-76.32 0ZM24 54.77c-.07-15.69-23.93-15.7-24 0v37a11.999 11.999 0 1 0 24 0v-37Z" 
          fill="#171717"
        />
        <path 
          d="M590.55 111.93c50.28-1.45 50.3-75.53 0-77-50.39 1.87-50.21 75.12 0 77Zm0 10.56c-36.46.63-61.45-40.56-43.28-72.4 19.33-35.87 73.19-33.26 88.73 4.48 14.23 30.9-11.66 68.91-45.44 67.92h-.01Zm65.28-2.72V27.13h10.88v15.68h.29c10.46-19.17 39.27-24.46 56-10.48 8.28 7.12 12.18 18.28 11.92 29v58.4H724V61.37c.22-15.3-10.68-26.64-26.08-26.4-15.08 0-30.52 12.06-31.2 27.68v57.12h-10.89Zm192.8-46.4-.48 5.44h-85.92c5.11 35.25 50.89 45.25 69.6 14.56h12.32c-21.85 48.15-92.6 32.46-93.28-20 2.85-64.88 94.91-64.82 97.76 0Zm-86.4-5.44h75c-7.02-43.56-68.01-43.65-75 0ZM64 11.77c-.06-15.66-23.93-15.77-24 0v123c.06 15.65 23.93 15.72 24 0v-123Zm40 31c-.07-15.68-23.93-15.71-24 0v61c.07 15.67 23.93 15.7 24 0v-61Z" 
          fill="#009F2B"
        />
      </g>
      <defs>
        <clipPath id="logo-propone__a">
          <path fill="#fff" d="M0 0h848.63v147.13H0z"/>
        </clipPath>
      </defs>
    </svg>
  );
}

export function IconGo(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 24 24" {...props}>
      <path
        d="M11.953 11.412v5.36h-1.57l-.112-1.334c-1.213 1.83-3.944 1.915-5.753.903a5.614 5.614 0 005.23-3.123H6.902v-1.811l5.051.005z"
        fill="#0186FE"
      />
      <path
        d="M3.461 15.591a4.697 4.697 0 01-1.43-3.444 4.96 4.96 0 015.097-5.133 5.064 5.064 0 013 .934 4.265 4.265 0 011.713 2.629h-2.18A2.373 2.373 0 007.155 8.95a2.965 2.965 0 00-2.208.862 3.162 3.162 0 00-.85 2.32 2.923 2.923 0 00.82 2.091c.5.506 1.172.806 1.882.84a6.35 6.35 0 01-2.31.502l-1.028.032v-.007zm13.934-1.14a2.485 2.485 0 001.927-.825 2.82 2.82 0 00.778-2 2.849 2.849 0 00-.778-2 2.484 2.484 0 00-1.927-.827 2.536 2.536 0 00-1.926.826 2.971 2.971 0 000 4 2.535 2.535 0 001.926.826zm-3.257-6.069a4.61 4.61 0 11-1.334 3.241 4.432 4.432 0 011.334-3.24z"
        fill="#111"
      />
    </svg>
  );
}

export function IconDoubleArrowRight(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 24 24" {...props}>
      <path
        d="M12.612 11.834l-5.18-5.18a.235.235 0 00-.167-.069H3.027a.235.235 0 00-.167.4l5.017 5.016-5.014 5.013a.235.235 0 00.167.4h4.238a.237.237 0 00.167-.069l5.18-5.18a.236.236 0 00.051-.257.235.235 0 00-.051-.076l-.003.002z"
        fill="currentColor"
      />
      <path
        d="M21.14 11.834l-5.18-5.18a.235.235 0 00-.167-.069h-4.238a.235.235 0 00-.167.4l5.017 5.016-5.014 5.013a.235.235 0 00.167.4h4.238a.237.237 0 00.167-.069l5.18-5.18a.233.233 0 00.051-.257.232.232 0 00-.051-.076l-.003.002z"
        fill="currentColor"
      />
    </svg>
  );
}

export function IconDoubleArrowDown(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 17 17" fill="none" {...props}>
      <path
        d="m9.068 8.562 4.263-3.477a.16.16 0 0 0 .042-.051c.01-.02.015-.04.015-.06V2.128a.137.137 0 0 0-.033-.088.19.19 0 0 0-.086-.058.234.234 0 0 0-.111-.009.21.21 0 0 0-.1.043L8.932 5.384 4.806 2.02a.21.21 0 0 0-.1-.043.234.234 0 0 0-.11.01.19.19 0 0 0-.087.057.138.138 0 0 0-.032.088v2.844c0 .021.005.042.014.061a.16.16 0 0 0 .042.051l4.263 3.477a.2.2 0 0 0 .063.035.232.232 0 0 0 .211-.035l-.002-.002Z"
        fill="#9D9D9D"
      />
      <path
        d="m9.068 14.286 4.263-3.476a.16.16 0 0 0 .042-.052c.01-.02.015-.04.015-.06V7.852a.137.137 0 0 0-.033-.087.19.19 0 0 0-.086-.059.234.234 0 0 0-.111-.009.21.21 0 0 0-.1.043l-4.127 3.367-4.125-3.365a.21.21 0 0 0-.1-.043.234.234 0 0 0-.11.01.19.19 0 0 0-.087.058.138.138 0 0 0-.032.087V10.7c0 .02.005.04.014.06a.16.16 0 0 0 .042.052l4.263 3.477a.23.23 0 0 0 .274 0l-.002-.003Z"
        fill="#9D9D9D"
      />
    </svg>
  );
}

export function IconSync(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 24 24" {...props}>
      <path
        d="M3.416 13h.039a.464.464 0 00.287-.1.42.42 0 00.153-.25 3.995 3.995 0 011.363-2.41 4.42 4.42 0 012.67-1.045h7.26v1.685a.41.41 0 00.072.231.44.44 0 00.194.156.47.47 0 00.481-.074l4.919-4.229A.425.425 0 0021 6.651a.404.404 0 00-.146-.313l-4.92-4.228a.47.47 0 00-.481-.074.441.441 0 00-.194.156.407.407 0 00-.073.23v2.116H7.925a4.94 4.94 0 00-3.37 1.17A4.425 4.425 0 003 8.767v3.805a.41.41 0 00.118.292c.077.08.184.128.298.136zm17.168-2h-.038a.464.464 0 00-.288.1.42.42 0 00-.153.25 3.995 3.995 0 01-1.363 2.41 4.42 4.42 0 01-2.67 1.045h-7.26V13.12a.406.406 0 00-.072-.231.44.44 0 00-.194-.156.47.47 0 00-.481.074l-4.919 4.229a.425.425 0 00-.146.313.404.404 0 00.146.313l4.92 4.228a.47.47 0 00.481.074.442.442 0 00.194-.156.406.406 0 00.073-.23v-2.116h7.261a4.94 4.94 0 003.37-1.17A4.425 4.425 0 0021 15.233v-3.805a.41.41 0 00-.118-.292.457.457 0 00-.298-.136z"
        fill="#009F2B"
      />
    </svg>
  );
}

export function IconSortAsc(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 24 24" {...props}>
      <path
        d="M16.117 13.268a1.17 1.17 0 102.339 0V7.986l1.512 1.512a1.168 1.168 0 001.65-1.65L18.11 4.341a1.169 1.169 0 00-1.65 0l-3.509 3.51a1.169 1.169 0 001.65 1.65l1.515-1.515v5.282zM3.17 20.369a1.17 1.17 0 010-2.339h12.86a1.17 1.17 0 110 2.339H3.17zm0-4.677a1.17 1.17 0 010-2.339h8.183a1.17 1.17 0 110 2.339H3.17zm0-4.677a1.17 1.17 0 010-2.339h4.68a1.17 1.17 0 110 2.339H3.17z"
        fill="#009F2B"
      />
    </svg>
  );
}

export function IconSortDesc(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 24 24" {...props}>
      <path
        d="M18.456 11.101a1.17 1.17 0 00-2.339 0v5.281l-1.512-1.512a1.168 1.168 0 00-1.65 1.65l3.507 3.508a1.168 1.168 0 001.65 0l3.509-3.51a1.168 1.168 0 00-1.65-1.65l-1.515 1.514v-5.281zM3.17 4a1.17 1.17 0 100 2.338h12.86a1.169 1.169 0 100-2.338H3.17zm0 4.677a1.17 1.17 0 100 2.338h8.183a1.169 1.169 0 100-2.338H3.17zm0 4.677a1.17 1.17 0 000 2.339h4.68a1.17 1.17 0 000-2.339H3.17z"
        fill="currentColor"
      />
    </svg>
  );
}

export function IconCallIncoming(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 24 24" {...props}>
      <path
        d="M14.098 9.46a.797.797 0 00.735.488h4.94a.8.8 0 100-1.6h-3.006l4.395-4.395a.8.8 0 00-1.131-1.131l-4.396 4.395V4.21a.8.8 0 10-1.6 0v4.938c0 .11.023.216.063.311z"
        fill="#0186FE"
      />
      <path
        d="M19.773 16.49v2.47a1.645 1.645 0 01-1.794 1.645 16.286 16.286 0 01-7.104-2.527 16.05 16.05 0 01-4.938-4.938 16.286 16.286 0 01-2.526-7.136A1.646 1.646 0 015.05 4.21h2.469a1.646 1.646 0 011.646 1.416c.104.791.297 1.567.576 2.315a1.646 1.646 0 01-.37 1.736l-1.045 1.048a13.168 13.168 0 004.938 4.938l1.044-1.045a1.646 1.646 0 011.737-.37c.747.278 1.524.471 2.314.575a1.646 1.646 0 011.415 1.667z"
        fill="#c3c3c3"
      />
    </svg>
  );
}

export function IconCallOutgoing(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 24 24" {...props}>
      <path
        d="M21.298 3.077a.797.797 0 00-.735-.49h-4.94a.8.8 0 100 1.6h3.007l-4.396 4.396a.8.8 0 001.132 1.131L19.76 5.32v3.007a.8.8 0 101.6 0V3.388a.798.798 0 00-.063-.311z"
        fill="#009F2B"
      />
      <path
        d="M19.77 16.49v2.467a1.647 1.647 0 01-1.793 1.645 16.286 16.286 0 01-7.1-2.526A16.044 16.044 0 015.94 13.14a16.286 16.286 0 01-2.526-7.132 1.646 1.646 0 011.637-1.794H7.52a1.646 1.646 0 011.645 1.415c.104.79.298 1.567.576 2.314a1.646 1.646 0 01-.37 1.736l-1.046 1.043a13.164 13.164 0 004.937 4.936l1.045-1.045a1.646 1.646 0 011.736-.37c.747.278 1.524.471 2.314.575a1.646 1.646 0 011.414 1.672z"
        fill="#c3c3c3"
      />
    </svg>
  );
}

export function IconCallLogs(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 24 24" {...props}>
      <path
        d="M18.77 17.673v2.467a1.647 1.647 0 01-1.793 1.645 16.286 16.286 0 01-7.1-2.526 16.044 16.044 0 01-4.937-4.936 16.286 16.286 0 01-2.526-7.132 1.646 1.646 0 011.637-1.794H6.52a1.646 1.646 0 011.645 1.415c.104.79.298 1.567.576 2.314a1.646 1.646 0 01-.37 1.736l-1.046 1.043a13.164 13.164 0 004.937 4.936l1.045-1.045a1.646 1.646 0 011.736-.37c.747.278 1.524.471 2.314.575a1.646 1.646 0 011.414 1.672zM18.174 2h-6.869a1.643 1.643 0 00-1.644 1.674v2.851a.627.627 0 101.253 0V3.674a.42.42 0 01.391-.421h6.869a.491.491 0 01.466.421v11.145a.63.63 0 00.627.652.627.627 0 00.626-.652V3.674A1.707 1.707 0 0018.174 2z"
        fill="currentColor"
      />
      <path
        d="M12.99 5.968h3.369a.736.736 0 000-1.462H12.99a.736.736 0 000 1.462zm0 2.714h3.369a.627.627 0 100-1.253H12.99a.627.627 0 100 1.253zm0 2.924h3.369a.626.626 0 00.46-1.079.628.628 0 00-.46-.174H12.99a.63.63 0 00-.652.627.627.627 0 00.652.626z"
        fill="currentColor"
      />
    </svg>
  );
}
// icon added for crm info
export function IconCrmInfo(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size || '1em'}
      height={props.size || '1em'}
      viewBox="0 0 20 21"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        d="M16.333 16.5H3.667A1.669 1.669 0 0 1 2 14.833V6.167A1.67 1.67 0 0 1 3.667 4.5h12.666A1.67 1.67 0 0 1 18 6.167v8.666a1.67 1.67 0 0 1-1.667 1.667ZM3.667 5.167a1 1 0 0 0-1 1v8.666a1 1 0 0 0 1 1h12.666a1 1 0 0 0 1-1V6.167a1 1 0 0 0-1-1H3.667Z"
      />
      <path
        fill="currentColor"
        d="M7 10.5a1.669 1.669 0 0 1-1.667-1.667c0-.918.748-1.666 1.667-1.666s1.667.748 1.667 1.666A1.67 1.67 0 0 1 7 10.5Zm0-2.667a1.001 1.001 0 0 0 0 2 1.001 1.001 0 0 0 0-2Zm2.667 6a.334.334 0 0 1-.334-.333v-.667c0-.551-.448-1-1-1H5.667c-.552 0-1 .449-1 1v.667a.334.334 0 0 1-.667 0v-.667c0-.918.748-1.666 1.667-1.666h2.666c.919 0 1.667.748 1.667 1.666v.667c0 .184-.15.333-.333.333Zm6-5.333h-4a.333.333 0 0 1 0-.667h4a.334.334 0 0 1 0 .667Zm0 2.667h-4a.333.333 0 0 1 0-.667h4a.333.333 0 0 1 0 .667Zm0 2.666h-4a.333.333 0 0 1 0-.666h4a.333.333 0 0 1 0 .666Z"
      />
    </svg>
  );
}
export function IconCommissionAffiliate(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size || '1em'}
      height={props.size || '1em'}
      viewBox="0 0 20 21"
      fill="none"
      {...props}
    >
      <mask
        id="a"
        width={16}
        height={17}
        x={2}
        y={2}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path fill="#fff" d="M2 2.5h16v16H2v-16Z" />
      </mask>
      <g mask="url(#a)">
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
          strokeWidth={0.9}
          d="M17.531 7.563a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z"
        />
        <path
          stroke="currentColor"
          d="M13.078 6.156a.469.469 0 1 1-.937 0 .469.469 0 0 1 .937 0Zm2.344 2.813a.469.469 0 1 1-.938 0 .469.469 0 0 1 .938 0Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
          strokeWidth={0.9}
          d="m12.61 8.969 2.343-2.813m-3.487 8.447a.937.937 0 0 0 .593-1.778l-4.073-1.348c-.868-.29-2.524-.345-3.642.773m0 0H2.469v4.688h1.875V12.25Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
          strokeWidth={0.9}
          d="m4.344 16 4.25.966c.636.145 1.318.23 1.97.222a8.27 8.27 0 0 0 4.702-1.552l1.873-1.387a.937.937 0 1 0-1.09-1.526l-2.04 1.507a2.812 2.812 0 0 1-2.524.38l-2.891-.954"
        />
      </g>
    </svg>
  );
}
export function IconAffiliateVerification(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size || '1em'}
      height={props.size || '1em'}
      viewBox="0 0 20 21"
      fill="none"
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        d="M10 3.464 4.64 5.689v2.705c0 3.5 2.119 6.653 5.36 7.976a8.615 8.615 0 0 0 5.36-7.976V5.689L10 3.464Z"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        d="m7.867 9.482 1.529 1.529 2.737-2.738"
      />
    </svg>
  );
}
export function IconUnauthorizeAffiliate(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size || '1em'}
      height={props.size || '1em'}
      viewBox="0 0 20 21"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9.9 2.813a.25.25 0 0 0-.25.25v4c0 .138.112.25.25.25.868 0 1.684.338 2.298.952a.25.25 0 0 0 .353 0l2.829-2.829a.25.25 0 0 0 0-.354 7.7 7.7 0 0 0-5.48-2.27Zm2.469 4.927a3.717 3.717 0 0 0-2.22-.92V3.317a7.199 7.199 0 0 1 4.698 1.945L12.369 7.74Zm-5.22 2.822a2.753 2.753 0 0 0 2.75 2.75 2.753 2.753 0 0 0 2.75-2.75 2.753 2.753 0 0 0-2.75-2.75 2.753 2.753 0 0 0-2.75 2.75Zm2.75-2.25c1.241 0 2.25 1.01 2.25 2.25a2.252 2.252 0 0 1-2.25 2.25 2.253 2.253 0 0 1-2.25-2.25c0-1.24 1.01-2.25 2.25-2.25Zm-1.175-4.65a.249.249 0 0 1 .29.22l.342 3.245a.25.25 0 0 1-.192.27 3.234 3.234 0 0 0-2.513 3.166c0 .868.337 1.683.95 2.297a.252.252 0 0 1 .002.355l-2.298 2.298a.25.25 0 0 1-.354 0 6.955 6.955 0 0 1-2.05-4.95 6.977 6.977 0 0 1 5.823-6.901Zm-1.646 9.37a3.722 3.722 0 0 1-.927-2.469c0-1.68 1.094-3.13 2.686-3.597l-.291-2.761A6.478 6.478 0 0 0 3.4 10.562c0 1.653.613 3.212 1.73 4.416l1.947-1.947Zm8.603-6.418-.036-.052a.251.251 0 0 0-.366-.047l-2.5 2.122a.25.25 0 0 0-.055.315c.28.488.427 1.045.427 1.612 0 .868-.338 1.684-.952 2.298a.25.25 0 0 0 0 .353l2.298 2.298a.25.25 0 0 0 .353 0 6.953 6.953 0 0 0 2.05-4.95 6.962 6.962 0 0 0-1.22-3.95Zm-1.01 8.366-1.947-1.947a3.75 3.75 0 0 0 .532-4.145l2.132-1.81a6.462 6.462 0 0 1 1.013 3.486 6.455 6.455 0 0 1-1.73 4.416Zm-.537 2.077A7.72 7.72 0 0 1 9.9 18.312a7.719 7.719 0 0 1-4.231-1.256.251.251 0 0 1-.066-.355l2.344-3.253a.25.25 0 0 1 .328-.07c.989.572 2.28.568 3.265-.009a.25.25 0 0 1 .33.07l2.33 3.262a.25.25 0 0 1-.067.355ZM7.15 15.409v1.86c.165.068.331.129.5.184v-2.738l-.5.694Zm3.5-1.182a3.837 3.837 0 0 1-.5.065v3.512c.168-.006.334-.017.5-.034v-3.543Zm-1.5 3.543c.166.017.333.028.5.034v-3.512a3.802 3.802 0 0 1-.5-.064v3.542Zm3-3.077v2.76c.169-.055.336-.116.5-.183v-1.877l-.5-.7Zm1 1.4v.95a7.24 7.24 0 0 0 .488-.267l-.488-.683Zm-1.5-2.1-.059-.083c-.142.072-.29.132-.44.185V17.7a7.18 7.18 0 0 0 .5-.105v-3.603Zm-3 .103a3.603 3.603 0 0 1-.425-.178l-.075.104v3.574c.165.04.332.076.5.105v-3.605Zm-2 2.947v-.94l-.486.674c.159.096.321.183.486.266Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export function IconTaskList(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        d="M3 6a1 1 0 011-1h5a1 1 0 011 1v5a1 1 0 01-1 1H4a1 1 0 01-1-1V6zm1.5 4.5v-4h4v4h-4z"
        fill="currentColor"
      />
      <path
        d="M12.75 5.5a.75.75 0 100 1.5h7.5a.75.75 0 100-1.5h-7.5zm0 6a.75.75 0 100 1.5h7.5a.75.75 0 100-1.5h-7.5zm0 6a.75.75 0 100 1.5h7.5a.75.75 0 100-1.5h-7.5zm-2.97-2.53a.75.75 0 010 1.06l-3.5 3.5a.75.75 0 01-1.06 0l-2-2a.75.75 0 111.06-1.06l1.47 1.47 2.97-2.97a.75.75 0 011.06 0z"
        fill="currentColor"
      />
    </svg>
  );
}

// Icons for Property Types
//

export function IconZameen(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M4 9l16-2v15H4V9z" fill="#fff" />
      <path
        d="M21.29 8.64V4.938h-5.194L12.002 2 1 9.899v5.24L3 14v8h3.431c-.212-.57-.185-.976.145-1.543l4.31-7.526-3.972.987a1.947 1.947 0 11-.944-3.779l8.417-2.09.069-.018.037-.01c.052-.012.103-.013.155-.021.063-.01.124-.024.188-.027.12-.009.238-.004.355.01.013.001.026 0 .04.002.088.012.172.035.257.059.182.047.362.11.533.209a2.107 2.107 0 01.768 2.885l-4.114 7.184 4.41-1.126a1.947 1.947 0 11.944 3.779L13.042 22h7.957L21 14l2 1.138v-5.24L21.29 8.64z"
        style={{ fill: '#00A651' }}
      />
    </svg>
  );
}

export function IconOLX(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 568 326" {...props}>
      <path
        d="M373.01 325.02h-77V.49h77v324.53zM268.25 162.76a133.73 133.73 0 11-267.46 0 133.73 133.73 0 01267.46 0zm-93.21 0a40.529 40.529 0 00-69.192-28.655A40.526 40.526 0 00112 196.464a40.527 40.527 0 0022.52 6.826 40.521 40.521 0 0040.52-40.53zm392.73-81.27h-51.2l-30 30-30-30h-51.2v52l29.59 29.59-29.59 29.6v51.29h51.86l29.31-29.31 29.31 29.31h51.92v-51.25l-29.6-29.6 29.6-29.63v-52z"
        style={{ fill: '#3A77FF' }}
      />
    </svg>
  );
}

export function LogoZameen(props) {
  return (
    <svg width={135} height={27} viewBox="0 0 135 27" {...props}>
      <path
        d="M132.2 16.7v-5.1c0-1.4-.4-2.1-1.4-2.1-.7 0-1.1.5-1.3 1-.1.2-.1.5-.1.7v5.5h-2.8v-5.2c0-1.2-.4-2-1.3-2-.7 0-1.2.6-1.4 1.1-.1.2-.1.5-.1.7v5.4H121v-6.4c0-1.2 0-2.2-.1-3h2.4l.1 1.3h.1c.4-.6 1.2-1.5 2.8-1.5 1.2 0 2.2.6 2.6 1.6.3-.5.8-.9 1.2-1.1.5-.3 1.1-.5 1.8-.5 1.8 0 3.2 1.3 3.2 4v5.5h-2.9zm-18-7.5c-1.4 0-1.9 1.4-1.9 2.8 0 1.6.7 2.8 1.9 2.8 1.1 0 1.9-1.1 1.9-2.8 0-1.4-.6-2.8-1.9-2.8zm0 7.7c-2.7 0-4.8-1.8-4.8-4.8s2-4.9 5-4.9c2.9 0 4.8 2 4.8 4.8-.1 3.4-2.5 4.9-5 4.9zm-6.4-7.2c-.3-.2-.9-.3-1.6-.3-1.5 0-2.5 1.1-2.5 2.6 0 1.7 1.1 2.6 2.6 2.6.7 0 1.2-.1 1.7-.3l.3 2.1c-.5.2-1.5.4-2.6.4-3 0-4.9-1.8-4.9-4.8 0-2.7 1.9-5 5.3-5 .8 0 1.6.1 2.2.4l-.5 2.3zm-10 7.2c-1 0-1.7-.7-1.7-1.8 0-1 .7-1.8 1.7-1.8s1.7.7 1.7 1.8-.7 1.8-1.7 1.8zm-6.7-.2v-5.2c0-1.2-.4-2-1.5-2-.8 0-1.3.6-1.5 1.1-.1.2-.1.5-.1.7v5.4h-2.9v-6.4c0-1.2 0-2.2-.1-3h2.5l.1 1.3h.1c.4-.6 1.3-1.5 2.9-1.5 1.9 0 3.3 1.3 3.3 4v5.5h-2.8zM79 9.1c-1.2 0-1.7 1.1-1.8 1.9h3.4c.1-.7-.2-1.9-1.6-1.9zm4.3 3.9h-6c.1 1.2 1.3 1.8 2.6 1.8 1 0 1.8-.1 2.6-.4l.4 2c-1 .4-2.1.6-3.4.6-3.2 0-5-1.8-5-4.8 0-2.4 1.5-5 4.7-5 3 0 4.2 2.3 4.2 4.7 0 .4-.1.9-.1 1.1zM68.9 9.1c-1.2 0-1.7 1.1-1.8 1.9h3.4c.1-.7-.2-1.9-1.6-1.9zm4.3 3.9h-6c.1 1.2 1.3 1.8 2.6 1.8 1 0 1.8-.1 2.6-.4l.4 2c-1 .4-2.1.6-3.4.6-3.2 0-5-1.8-5-4.8 0-2.4 1.5-5 4.7-5 3 0 4.2 2.3 4.2 4.7 0 .4-.1.9-.1 1.1zm-13.4 3.7v-5.1c0-1.4-.4-2.1-1.4-2.1-.7 0-1.1.5-1.3 1-.1.2-.1.5-.1.8v5.5h-2.8v-5.2c0-1.2-.4-2-1.3-2-.7 0-1.2.6-1.4 1.1-.1.2-.1.5-.1.7v5.4h-2.8v-6.4c0-1.2 0-2.2-.1-3h2.4l.1 1.2h.1c.4-.6 1.2-1.5 2.8-1.5 1.2 0 2.2.6 2.6 1.6.3-.5.8-.9 1.2-1.1.5-.3 1.1-.5 1.8-.5 1.8 0 3.2 1.3 3.2 4v5.5h-2.9zm-16.4-4.4c-1.5 0-2.7.3-2.7 1.5 0 .7.5 1.1 1.1 1.1.7 0 1.3-.5 1.5-1.1 0-.2.1-.3.1-.5v-1zm.3 4.4l-.2-.9h-.1c-.6.7-1.6 1.1-2.7 1.1-1.9 0-3-1.4-3-2.9 0-2.4 2.2-3.6 5.5-3.6v-.1c0-.5-.3-1.2-1.7-1.2-1 0-2 .3-2.6.7L38.5 8c.6-.4 1.9-.8 3.6-.8 3.1 0 4.1 1.8 4.1 4v3.2c0 .9 0 1.8.1 2.3h-2.6zm-6.9-2.3v2.3h-8.1V15l2.9-3.7c.5-.6 1-1.1 1.5-1.7H29V7.4h7.6v1.7l-2.8 3.5c-.5.6-1 1.2-1.5 1.7h4.5z"
        style={{ fill: '#231f20' }}
      />
      <path
        d="M135 25.1h-1v-4.3h1v4.3zm-1.1-5v-.9h1.1v.9h-1.1zm-2.1 3.2c-.3-.1-.6-.2-1-.2-.6 0-1 .3-1 .7 0 .4.4.6.8.6.7 0 1.1-.4 1.1-.9v-.2zm0 1.8v-.5c-.3.4-.7.6-1.4.6-.8 0-1.5-.5-1.5-1.3 0-.9.7-1.4 1.8-1.4.5 0 .9.1 1.2.2v-.1c0-.6-.4-.9-1.1-.9-.5 0-.8.1-1.2.3l-.3-.8c.5-.2.9-.4 1.6-.4 1.3 0 1.9.7 1.9 1.8v2.6h-1zm-5 0v-2.4H124v2.4h-1v-5.7h1v2.4h2.7v-2.4h1v5.7h-.9zm-8.5-1.8c-.3-.1-.6-.2-1-.2-.6 0-1 .3-1 .7 0 .4.4.6.8.6.7 0 1.1-.4 1.1-.9v-.2zm0 1.8v-.5c-.3.4-.7.6-1.4.6-.8 0-1.5-.5-1.5-1.3 0-.9.7-1.4 1.8-1.4.5 0 .9.1 1.2.2v-.1c0-.6-.4-.9-1.1-.9-.5 0-.8.1-1.2.3l-.3-.8c.5-.2.9-.4 1.6-.4 1.3 0 1.9.7 1.9 1.8v2.6h-1zm-4.8-3.5v2.1c0 .4.2.5.5.5.2 0 .4 0 .6-.1v.9a2 2 0 0 1-.9.2c-.7 0-1.2-.3-1.2-1.3v-2.3h-.5v-.9h.5v-1.2h1v1.2h1.2v.9h-1.2zm-3.3 1.7c-.3-.1-.6-.2-1-.2-.6 0-1 .3-1 .7 0 .4.4.6.8.6.7 0 1.1-.4 1.1-.9v-.2zm0 1.8v-.5c-.3.4-.7.6-1.4.6-.8 0-1.5-.5-1.5-1.3 0-.9.7-1.4 1.8-1.4.5 0 .9.1 1.2.2v-.1c0-.6-.4-.9-1.1-.9-.5 0-.8.1-1.2.3l-.3-.8c.5-.2.9-.4 1.6-.4 1.3 0 1.9.7 1.9 1.8v2.6h-1zm-5.8-4.8h-1.2v2.1h1.2c.8 0 1.2-.4 1.2-1 .1-.8-.4-1.1-1.2-1.1zm0 3h-1.1v1.8h-1v-5.7h2.3c1.3 0 2.2.8 2.2 1.9-.1 1.3-1.1 2-2.4 2zm-6.9 1.8v-2.5c0-.7-.3-1.1-.9-1.1-.6 0-1 .4-1 1.1V25h-1v-4.3h1v.7c.3-.4.7-.8 1.4-.8 1 0 1.5.7 1.5 1.7v2.8h-1zm-4.2 0h-1v-4.3h1v4.3zm-1-5v-.9h1.1v.9h-1.1zm-2.2 3.2c-.3-.1-.6-.2-1-.2-.6 0-1 .3-1 .7 0 .4.4.6.8.6.7 0 1.1-.4 1.1-.9v-.2zm0 1.8v-.5c-.3.4-.7.6-1.4.6-.8 0-1.5-.5-1.5-1.3 0-.9.7-1.4 1.8-1.4.5 0 .9.1 1.2.2v-.1c0-.6-.4-.9-1.1-.9-.5 0-.8.1-1.2.3l-.3-.8c.5-.2.9-.4 1.6-.4 1.3 0 1.9.7 1.9 1.8v2.6h-1zm-4.8 0v-2.5c0-.7-.3-1.1-.9-1.1-.5 0-.9.4-.9 1.1V25h-1v-2.5c0-.7-.3-1-.9-1s-.9.4-.9 1.1V25h-1v-4.3h1v.7c.3-.4.7-.7 1.3-.7.6 0 1.1.3 1.3.8.4-.5.8-.8 1.5-.8.9 0 1.5.6 1.5 1.7v2.8h-1zm-7.8 0v-.7c-.3.4-.7.8-1.4.8-1 0-1.5-.7-1.5-1.7v-2.8h1v2.5c0 .7.3 1.1.9 1.1.6 0 1-.4 1-1.1v-2.4h1v4.3h-1zm-5.2 0v-2.4h-2.7v2.4h-1v-5.7h1v2.4h2.7v-2.4h1v5.7h-1zm-8.8 1.2l-.1-.4c.5-.1.7-.4.7-.8h-.4V24h1.1v1c0 .8-.4 1.2-1.3 1.3zm-1.9-3c-.3-.1-.6-.2-1-.2-.6 0-1 .3-1 .7 0 .4.4.6.8.6.7 0 1.1-.4 1.1-.9v-.2zm0 1.8v-.5c-.3.4-.7.6-1.4.6-.8 0-1.5-.5-1.5-1.3 0-.9.7-1.4 1.8-1.4.5 0 .9.1 1.2.2v-.1c0-.6-.4-.9-1.1-.9-.5 0-.8.1-1.2.3l-.4-.9c.5-.2.9-.4 1.6-.4 1.3 0 1.9.7 1.9 1.8v2.6h-.9zm-4.8-3.5v2.1c0 .4.2.5.5.5.2 0 .4 0 .6-.1v.9a2 2 0 0 1-.9.2c-.7 0-1.2-.3-1.2-1.3v-2.3h-.5v-.9h.5v-1.2h1v1.2H58v.9h-1.2zm-3.3 1.7c-.3-.1-.6-.2-1-.2-.6 0-1 .3-1 .7 0 .4.4.6.8.6.7 0 1.1-.4 1.1-.9v-.2zm0 1.8v-.5c-.3.4-.7.6-1.4.6-.8 0-1.5-.5-1.5-1.3 0-.9.7-1.4 1.8-1.4.5 0 .9.1 1.2.2v-.1c0-.6-.4-.9-1.1-.9-.5 0-.8.1-1.2.3l-.3-.8c.5-.2.9-.4 1.6-.4 1.3 0 1.9.7 1.9 1.8v2.6h-1zm-5.7-4.8h-1.2v2.1h1.2c.8 0 1.2-.4 1.2-1 0-.8-.5-1.1-1.2-1.1zm-.1 3h-1.1v1.8h-1v-5.7h2.3c1.3 0 2.2.8 2.2 1.9-.1 1.3-1.1 2-2.4 2zm-5.6-1.6c-.9 0-1.5.6-1.5 1.7V25h-1v-4.3h1v1c.3-.6.8-1.1 1.5-1.1v1.1zm-4.6 1.6c-.3-.1-.6-.2-1-.2-.6 0-1 .3-1 .7 0 .4.4.6.8.6.7 0 1.1-.4 1.1-.9v-.2zm0 1.8v-.5c-.3.4-.7.6-1.4.6-.8 0-1.5-.5-1.5-1.3 0-.9.7-1.4 1.8-1.4.5 0 .9.1 1.2.2v-.1c0-.6-.4-.9-1.1-.9-.5 0-.8.1-1.2.3l-.3-.8c.5-.2.9-.4 1.6-.4 1.3 0 1.9.7 1.9 1.8v2.6h-1zm-5 0v-2.4h-2.7v2.4h-1v-5.7h1v2.4h2.7v-2.4h1v5.7h-1z"
        style={{ fill: '#f37a20' }}
      />
      <path style={{ fill: '#fff' }} d="M3.7 7.7h18.5v17.4H3.7z" />
      <path
        d="M23.8 8.5V4.2h-6.1L12.9.8 0 10v6.1l2-1.5v10.5h4.4c-.2-.7-.2-1.4.2-2.1l5-8.8-4.7 1.2c-1.2.3-2.5-.4-2.8-1.7-.3-1.2.4-2.5 1.7-2.8l9.9-2.4h.9c.1 0 .2 0 .3.1.2.1.4.1.6.2 1.2.7 1.6 2.2.9 3.4l-4.8 8.4 5.2-1.3c1.2-.3 2.5.4 2.8 1.7.3 1.2-.4 2.5-1.7 2.8l-5.8 1.5h9.7V14.8l2 1.5V10l-2-1.5z"
        style={{ fill: '#00A551' }}
      />
    </svg>
  );
}

export function IconMeeting(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 12 12" {...props}>
      <g clipPath="url(#a1)">
        <path
          d="M9.5 1H9V.5a.5.5 0 1 0-1 0V1H4V.5a.5.5 0 1 0-1 0V1h-.5A2.503 2.503 0 0 0 0 3.5v6C0 10.879 1.121 12 2.5 12h7c1.379 0 2.5-1.121 2.5-2.5v-6C12 2.122 10.879 1 9.5 1Zm-7 1h7c.827 0 1.5.673 1.5 1.5V4H1v-.5C1 2.673 1.673 2 2.5 2Zm7 9h-7C1.673 11 1 10.327 1 9.5V5h10v4.5c0 .827-.673 1.5-1.5 1.5Zm0-4a.5.5 0 0 1-.5.5H3a.5.5 0 1 1 0-1h6a.5.5 0 0 1 .5.5ZM6 9a.5.5 0 0 1-.5.5H3a.5.5 0 1 1 0-1h2.5A.5.5 0 0 1 6 9Z"
          fill="#A7A7A7"
        />
      </g>
      <defs>
        <clipPath id="a1">
          <path fill="#fff" d="M0 0h12v12H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function IconCreateAgenda(props) {
  return (
    <svg width={props.size || '90px'} height={props.size || '82px'} viewBox="0 0 90 82" fill="none" {...props}>
      <g clipPath="url(#abc)">
        <path
          d="m46.092.179-2.928.766-36.08 9.446-2.928.766a5.554 5.554 0 0 0-3.384 2.589 5.703 5.703 0 0 0-.595 4.26l12.698 49.988a5.62 5.62 0 0 0 2.55 3.436 5.473 5.473 0 0 0 4.196.604l.007-.002L61.55 61.058l.008-.002a5.554 5.554 0 0 0 3.385-2.589 5.703 5.703 0 0 0 .595-4.26L52.838 4.22a5.62 5.62 0 0 0-2.55-3.436A5.473 5.473 0 0 0 46.092.18Z"
          fill="#F2F2F2"
        />
        <path
          d="m46.49 1.746-3.468.908-35 9.162-3.468.909a3.955 3.955 0 0 0-2.41 1.843 4.061 4.061 0 0 0-.424 3.033L14.418 67.59a4.003 4.003 0 0 0 1.816 2.447c.9.54 1.975.694 2.988.43l.008-.002 41.92-10.974.008-.002a3.956 3.956 0 0 0 2.41-1.844 4.061 4.061 0 0 0 .424-3.033L51.294 4.623a4.002 4.002 0 0 0-1.816-2.447 3.897 3.897 0 0 0-2.988-.43Z"
          fill="#fff"
        />
        <path
          d="M50.838 45.358 29.63 50.91a.91.91 0 0 1-.699-.1.935.935 0 0 1-.424-.573.949.949 0 0 1 .099-.709.924.924 0 0 1 .563-.431l21.207-5.552a.91.91 0 0 1 .699.1.949.949 0 0 1 .326 1.282.924.924 0 0 1-.564.431Zm4.461 2.096-24.89 6.517a.91.91 0 0 1-.969-.344.941.941 0 0 1-.176-.694.944.944 0 0 1 .36-.617.917.917 0 0 1 .324-.159l24.89-6.516a.91.91 0 0 1 .7.1.949.949 0 0 1 .326 1.282.924.924 0 0 1-.565.431Z"
          fill="#F2F2F2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="m43.871 17.934-21.207 5.551a.91.91 0 0 1-.699-.1.949.949 0 0 1-.326-1.282.924.924 0 0 1 .565-.43L43.41 16.12a.91.91 0 0 1 .699.101c.21.126.363.332.424.572a.949.949 0 0 1-.099.71.924.924 0 0 1-.563.43Zm4.461 2.095-24.89 6.517a.91.91 0 0 1-.7-.1.949.949 0 0 1-.326-1.282.924.924 0 0 1 .565-.432l24.89-6.516a.91.91 0 0 1 .7.1.949.949 0 0 1 .326 1.282.924.924 0 0 1-.565.431ZM26.148 37.2l21.206-5.552a.915.915 0 0 0 .564-.431.943.943 0 0 0-.665-1.403.909.909 0 0 0-.36.02l-21.206 5.552a.916.916 0 0 0-.564.431.944.944 0 0 0 .326 1.282.913.913 0 0 0 .699.1Zm25.668-3.458-24.89 6.517a.909.909 0 0 1-.968-.344.942.942 0 0 1-.058-1.039.93.93 0 0 1 .564-.43l24.891-6.517a.91.91 0 0 1 .699.1.949.949 0 0 1 .326 1.282.924.924 0 0 1-.564.431Zm-40.277-2.598 7.505-1.965a.443.443 0 0 0 .27-.207.455.455 0 0 0 .048-.34l-1.723-6.782a.449.449 0 0 0-.203-.274.437.437 0 0 0-.335-.048L9.596 23.49a.443.443 0 0 0-.27.207.455.455 0 0 0-.048.34L11 30.82a.445.445 0 0 0 .538.323ZM22.527 42.89l-7.505 1.965a.437.437 0 0 1-.335-.049.448.448 0 0 1-.203-.274l-1.723-6.782a.455.455 0 0 1 .048-.34.444.444 0 0 1 .27-.207l7.505-1.964a.437.437 0 0 1 .335.048c.1.06.174.16.203.274l1.723 6.782a.455.455 0 0 1-.047.34.444.444 0 0 1-.27.207Zm-4.021 15.677 7.505-1.965a.444.444 0 0 0 .27-.207.455.455 0 0 0 .047-.34l-1.722-6.782a.45.45 0 0 0-.204-.274.437.437 0 0 0-.335-.048l-7.505 1.964a.444.444 0 0 0-.27.207.455.455 0 0 0-.048.34l1.723 6.782a.441.441 0 0 0 .539.323Z"
          fill="#F2F2F2"
        />
        <path
          d="M75.34 12.85H32.032a5.503 5.503 0 0 0-3.914 1.65 5.672 5.672 0 0 0-1.624 3.973v51.624a5.672 5.672 0 0 0 1.624 3.974 5.503 5.503 0 0 0 3.914 1.648H75.34a5.503 5.503 0 0 0 3.914-1.648 5.672 5.672 0 0 0 1.624-3.974V18.473a5.673 5.673 0 0 0-1.624-3.974 5.503 5.503 0 0 0-3.914-1.648Z"
          fill="#E6E6E6"
        />
        <path
          d="M75.34 14.469H32.032a3.919 3.919 0 0 0-2.787 1.174 4.04 4.04 0 0 0-1.157 2.83v51.624a4.04 4.04 0 0 0 1.157 2.83 3.919 3.919 0 0 0 2.787 1.173H75.34a3.919 3.919 0 0 0 2.788-1.174 4.04 4.04 0 0 0 1.156-2.83V18.474a4.04 4.04 0 0 0-1.156-2.83 3.919 3.919 0 0 0-2.788-1.174Z"
          fill="#fff"
        />
        <path
          d="M79.89 82.199c5.584 0 10.11-4.595 10.11-10.264 0-5.668-4.526-10.263-10.11-10.263s-10.11 4.595-10.11 10.263c0 5.669 4.526 10.264 10.11 10.264Z"
          fill="#009F2B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M34.241 34.062h14.886a.44.44 0 0 0 .312-.132.453.453 0 0 0 .13-.317V21.819a.452.452 0 0 0-.13-.317.44.44 0 0 0-.312-.132H34.24a.44.44 0 0 0-.313.132.453.453 0 0 0-.13.317v11.794a.46.46 0 0 0 .13.317.44.44 0 0 0 .313.132Zm18.46-6.99h16.146a.918.918 0 0 0 .652-.274.943.943 0 0 0 0-1.325.915.915 0 0 0-.652-.274H52.7a.915.915 0 0 0-.652.274.944.944 0 0 0 0 1.325.915.915 0 0 0 .652.274ZM34.265 47.43h7.75a.44.44 0 0 0 .312-.132.453.453 0 0 0 .13-.317v-7.004a.453.453 0 0 0-.13-.317.44.44 0 0 0-.312-.132h-7.75a.44.44 0 0 0-.313.132.453.453 0 0 0-.13.317v7.004c0 .119.047.233.13.317a.44.44 0 0 0 .313.132Zm34.556-4.595h-21.9a.91.91 0 0 1-.653-.273.94.94 0 0 1-.27-.663.949.949 0 0 1 .27-.662.923.923 0 0 1 .653-.274h21.9c.245 0 .48.099.652.275a.943.943 0 0 1 0 1.323.915.915 0 0 1-.652.274Zm3.805 3.16H46.922a.911.911 0 0 1-.653-.274.94.94 0 0 1-.27-.663.949.949 0 0 1 .27-.662.922.922 0 0 1 .653-.274h25.705c.244 0 .479.099.652.274a.943.943 0 0 1 0 1.324.915.915 0 0 1-.652.275ZM46.922 56.998h21.9c.245 0 .48-.1.653-.275a.943.943 0 0 0 0-1.324.915.915 0 0 0-.653-.274h-21.9a.911.911 0 0 0-.653.274.94.94 0 0 0-.27.662.949.949 0 0 0 .27.663.922.922 0 0 0 .653.274Zm25.705 3.16H46.922a.91.91 0 0 1-.653-.274.94.94 0 0 1-.2-1.021.94.94 0 0 1 .5-.507.91.91 0 0 1 .353-.07h25.705a.909.909 0 0 1 .653.273.938.938 0 0 1 .27.662.95.95 0 0 1-.27.663.923.923 0 0 1-.653.274Zm-30.611 1.434h-7.75a.44.44 0 0 1-.313-.132.453.453 0 0 1-.13-.317v-7.004c0-.119.047-.233.13-.317a.44.44 0 0 1 .313-.132h7.75a.44.44 0 0 1 .313.132.46.46 0 0 1 .13.317v7.004a.453.453 0 0 1-.13.317.44.44 0 0 1-.313.132Zm30.635-31.36h-19.95a.91.91 0 0 1-.653-.274.938.938 0 0 1-.27-.663.95.95 0 0 1 .27-.662.92.92 0 0 1 .652-.274h19.951c.245 0 .48.099.652.274a.944.944 0 0 1 0 1.325.915.915 0 0 1-.652.274Z"
          fill="#E6E6E6"
        />
        <path
          d="m80.305 74.133-1.721 1.747a1.808 1.808 0 0 1-2.582 0 1.856 1.856 0 0 1-.535-1.31c0-.495.19-.96.535-1.31l1.721-1.748a.624.624 0 0 0 0-.874.602.602 0 0 0-.86 0l-1.722 1.747a3.093 3.093 0 0 0-.891 2.185c0 .825.317 1.6.891 2.184a3.01 3.01 0 0 0 4.304 0l1.721-1.748a.624.624 0 0 0 0-.873.602.602 0 0 0-.86 0Zm5.195-4.805c0-.826-.317-1.601-.891-2.185a3.014 3.014 0 0 0-4.304 0l-1.721 1.748a.624.624 0 0 0 0 .874.602.602 0 0 0 .86 0l1.722-1.748a1.808 1.808 0 0 1 2.582 0c.345.35.535.816.535 1.31 0 .496-.19.961-.535 1.311l-1.721 1.748a.624.624 0 0 0 0 .874.602.602 0 0 0 .86 0l1.722-1.748c.575-.584.891-1.36.891-2.184Z"
          fill="#fff"
        />
        <path
          d="M77.723 74.133a.602.602 0 0 0 .861 0l3.443-3.495a.624.624 0 0 0 0-.874.602.602 0 0 0-.861 0l-3.443 3.495a.624.624 0 0 0 0 .874Z"
          fill="#fff"
        />
      </g>
      <defs>
        <clipPath id="abc">
          <path fill="#fff" d="M0 0h90v82H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function IconCreateNotes(props) {
  return (
    <svg width={props.width || '68px'} height={props.height || '75px'} viewBox="0 0 68 75" fill="none" {...props}>
      <path
        d="M54.543 66H7.457a.53.53 0 0 1-.323-.105.324.324 0 0 1-.134-.252V16.357c0-.095.048-.185.134-.252A.53.53 0 0 1 7.457 16h47.086a.53.53 0 0 1 .323.105.324.324 0 0 1 .134.252v49.286a.324.324 0 0 1-.134.252.53.53 0 0 1-.323.105ZM7.457 16.179a.265.265 0 0 0-.161.052.162.162 0 0 0-.067.126v49.286a.16.16 0 0 0 .067.126.265.265 0 0 0 .161.052h47.086c.06 0 .119-.019.161-.052a.161.161 0 0 0 .067-.126V16.357a.161.161 0 0 0-.067-.126.265.265 0 0 0-.161-.052H7.457Z"
        fill="#CACACA"
      />
      <path
        d="M47.347 27.294H14.12a.843.843 0 0 1-.6-.251.863.863 0 0 1 0-1.213.843.843 0 0 1 .6-.25h33.227c.225 0 .44.09.6.25a.862.862 0 0 1 0 1.213.843.843 0 0 1-.6.25Zm0 5.215H14.12a.843.843 0 0 1-.6-.251.862.862 0 0 1 0-1.213.843.843 0 0 1 .6-.251h33.227c.225 0 .44.09.6.251a.862.862 0 0 1 0 1.213.843.843 0 0 1-.6.25Zm0 5.215H14.12a.843.843 0 0 1-.6-.252.863.863 0 0 1 0-1.212.843.843 0 0 1 .6-.251h33.227c.225 0 .44.09.6.25a.862.862 0 0 1 0 1.213.843.843 0 0 1-.6.252Zm0 5.214H14.12a.843.843 0 0 1-.6-.25.863.863 0 0 1 0-1.213.843.843 0 0 1 .6-.251h33.227c.225 0 .44.09.6.25a.862.862 0 0 1 0 1.213.843.843 0 0 1-.6.252Zm0 5.215H14.12a.843.843 0 0 1-.6-.25.863.863 0 0 1 0-1.213.843.843 0 0 1 .6-.252h33.227c.225 0 .44.09.6.252a.862.862 0 0 1 0 1.212.843.843 0 0 1-.6.251Zm.286 7.407H25.588c-.31 0-.562-.384-.562-.858 0-.473.252-.857.563-.857h22.044c.31 0 .562.384.562.857 0 .474-.252.858-.562.858Zm0 3.714H25.588c-.31 0-.562-.383-.562-.857s.252-.857.563-.857h22.044c.31 0 .562.383.562.857s-.252.857-.562.857Z"
        fill="#E6E6E6"
      />
      <path
        d="M54.36 22.183c3.599 0 6.517-2.95 6.517-6.591 0-3.64-2.918-6.592-6.517-6.592-3.6 0-6.517 2.951-6.517 6.592 0 3.64 2.918 6.591 6.517 6.591Z"
        fill="#009F2B"
      />
      <path
        d="M51.645 15.157a.427.427 0 0 0-.304.128.437.437 0 0 0 .304.742h2.285v2.312c0 .115.046.225.126.306a.427.427 0 0 0 .608 0 .438.438 0 0 0 .126-.306v-2.312h2.285a.428.428 0 0 0 .304-.127.438.438 0 0 0-.304-.743H54.79v-2.311a.437.437 0 0 0-.126-.308.428.428 0 0 0-.734.308v2.311h-2.285Z"
        fill="#fff"
      />
    </svg>
  );
}

export function BgPaperPlanes(props) {
  return (
    <svg width={65} height={58} viewBox="0 0 65 58" fill="none" {...props}>
      <path d="m19.513 57.21-2.684-5.572 25.48-12.776-22.796 18.349Z" fill="url(#a)" />
      <path d="M16.83 51.638 7.465 50.2 42.31 38.862 16.83 51.638Z" fill="#EFE8E8" />
      <path d="m21.823 52.444-2.31 4.767L42.31 38.862 21.824 52.444Z" fill="#CCC" />
      <path d="m33.705 54.583 8.604-15.72-20.485 13.581 11.881 2.139Z" fill="url(#b)" />
      <path d="m34.11 23.462-3.344-7.36L64.432.153l-30.321 23.31Z" fill="url(#c)" />
      <path d="m30.766 16.102-12.15-1.99L64.431.152l-33.666 15.95Z" fill="#60B8E7" />
      <path d="m37.27 17.3-3.16 6.162L64.433.153 37.27 17.301Z" fill="#86D1D8" />
      <path d="M51.625 19.076 64.432.153 37.27 17.301l14.355 1.775Z" fill="#6AB1E2" />
      <path d="M6.025 31.293 5.05 28.37l13.391-4.698-12.416 7.62Z" fill="url(#d)" />
      <path d="M5.05 28.37.514 27.066l17.927-3.394L5.05 28.37Z" fill="url(#e)" />
      <path d="m7.466 29.084-1.441 2.209 12.416-7.62-10.975 5.411Z" fill="#CCC" />
      <path d="m13.202 30.893 5.24-7.22-10.976 5.411 5.736 1.81Z" fill="url(#f)" />
      <defs>
        <linearGradient id="a" x1={16.7} y1={48.65} x2={42.679} y2={47.538} gradientUnits="userSpaceOnUse">
          <stop stopColor="#B7AEAE" />
          {' '}
          <stop offset={1} stopColor="#D1D1D1" />
        </linearGradient>
        <linearGradient id="b" x1={39.654} y1={47.684} x2={23.899} y2={43.474} gradientUnits="userSpaceOnUse">
          <stop stopColor="#fff" />
          {' '}
          <stop offset={1} stopColor="#E6E6E6" />
        </linearGradient>
        <linearGradient id="c" x1={30.692} y1={12.232} x2={64.679} y2={11.554} gradientUnits="userSpaceOnUse">
          <stop stopColor="#5FA8B7" />
          {' '}
          <stop offset={0.933} stopColor="#61B3D6" />
        </linearGradient>
        <linearGradient id="d" x1={4.982} y1={27.737} x2={18.62} y2={26.998} gradientUnits="userSpaceOnUse">
          <stop stopColor="#B7AEAE" />
          {' '}
          <stop offset={1} stopColor="#D1D1D1" />
        </linearGradient>
        <linearGradient id="e" x1={16.117} y1={26.309} x2={6.956} y2={19.139} gradientUnits="userSpaceOnUse">
          <stop stopColor="#fff" />
          {' '}
          <stop offset={1} stopColor="#E6E6E6" />
        </linearGradient>
        <linearGradient id="f" x1={17.018} y1={27.724} x2={8.776} y2={25.155} gradientUnits="userSpaceOnUse">
          <stop stopColor="#fff" />
          {' '}
          <stop offset={1} stopColor="#E6E6E6" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function IconHome(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="m18.024 9.12-1.402-1.278V3.603a.488.488 0 0 0-.489-.488h-3.377a.488.488 0 0 0-.488.488v.272l-1.695-1.544a.848.848 0 0 0-1.147 0l-7.45 6.79a.846.846 0 0 0-.221.936c.128.331.44.544.794.544h1.19v6.803c0 .27.219.488.488.488h4.084c.27 0 .489-.218.489-.488v-4.13h2.4v4.13c0 .27.219.488.488.488h4.084c.27 0 .489-.218.489-.488v-6.802h1.19a.846.846 0 0 0 .794-.544.846.846 0 0 0-.22-.938Zm-2.252.505a.488.488 0 0 0-.488.488v6.803h-3.107v-4.13a.488.488 0 0 0-.489-.49H8.311a.488.488 0 0 0-.488.49v4.13H4.716v-6.803a.488.488 0 0 0-.489-.488H2.872L10 3.13l2.427 2.212a.488.488 0 0 0 .818-.361v-.89h2.4v3.967c0 .137.058.268.16.36l1.323 1.207h-1.356Z"
        fill="#009F2B"
        stroke="#009F2B"
        strokeWidth={0.3}
      />
    </svg>
  );
}

export function IconApartment(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 20 21" fill="none" {...props}>
      <path
        d="M5.533 6.943h2.474v1.039H5.533v-1.04Zm0 2.362h2.474v1.039H5.533v-1.04Zm0 2.361h2.474v1.039H5.533v-1.04Zm0 2.364h2.474v1.04H5.533v-1.04Z"
        fill="#009F2B"
      />
      <path
        d="M10.535 16.449V7.963l5.423-.006v5.725h1.038V7.437a.524.524 0 0 0-.52-.52l-6.46.009a.519.519 0 0 0-.519.519v9H4.042V6.174L9.497 4.71v1.179h1.038v-1.86a.525.525 0 0 0-.654-.5L3.388 5.274a.519.519 0 0 0-.384.5v10.675h-1.1v1.039h16.192v-1.04h-7.56Z"
        fill="#009F2B"
      />
      <path
        d="M15.958 14.616h1.038v.967h-1.038v-.967Zm-3.964-5.311h2.476v1.039h-2.474l-.002-1.04Zm0 2.362h2.476v1.039h-2.474l-.002-1.04Zm0 2.363h2.476v1.04h-2.474l-.002-1.04Z"
        fill="#009F2B"
      />
    </svg>
  );
}

export function IconShop(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 20 21" fill="none" {...props}>
      <path
        d="m17.311 7.98-.915-3.847a.462.462 0 0 0-.444-.364H4.048c-.21 0-.394.15-.444.364L2.688 7.98a.493.493 0 0 0-.013.116c0 .806.363 1.516.915 1.953v6.701a.47.47 0 0 0 .458.481h4.578a.47.47 0 0 0 .458-.48v-3.366h1.832v3.365a.47.47 0 0 0 .457.481h4.579a.47.47 0 0 0 .458-.48v-6.702c.552-.437.915-1.147.915-1.953a.496.496 0 0 0-.014-.116Zm-1.817 8.29H11.83v-3.366a.47.47 0 0 0-.458-.48H8.626a.47.47 0 0 0-.457.48v3.366H4.506v-5.81c.113.02.226.039.343.039.698 0 1.319-.364 1.717-.93.398.566 1.02.93 1.717.93.698 0 1.319-.364 1.717-.93.398.566 1.019.93 1.717.93.697 0 1.318-.364 1.717-.93.398.566 1.019.93 1.716.93.118 0 .231-.018.344-.039v5.809Zm-.344-6.732c-.694 0-1.258-.647-1.258-1.442a.47.47 0 0 0-.458-.48.47.47 0 0 0-.458.48c0 .795-.565 1.442-1.26 1.442-.693 0-1.258-.647-1.258-1.442a.47.47 0 0 0-.458-.48.47.47 0 0 0-.458.48c0 .795-.565 1.442-1.259 1.442s-1.259-.647-1.259-1.442a.47.47 0 0 0-.458-.48.47.47 0 0 0-.458.48c0 .795-.565 1.442-1.259 1.442-.677 0-1.232-.617-1.258-1.386l.815-3.422h11.189l.815 3.422c-.027.769-.582 1.386-1.26 1.386Z"
        fill="#009F2B"
        stroke="#009F2B"
        strokeWidth={0.2}
      />
    </svg>
  );
}

export function SvgNoUserSelected(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 237 214" fill="none" {...props}>
      <g clipPath="url(#a)">
        <path
          d="M206.898 158.326c-.769-6.173-4.602-12.255-10.501-14.264a28.613 28.613 0 0 1-.001 19.678c-.907 2.446-2.17 5.074-1.317 7.54.53 1.535 1.828 2.709 3.278 3.443 1.451.734 3.061 1.084 4.65 1.427l.313.258c2.524-5.688 4.347-11.909 3.578-18.082Z"
          fill="#F0F0F0"
        />
        <path
          d="M196.339 144.179a24.48 24.48 0 0 1 6.101 13.787c.134 1.1.094 2.215-.12 3.303a6.046 6.046 0 0 1-1.508 2.806c-.679.745-1.461 1.429-1.947 2.326a3.707 3.707 0 0 0-.181 3.025c.429 1.229 1.275 2.23 2.136 3.181.957 1.056 1.967 2.137 2.374 3.537.049.169.31.083.261-.086-.708-2.435-3.076-3.818-4.205-6.012-.528-1.023-.749-2.211-.255-3.292.432-.944 1.238-1.65 1.932-2.399a6.446 6.446 0 0 0 1.577-2.689 9.745 9.745 0 0 0 .247-3.286 23.742 23.742 0 0 0-1.739-7.222 24.913 24.913 0 0 0-4.492-7.184c-.117-.132-.298.075-.181.205Z"
          fill="#fff"
        />
        <path
          d="M202.366 156.307a3.683 3.683 0 0 0 2.11-1.411c.514-.705.759-1.57.693-2.439-.014-.176-.288-.163-.274.014a3.402 3.402 0 0 1-2.615 3.576c-.172.04-.085.3.086.26Zm-1.159 7.435a7.086 7.086 0 0 1-3.17-4.079c-.05-.17-.31-.084-.261.086a7.375 7.375 0 0 0 3.307 4.238c.152.09.275-.155.124-.245Zm-1.526-14.958a2.077 2.077 0 0 1-1.975-.1c-.151-.092-.274.154-.123.245a2.335 2.335 0 0 0 2.184.116.141.141 0 0 0 .078-.07.137.137 0 0 0 .01-.103.143.143 0 0 0-.069-.08.141.141 0 0 0-.105-.008Z"
          fill="#fff"
        />
        <path
          d="M178.418 155.088c.093.06.186.12.278.183a27.38 27.38 0 0 1 3.51 2.735c.086.076.172.155.255.233a28.875 28.875 0 0 1 6.285 8.587 28.01 28.01 0 0 1 1.539 3.975c.568 1.881 1.034 3.966 2.159 5.505.115.162.241.316.375.463h10.161c.023-.012.047-.021.07-.033l.406.019-.052-.218-.03-.125a.847.847 0 0 1-.018-.081l-.007-.025c-.005-.026-.012-.049-.016-.072a80.703 80.703 0 0 0-.316-1.242c0-.003 0-.003-.002-.005-.832-3.154-1.936-6.266-3.477-9.112-.047-.085-.093-.173-.144-.259a26.773 26.773 0 0 0-2.409-3.647 23.476 23.476 0 0 0-1.579-1.802 19.684 19.684 0 0 0-4.933-3.688c-3.644-1.921-7.863-2.657-11.758-1.484l-.297.093Z"
          fill="#F0F0F0"
        />
        <path
          d="M178.441 155.217a24.559 24.559 0 0 1 13.188 7.341 10.559 10.559 0 0 1 1.897 2.71c.441.986.61 2.073.489 3.146-.094 1.004-.305 2.019-.152 3.028a3.708 3.708 0 0 0 1.679 2.523c1.084.724 2.364 1.015 3.626 1.257 1.4.268 2.859.524 4.028 1.397.142.106.298-.12.157-.225-2.034-1.519-4.76-1.201-6.984-2.273-1.039-.5-1.932-1.316-2.189-2.476-.225-1.014-.008-2.061.095-3.076a6.437 6.437 0 0 0-.363-3.095 9.753 9.753 0 0 0-1.785-2.772 23.803 23.803 0 0 0-5.745-4.722 25.045 25.045 0 0 0-7.92-3.037c-.173-.034-.193.24-.021.274Z"
          fill="#fff"
        />
        <path
          d="M190.569 161.278a3.671 3.671 0 0 0-.084-4.759c-.117-.132-.328.044-.211.176a3.396 3.396 0 0 1 .069 4.427c-.112.136.114.291.226.156Zm3.56 6.633a7.11 7.11 0 0 1-4.992-1.352c-.142-.106-.298.12-.156.225a7.39 7.39 0 0 0 5.197 1.397c.176-.019.126-.289-.049-.27Zm-10.241-11.026a2.093 2.093 0 0 1-1.637 1.107c-.177.017-.126.287.049.27a2.341 2.341 0 0 0 1.814-1.221.141.141 0 0 0 .02-.102.14.14 0 0 0-.055-.089.144.144 0 0 0-.103-.022.141.141 0 0 0-.088.057Z"
          fill="#fff"
        />
        <path
          d="M128.703 43.544a2.66 2.66 0 0 0-.536 2.197 2.673 2.673 0 0 0 1.344 1.822l-1.567 9.37 4.521-2.002.795-8.592a2.684 2.684 0 0 0-1.034-3.417 2.7 2.7 0 0 0-3.523.622Zm40.673 129.64h-3.697l-1.759-14.232h5.456v14.232Z"
          fill="#9E616A"
        />
        <path
          d="M170.319 176.76h-11.92v-.15c0-1.229.489-2.406 1.359-3.275a4.645 4.645 0 0 1 3.28-1.356h7.281v4.781Z"
          fill="#2F2E41"
        />
        <path d="M144.57 173.184h-3.696l-1.759-14.232h5.456l-.001 14.232Z" fill="#9E616A" />
        <path
          d="M145.513 176.76h-11.92v-.15c0-1.229.489-2.406 1.359-3.275a4.645 4.645 0 0 1 3.281-1.356h7.28v4.781Zm-2.484-69.985-1.381 1.814s-.125.847-2.221 7.748l-1.15 51.87h6.955l9.296-41.502 9.648 42.335 6.029.355-.283-48.118s.761-9.9-1.938-11.738c-2.699-1.839-24.955-2.764-24.955-2.764Z"
          fill="#2F2E41"
        />
        <path
          d="M152.356 63.186c4.031 0 7.298-3.26 7.298-7.284 0-4.023-3.267-7.284-7.298-7.284-4.03 0-7.298 3.261-7.298 7.284s3.268 7.284 7.298 7.284Z"
          fill="#9E616A"
        />
        <path
          d="m159.698 57.042-.12-.24c-.187-.372-1.73-3.465-1.924-4.26l-1.942.227-5.057.001.703-1.052-1.858.242a4.27 4.27 0 0 0-1.894.712c-.346.23-.639.531-.858.884a149.79 149.79 0 0 0-1.688 3.008l-.097.178-.843-1.415c-.011-.055-1.055-5.49 2.44-7.334.18-.366 1.716-3.24 5.346-3.046a2.302 2.302 0 0 1 1.564-.776c.829-.043 1.69.391 2.554 1.297 1.148 1.203 2.72 2.85 3.671 4.68l.262.373c.373.535.558 1.178.525 1.828a6.096 6.096 0 0 1-.208 3.113l-.576 1.58Z"
          fill="#2F2E41"
        />
        <path
          d="m157.917 64.557 4.038 2.227 7.933 2.217-2.368 20.72.431 20.409s-13.428 9.181-26.303-1.541v-25.69l.761-13.898s3.081-.873 4.633.634l2.942-3.815 7.933-1.263Z"
          fill="#E4E4E4"
        />
        <path
          d="m144.189 70.91-1.78-1.909-9.805-1.108.921-15.03-5.346-3.807-3.928 21.16L142.394 82.9l1.795-11.99Z"
          fill="#E4E4E4"
        />
        <path
          d="M164.064 116.874a2.678 2.678 0 0 1 .558-2.192 2.68 2.68 0 0 1 2.043-.98l3.019-9.01 3.052 3.885-3.335 7.96a2.69 2.69 0 0 1-2.518 2.535 2.694 2.694 0 0 1-2.819-2.198Z"
          fill="#9E616A"
        />
        <path
          d="m166.908 71.373 2.98-2.372s3.047 1.678 3.974 4.686c.928 3.008 2.55 20.13 2.55 20.13l-4.404 21.982-4.926-3.41 2.376-17.415-4.173-12.726 1.623-10.875Z"
          fill="#E4E4E4"
        />
        <path d="M129.548 36h-75.16v18.229h75.16V36Z" fill="#E6E6E6" />
        <path d="M56.36 52.26h71.215V37.969H56.361v14.293Z" fill="#fff" />
        <path
          d="M69.925 50.56a5.45 5.45 0 0 0 5.455-5.446 5.45 5.45 0 0 0-5.455-5.445 5.45 5.45 0 0 0-5.456 5.445 5.45 5.45 0 0 0 5.456 5.446Zm49.542-7.576H82.971v1.184h36.496v-1.184Zm0 3.078H82.971v1.183h36.496v-1.183Z"
          fill="#009F2B"
        />
        <path d="m27 63.706 63.593 4.63v16.666L27 83.822V63.707Z" fill="#E6E6E6" />
        <path d="m29.003 81.7 60.202 1.47V70.043l-60.202-4.03V81.7Z" fill="#fff" />
        <path
          d="M42.216 68.697c.695.045 1.372.24 1.984.573a5.518 5.518 0 0 1 1.603 1.32 6.23 6.23 0 0 1 1.073 1.868c.26.715.392 1.47.392 2.231.002.75-.13 1.494-.392 2.196a5.534 5.534 0 0 1-1.073 1.77A4.84 4.84 0 0 1 44.2 79.83a4.504 4.504 0 0 1-1.984.392 4.756 4.756 0 0 1-2.005-.514 5.47 5.47 0 0 1-1.655-1.299 6.203 6.203 0 0 1-1.124-1.895 6.516 6.516 0 0 1-.414-2.291 6.213 6.213 0 0 1 .414-2.254 5.5 5.5 0 0 1 1.124-1.792 4.81 4.81 0 0 1 1.655-1.147 4.506 4.506 0 0 1 2.005-.332ZM54.06 72.82l29.301 1.525v1.108l-29.3-1.421V72.82Zm0 3.15 29.301 1.255v1.107l-29.3-1.152v-1.21ZM27 97.56l63.593-1.178v16.666L27 117.677V97.561Z"
          fill="#E6E6E6"
        />
        <path d="m29.003 115.371 60.202-4.03V98.216l-60.202 1.47v15.685Z" fill="#fff" />
        <path
          d="M37.022 106.896a6.531 6.531 0 0 1 .506-2.272 6.14 6.14 0 0 1 1.198-1.838 5.38 5.38 0 0 1 1.702-1.213 4.697 4.697 0 0 1 2.02-.412 4.519 4.519 0 0 1 1.96.492 4.91 4.91 0 0 1 1.551 1.255c.444.541.783 1.161.999 1.826.233.715.336 1.466.303 2.217a6.52 6.52 0 0 1-.479 2.214 6.166 6.166 0 0 1-1.145 1.816 5.419 5.419 0 0 1-1.652 1.241 4.739 4.739 0 0 1-2.002.472 4.493 4.493 0 0 1-1.988-.435 4.885 4.885 0 0 1-1.603-1.233 5.6 5.6 0 0 1-1.049-1.852 6.282 6.282 0 0 1-.32-2.278Zm17.038-2.692 29.301-1.152v1.107l-29.3 1.256v-1.211Zm0 3.148 29.301-1.42v1.107l-29.3 1.524v-1.211Z"
          fill="#E6E6E6"
        />
        <path
          d="M209.768 177h-88.326a.232.232 0 0 1-.164-.395.232.232 0 0 1 .164-.068h88.326c.062 0 .121.024.164.068a.228.228 0 0 1 .068.163.232.232 0 0 1-.232.232Z"
          fill="#CACACA"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" transform="translate(27 36)" d="M0 0h183v141H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SvgMenuClients(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 21 21" fill="none" {...props}>
      <path d="M10.863 8.689a3.02 3.02 0 1 0 0-6.042 3.02 3.02 0 0 0 0 6.042Z" fill="currentColor" />
      <path
        d="M16.974 8.689a1.91 1.91 0 1 0 0-3.82 1.91 1.91 0 0 0 0 3.82Zm-12.222 0a1.91 1.91 0 1 0 0-3.82 1.91 1.91 0 0 0 0 3.82Zm1.882 1.715c-.752-.616-1.433-.535-2.302-.535a2.353 2.353 0 0 0-2.358 2.344v3.792a1.02 1.02 0 0 0 1.022 1.017c2.431 0 2.138.044 2.138-.105 0-2.687-.318-4.657 1.5-6.513Z"
        fill="currentColor"
        opacity="0.7"
      />
      <path
        d="M11.69 9.883c-1.518-.126-2.838.002-3.976.941-1.905 1.526-1.538 3.58-1.538 6.093 0 .665.54 1.216 1.216 1.216 7.33 0 7.62.237 8.055-.726.143-.325.104-.222.104-3.335 0-2.474-2.142-4.189-3.86-4.189Z"
        fill="currentColor"
      />
      <path
        d="M17.395 9.87c-.874 0-1.551-.081-2.302.534 1.804 1.842 1.5 3.678 1.5 6.513 0 .15-.244.105 2.102.105.583 0 1.057-.472 1.057-1.053v-3.756a2.353 2.353 0 0 0-2.357-2.344Z"
        fill="currentColor"
        opacity="0.7"
      />
    </svg>
  );
}

export function SvgMenuLeads(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 21 21" fill="none" {...props}>
      <path
        d="M10.863 9.672a2.105 2.105 0 1 0 0-4.21 2.105 2.105 0 0 0 0 4.21Zm.585.854c-1.058-.074-1.978 0-2.771.547-1.327.889-1.072 2.085-1.072 3.548 0 .387.377.708.847.708 5.108 0 5.311.138 5.614-.422.1-.19.072-.13.072-1.943 0-1.44-1.492-2.438-2.69-2.438ZM1.946 9.15a8.918 8.918 0 0 1 2.55-5.114 8.92 8.92 0 0 1 5.115-2.55.558.558 0 1 1 .154 1.105A7.907 7.907 0 0 0 3.05 9.304a.558.558 0 0 1-1.105-.154Zm10.016-6.56a7.907 7.907 0 0 1 6.714 6.714.558.558 0 1 0 1.105-.154 8.918 8.918 0 0 0-2.551-5.114 8.92 8.92 0 0 0-5.114-2.55.558.558 0 1 0-.154 1.105ZM9.765 18.216a7.907 7.907 0 0 1-6.714-6.713.558.558 0 1 0-1.105.153 8.919 8.919 0 0 0 2.55 5.114 8.92 8.92 0 0 0 5.115 2.55.558.558 0 0 0 .154-1.105Zm9.54-7.189a.558.558 0 0 0-.63.476 7.907 7.907 0 0 1-6.713 6.713.558.558 0 0 0 .154 1.105 8.919 8.919 0 0 0 5.114-2.55 8.92 8.92 0 0 0 2.55-5.114.558.558 0 0 0-.475-.63Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function SvgMenuSaleDispute(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 21 21" fill="none" {...props}>
      <g clipPath="url(#sd)">
        <path
          d="M15.635 6.07c0 .546-.397.877-.687 1.12-.11.093-.314.26-.313.324a.44.44 0 0 1-.443.443h-.004a.44.44 0 0 1-.446-.436c-.004-.483.349-.773.632-1.01.223-.187.369-.319.369-.44a.442.442 0 0 0-.883 0 .446.446 0 1 1-.893 0 1.334 1.334 0 0 1 2.668-.002Zm-1.434 2.3c-.247 0-.437.2-.437.446v.004c0 .246.19.444.437.444a.448.448 0 0 0 0-.894Zm-8.996 3.109a.446.446 0 1 0 0 .892h.037a.446.446 0 1 0 0-.892h-.037Zm1.551 0a.446.446 0 1 0 0 .892h.037a.446.446 0 1 0 0-.892h-.037ZM19.863 4.35v5.023c0 1.19-.953 2.154-2.143 2.154h-5.787c-.113 0-.207 0-.284-.002a2.352 2.352 0 0 0-.21.002 2.938 2.938 0 0 0-.217.19l-.117.106-1.638 1.493a.455.455 0 0 1-.76-.33V8.255H4.03c-.697 0-1.275.571-1.275 1.268v5.023c0 .698.578 1.246 1.275 1.246h6.465c.111 0 .216.05.298.126l1.334 1.23v-4.242a.446.446 0 1 1 .892 0v5.254a.44.44 0 0 1-.44.441.451.451 0 0 1-.3-.121l-1.957-1.796H4.031c-1.189 0-2.168-.948-2.168-2.138V9.523c0-1.19.979-2.161 2.168-2.161h4.675V4.35c0-1.19.986-2.145 2.176-2.145h6.839c1.189 0 2.142.955 2.142 2.145Zm-.892 0c0-.698-.553-1.252-1.25-1.252h-6.84c-.696 0-1.282.554-1.282 1.252v7.625l.897-.811c.042-.038.088-.073.122-.104.41-.378.515-.438 1.05-.427l.265.002h5.787c.698 0 1.25-.565 1.25-1.262V4.35Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="sd">
          <path fill="#fff" transform="translate(1.863 1.403)" d="M0 0h18v18H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SvgaddNewAction(props) {
  return (
    <svg viewBox="0 0 16 14" fill="none" width={props.size || '1em'} height={props.size || '1em'} {...props}>
      <path
        d="m13.832 2.262-7.86 7.934L3.05 7.25l.971-.98 1.95 1.967 6.89-6.948.971.973zm-6.89 10.296c-3.038 0-5.511-2.494-5.511-5.558 0-3.064 2.473-5.558 5.512-5.558a5.44 5.44 0 0 1 2.948.869l1-1.008A6.864 6.864 0 0 0 6.942.053C3.139.053.053 3.165.053 7s3.086 6.947 6.89 6.947a6.776 6.776 0 0 0 3.293-.847l-1.034-1.042c-.689.32-1.453.5-2.26.5zm4.823-3.474H9.7v1.39h2.066v2.084h1.378v-2.084h2.067v-1.39h-2.067V7h-1.378v2.084z"
        fill={props.color || 'currentColor'}
      />
    </svg>
  );
}

export function SvgToDo(props) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill={props.color || 'currentColor'}
      width={props.size || '1em'}
      height={props.size || '1em'}
      {...props}
    >
      <path d="M16.473 12.938H9.876a.66.66 0 1 0 0 1.32h6.597a.66.66 0 0 0 0-1.32z" />
      <path d="M9.876 12.852h6.597a.746.746 0 1 1 0 1.492H9.876a.746.746 0 0 1 0-1.492zm6.597 1.32a.574.574 0 0 0 0-1.148H9.876a.574.574 0 1 0 0 1.148h6.597zM6.635 11.99l-1.99 1.967-.749-.775a.602.602 0 1 0-.86.832l1.168 1.215a.602.602 0 0 0 .422.18h.007a.603.603 0 0 0 .42-.172l2.418-2.392a.602.602 0 0 0-.78-.906.61.61 0 0 0-.056.051z" />
      <path d="M7.083 11.706a.688.688 0 0 1 .45 1.205l-2.42 2.382a.68.68 0 0 1-.479.198h-.007a.688.688 0 0 1-.484-.205L2.974 14.07a.688.688 0 0 1 .983-.951l.688.715 1.926-1.904a.683.683 0 0 1 .512-.225zM4.636 15.32a.51.51 0 0 0 .358-.148l2.423-2.395A.516.516 0 0 0 6.749 12a.512.512 0 0 0-.049.049l-2.052 2.027-.809-.84a.516.516 0 0 0-.736.712l1.168 1.215a.516.516 0 0 0 .362.153l.003.002zm2.44-10.725H3.47a.602.602 0 0 0-.602.602V8.81a.602.602 0 0 0 .602.602h3.607a.602.602 0 0 0 .602-.602V5.197a.602.602 0 0 0-.602-.602zm-.602 3.613H4.065V5.799h2.409v2.409z" />
      <path d="M3.47 4.509h3.606a.688.688 0 0 1 .688.688V8.81a.688.688 0 0 1-.688.688H3.47a.688.688 0 0 1-.688-.688V5.197a.688.688 0 0 1 .688-.688zm3.612 4.812a.516.516 0 0 0 .516-.516V5.192a.516.516 0 0 0-.516-.516H3.47a.516.516 0 0 0-.516.516v3.613a.516.516 0 0 0 .516.516h3.613zM3.986 5.708h2.58v2.58h-2.58v-2.58zm2.408.172H4.158v2.237h2.23l.006-2.237zm10.079.461H9.876a.66.66 0 1 0 0 1.32h6.597a.66.66 0 1 0 0-1.32z" />
      <path d="M9.876 6.255h6.597a.746.746 0 0 1 0 1.492H9.876a.746.746 0 1 1 0-1.492zm6.597 1.32a.574.574 0 1 0 0-1.148H9.876a.574.574 0 0 0 0 1.148h6.597z" />
    </svg>
  );
}
export function SvgWaitingResponce(props) {
  return (
    <svg width={props.size || '208px'} height={props.size || '154px'} viewBox="0 0 208 154" fill="none" {...props}>
      <g clipPath="url(#wr)">
        <path
          d="M12.55 125.065a101.174 101.174 0 0 0 4.753 28.041c.064.211.136.419.205.629h17.734a36.097 36.097 0 0 1-.056-.629c-1.182-13.555 5.572-95.073 13.724-109.182-.714 1.145-37.734 38.07-36.36 81.141Z"
          fill="#E6E6E6"
        />
        <path
          d="M13.882 153.106c.148.211.302.422.46.629h13.305c-.101-.179-.218-.39-.354-.629-2.197-3.955-8.703-15.781-14.74-28.041C6.064 111.89.108 98.216.61 93.267c-.156 1.115-4.646 35.144 13.27 59.839Z"
          fill="#E6E6E6"
        />
        <path
          d="M70.778 105.412a3.067 3.067 0 0 0-.09.474l-12.81 6.71-2.975-1.869-3.414 4.109 4.944 3.817a2.343 2.343 0 0 0 2.8.043l13.32-9.649a3.07 3.07 0 0 0 3.405-.725 3.048 3.048 0 0 0-.725-4.756 3.07 3.07 0 0 0-3.468.318 3.052 3.052 0 0 0-.987 1.528Zm15.445 45.461 2.57-1.647-5.15-10.664-3.791 2.431 6.371 9.88Z"
          fill="#9E616A"
        />
        <path
          d="m85.029 150.457 5.059-3.244a3.84 3.84 0 0 1 5.297 1.147l.067.105-8.282 5.311-2.141-3.319Zm-35.814-17.901 19.718-12.588s3.623-.349 5.797 3.924l13.132 18.81-5.603 3.78-14.572-15.088-10 9.861s14.733-2.409 14.235 7.279c-.395 7.688-20.559 5.051-28.865 3.635a10.888 10.888 0 0 1-7.633-5.21c-.89-1.541-1.37-3.291-.621-4.944 1.995-4.411 14.412-9.459 14.412-9.459Z"
          fill="#2F2E41"
        />
        <path
          d="m39.44 143.077-5.682-1.147 1.62-27.81 6.537-7.986 3.896-.688a4.719 4.719 0 0 1 3.356.652 4.698 4.698 0 0 1 2.028 2.746l1.717 6.255c2.913 4.919-1.168 10.622-1.544 11.129l.212 8.625-12.14 8.224Z"
          fill="#8EB398"
        />
        <path d="m44.731 107.224.36-1.272s3.913-2.876 9.892 4.576l-2.865 5.093-6.228-.249-1.159-8.148Z" fill="#8EB398" />
        <path
          d="M53.731 97.326c1.109 4.531-3.26 4.868-8.443 6.129-5.183 1.26-9.217 2.968-10.325-1.563-1.108-4.531-1.02-13.062 6.311-14.845 7.585-1.845 11.35 5.748 12.457 10.28Z"
          fill="#2F2E41"
        />
        <path
          d="M43.715 103.64c3.59 0 6.5-2.902 6.5-6.482s-2.91-6.481-6.5-6.481-6.5 2.901-6.5 6.481 2.91 6.482 6.5 6.482Z"
          fill="#9E616A"
        />
        <path
          d="m36.267 98.315 2.498-.608.35-3.344.972 3.023 1.194-.29.203-1.952.568 1.764 8.87-2.158a6.862 6.862 0 0 0-3.11-4.237 6.897 6.897 0 0 0-5.205-.803l-1.286.313a6.89 6.89 0 0 0-4.249 3.102 6.85 6.85 0 0 0-.805 5.19Z"
          fill="#2F2E41"
        />
        <path
          d="M54.846 129.209a3.077 3.077 0 0 0-.457.159l-12.194-7.769.152-3.502-5.27-.92-.874 6.174a2.324 2.324 0 0 0 1.351 2.447l15.007 6.751a3.057 3.057 0 0 0 2.32 2.589 3.067 3.067 0 0 0 3.249-1.247 3.048 3.048 0 0 0-1.463-4.584 3.077 3.077 0 0 0-1.82-.098Z"
          fill="#9E616A"
        />
        <path
          d="m42.902 107.404-.92-1.155s-3.69-1.186-5.682 3.782c-1.993 4.969-.125 9.812-.125 9.812l8.719.746.623-8.074-2.615-5.111Z"
          fill="#8EB398"
        />
        <path
          d="M139.916 35.28a.7.7 0 0 1 .7-.7H207.3a.7.7 0 0 1 .7.7v20.887a.7.7 0 0 1-.7.7h-1.179a.7.7 0 0 0-.7.7v3.443a.7.7 0 0 1-1.194.495l-4.447-4.433a.7.7 0 0 0-.494-.205h-58.67a.7.7 0 0 1-.7-.7V35.28Z"
          fill="#E6E6E6"
        />
        <path d="M206.109 36.75h-64.302v17.83h64.302V36.75Z" fill="#fff" />
        <path d="M177.938 41.956h-30.96v.936h30.96v-.937Z" fill="#009F2B" />
        <path
          d="M200.938 45.197h-53.96v.936h53.96v-.937Zm-.053 3.241h-53.907v.936h53.907v-.936ZM167.307.7a.7.7 0 0 0-.7-.7H99.923a.7.7 0 0 0-.7.7v20.888a.7.7 0 0 0 .7.7h1.179a.7.7 0 0 1 .7.7v3.442a.7.7 0 0 0 1.194.496l4.447-4.434a.7.7 0 0 1 .494-.204h58.67a.7.7 0 0 0 .7-.7V.7Z"
          fill="#E6E6E6"
        />
        <path d="M165.416 2.17h-64.302V20h64.302V2.17Z" fill="#fff" />
        <path d="M137.76 7.547h-30.959v.937h30.959v-.937Z" fill="#009F2B" />
        <path d="M160.761 10.789h-53.96v.936h53.96v-.936Zm-.053 3.241h-53.907v.936h53.907v-.936Z" fill="#E6E6E6" />
        <path
          d="M83.02 100.456h-.12v-3.293a1.902 1.902 0 0 0-1.18-1.76 1.916 1.916 0 0 0-.732-.145h-6.995a1.915 1.915 0 0 0-1.766 1.176 1.902 1.902 0 0 0-.145.73v18.062a1.906 1.906 0 0 0 1.91 1.906h6.996a1.912 1.912 0 0 0 1.911-1.906V102.8h.12v-2.344Z"
          fill="#3F3D56"
        />
        <path
          d="M81.065 95.754h-.913a.675.675 0 0 1-.628.931h-4.007a.68.68 0 0 1-.675-.607.675.675 0 0 1 .047-.325h-.853a1.429 1.429 0 0 0-1.427 1.424v18.036a1.423 1.423 0 0 0 1.427 1.423h7.03a1.422 1.422 0 0 0 1.318-.878c.071-.173.108-.358.108-.545V97.177a1.42 1.42 0 0 0-.88-1.315 1.43 1.43 0 0 0-.547-.108Z"
          fill="#fff"
        />
        <path d="M158.816 65.767H75.212v27.369h3.167v7.157l7.178-7.157h73.259V65.767Z" fill="#fff" />
        <path
          d="M79.478 99.57a.8.8 0 0 1-1.364-.566V94.2a.8.8 0 0 0-.8-.8h-1.567a.8.8 0 0 1-.8-.8V66.303a.8.8 0 0 1 .8-.8h82.534a.8.8 0 0 1 .8.8V92.6a.8.8 0 0 1-.8.8H85.997a.8.8 0 0 0-.564.233l-5.955 5.938Zm-4-7.5a.8.8 0 0 0 .8.8h1.566a.8.8 0 0 1 .8.8v4.057a.8.8 0 0 0 1.365.566l5.204-5.189a.8.8 0 0 1 .565-.233h71.972a.8.8 0 0 0 .8-.8V66.83a.8.8 0 0 0-.8-.8H76.277a.8.8 0 0 0-.8.8v25.24Z"
          fill="#CCC"
        />
        <path d="M122.534 75.035H84.517v1.15h38.017v-1.15Z" fill="#009F2B" />
        <path d="M150.777 79.015h-66.26v1.15h66.26v-1.15Zm-.065 3.98H84.517v1.15h66.195v-1.15Z" fill="#E6E6E6" />
        <path
          d="M113.808 154h-101.1a.265.265 0 0 1 0-.529h101.1a.27.27 0 0 1 .188.077.268.268 0 0 1 0 .375.27.27 0 0 1-.188.077Z"
          fill="#3F3D56"
        />
      </g>
      <defs>
        <clipPath id="wr">
          <path fill="#fff" d="M0 0h208v154H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SvgSelectMeeting(props) {
  return (
    <svg width={props.size || '207px'} height={props.size || '163px'} viewBox="0 0 207 163" fill="none" {...props}>
      <path
        d="M36.29 122.673 3.25 107.425a4.95 4.95 0 0 1-2.564-2.781 4.965 4.965 0 0 1 .144-3.785l4.257-9.264a4.949 4.949 0 0 1 2.776-2.57 4.935 4.935 0 0 1 3.776.144l33.04 15.248a4.955 4.955 0 0 1 2.566 2.782 4.966 4.966 0 0 1-.145 3.785l-4.256 9.264a4.947 4.947 0 0 1-2.776 2.57 4.932 4.932 0 0 1-3.777-.145Z"
        fill="#F2F2F2"
      />
      <path
        d="m31.146 116.784-20.086-9.27a2.817 2.817 0 0 1-1.377-3.735l3.373-7.34a2.807 2.807 0 0 1 3.728-1.38l20.086 9.269a2.818 2.818 0 0 1 1.377 3.736l-3.373 7.34a2.809 2.809 0 0 1-3.728 1.38Z"
        fill="#fff"
      />
      <path
        d="m31.031 117.036-20.086-9.269a3.103 3.103 0 0 1-1.512-4.103l3.373-7.34a3.084 3.084 0 0 1 4.094-1.516l20.086 9.27a3.103 3.103 0 0 1 1.512 4.103l-3.373 7.34a3.084 3.084 0 0 1-4.094 1.515ZM16.67 95.311a2.532 2.532 0 0 0-3.362 1.244l-3.373 7.34a2.548 2.548 0 0 0 1.242 3.369l20.086 9.27a2.533 2.533 0 0 0 3.362-1.245l3.372-7.34a2.546 2.546 0 0 0-1.241-3.369l-20.087-9.27Z"
        fill="#3F3D56"
      />
      <path
        d="m25.34 105.612-.111-.051a.495.495 0 0 1-.285-.464.494.494 0 0 1 .32-.441.484.484 0 0 1 .373.016l.111.051a.487.487 0 0 1 .239.649.488.488 0 0 1-.647.24Zm4.757 5.162-6.104-2.817a.495.495 0 0 1-.254-.275.494.494 0 0 1 .126-.53.48.48 0 0 1 .352-.13.497.497 0 0 1 .185.045l6.104 2.817a.495.495 0 0 1 .285.464.494.494 0 0 1-.32.441.484.484 0 0 1-.374-.015Z"
        fill="#CCC"
      />
      <path
        d="M19.6 107.191a3.28 3.28 0 0 0 3.276-3.284 3.28 3.28 0 0 0-3.277-3.284 3.28 3.28 0 0 0-3.276 3.284 3.28 3.28 0 0 0 3.276 3.284Z"
        fill="#009F2B"
      />
      <path
        d="M206.745 32.742c0 28.543-47.118 70.439-100.765 70.439-53.648 0-93.51-41.896-93.51-70.439C12.47 4.2 61.601.203 115.25.203s91.495 3.997 91.495 32.54Z"
        fill="#FAFAFA"
      />
      <path
        d="M143.332 88.784H73.506a6.348 6.348 0 0 1-4.487-1.865 6.376 6.376 0 0 1-1.86-4.496V15.212a6.375 6.375 0 0 1 1.86-4.496 6.348 6.348 0 0 1 4.487-1.866h69.826a6.35 6.35 0 0 1 4.487 1.866 6.376 6.376 0 0 1 1.861 4.496v67.21a6.376 6.376 0 0 1-1.861 4.497 6.35 6.35 0 0 1-4.487 1.865Z"
        fill="#fff"
      />
      <path
        d="M143.332 88.784H73.506a6.348 6.348 0 0 1-4.487-1.865 6.376 6.376 0 0 1-1.86-4.496V15.212a6.375 6.375 0 0 1 1.86-4.496 6.348 6.348 0 0 1 4.487-1.866h69.826a6.35 6.35 0 0 1 4.487 1.866 6.376 6.376 0 0 1 1.861 4.496v67.21a6.376 6.376 0 0 1-1.861 4.497 6.35 6.35 0 0 1-4.487 1.865ZM73.506 9.404a5.796 5.796 0 0 0-4.096 1.702 5.821 5.821 0 0 0-1.7 4.106v67.21a5.821 5.821 0 0 0 1.7 4.106 5.796 5.796 0 0 0 4.096 1.703h69.826a5.797 5.797 0 0 0 4.097-1.703 5.824 5.824 0 0 0 1.699-4.105V15.212a5.824 5.824 0 0 0-1.699-4.106 5.798 5.798 0 0 0-4.097-1.703H73.506Z"
        fill="#3F3D56"
      />
      <path
        d="M107.512 33.338H95.783a1.117 1.117 0 0 1-1.036-.692 1.124 1.124 0 0 1 1.036-1.553h11.729a1.12 1.12 0 0 1 1.118 1.123 1.12 1.12 0 0 1-1.118 1.122Z"
        fill="#009F2B"
      />
      <path
        d="M133.804 37.93H95.783a1.119 1.119 0 0 1-1.12-1.123 1.124 1.124 0 0 1 1.12-1.122h38.021a1.119 1.119 0 0 1 1.12 1.122 1.124 1.124 0 0 1-1.12 1.123Z"
        fill="#E6E6E6"
      />
      <path
        d="M86.124 37.606a3.385 3.385 0 0 0 3.381-3.389 3.385 3.385 0 0 0-3.381-3.388 3.385 3.385 0 0 0-3.381 3.389 3.385 3.385 0 0 0 3.38 3.388Z"
        fill="#009F2B"
      />
      <path
        d="M74.808 20.457a3.385 3.385 0 0 0 3.381-3.388 3.385 3.385 0 0 0-3.38-3.389 3.385 3.385 0 0 0-3.382 3.389 3.385 3.385 0 0 0 3.381 3.389Z"
        fill="#F2F2F2"
      />
      <path
        d="M85.663 35.981a.375.375 0 0 1-.301-.15l-.923-1.233a.375.375 0 0 1-.023-.419.377.377 0 0 1 .625-.034l.604.807 1.55-2.33a.376.376 0 1 1 .627.416l-.001.002-1.845 2.773a.375.375 0 0 1-.303.168h-.01Z"
        fill="#fff"
      />
      <path
        d="M133.804 50.1H95.783a1.119 1.119 0 0 1-1.12-1.123 1.124 1.124 0 0 1 1.12-1.122h38.021a1.119 1.119 0 0 1 1.12 1.122 1.124 1.124 0 0 1-1.12 1.123Zm-47.68 2.442a3.652 3.652 0 0 1-3.38-2.263 3.673 3.673 0 0 1 .794-3.994 3.655 3.655 0 0 1 6.243 2.592 3.673 3.673 0 0 1-1.072 2.59 3.657 3.657 0 0 1-2.585 1.075Zm0-6.777a3.101 3.101 0 0 0-2.87 1.921 3.118 3.118 0 0 0 .674 3.391 3.103 3.103 0 0 0 5.301-2.2c0-.825-.328-1.616-.91-2.2a3.105 3.105 0 0 0-2.195-.912Zm21.388 16.892H95.783a1.119 1.119 0 0 1-1.122-1.123 1.124 1.124 0 0 1 1.122-1.122h11.729a1.119 1.119 0 0 1 1.118 1.122 1.12 1.12 0 0 1-1.118 1.122Zm26.292 4.591H95.783a1.118 1.118 0 0 1-1.12-1.122 1.124 1.124 0 0 1 1.12-1.123h38.021a1.119 1.119 0 0 1 1.12 1.123 1.124 1.124 0 0 1-1.12 1.122Zm-47.68-.047a3.651 3.651 0 0 1-3.38-2.262 3.672 3.672 0 0 1 .793-3.995 3.656 3.656 0 0 1 3.986-.794 3.659 3.659 0 0 1 2.258 3.386 3.673 3.673 0 0 1-1.072 2.59 3.657 3.657 0 0 1-2.585 1.075Zm0-6.777a3.101 3.101 0 0 0-2.87 1.92 3.12 3.12 0 0 0 .674 3.393 3.104 3.104 0 0 0 3.384.674 3.108 3.108 0 0 0 1.917-2.875 3.12 3.12 0 0 0-.91-2.2 3.106 3.106 0 0 0-2.195-.912Z"
        fill="#E6E6E6"
      />
      <path
        d="M76.345 16.796h-2.487l.944-.966a.234.234 0 0 0-.334-.327l-1.33 1.363a.234.234 0 0 0 0 .327l1.33 1.364a.233.233 0 1 0 .334-.327l-.943-.966h2.486a.233.233 0 0 0 .233-.234.234.234 0 0 0-.233-.234Z"
        fill="#3F3D56"
      />
      <path d="M50.993 159.273h2.732l1.3-10.563h-4.033v10.563Z" fill="#A0616A" />
      <path
        d="M50.897 162.13H59.3v-.107a3.28 3.28 0 0 0-.958-2.317 3.266 3.266 0 0 0-2.313-.96l-1.535-1.167-2.864 1.167h-.734v3.384Z"
        fill="#2F2E41"
      />
      <path d="M38.573 159.273h2.733l1.3-10.563h-4.034l.001 10.563Z" fill="#A0616A" />
      <path
        d="M38.477 162.13h8.403v-.107a3.28 3.28 0 0 0-.958-2.317 3.266 3.266 0 0 0-2.313-.96l-1.535-1.167-2.864 1.167h-.733v3.384Zm19.159-70.673s4.416 5.489 3.56 6.912c-.856 1.423-2.236.93-.856 2.421 1.38 1.492 1.933 1.509.966 2.607-.966 1.097-1.805 25.089-1.805 25.089l-4.405 24.964-4.847.438s-.905-3.051-.927-4.234c-.022-1.182-.022-.152-.022-2.603s.872-.552.022-2.885c-.85-2.332-1.91-9.203 0-12.544 1.91-3.341.41-.41.41-.41l-1.48-22.641-2.816 23.306s0 8.021-1.38 13.829l-.228 8.182-5.948-.228s-1.551-2.422-1-5.188c.553-2.766-1.655-4.149-1.655-5.532s.116-14.611.116-14.611l1.29-27.539s-1.13-6.253 1.353-8.742c2.484-2.49 19.652-.591 19.652-.591Z"
        fill="#2F2E41"
      />
      <path
        d="m44.476 42.502 5.796.276c-.045 1.696.879 3.296 2.771 4.799l3.157 3.26.828 7.19-.828 27.106 4.692 11.064c-6.305 2.469-13.674 3.564-24.012.83-1.165-1.246.324-8.509 1.002-13.931 0 0 1.467-2.26.143-3.893-1.325-1.633.511-11.772.511-11.772l.553-11.34c-.314-3.67-2.914-6.433-.026-8.711a16.813 16.813 0 0 0 5.413-4.878Z"
        fill="#009F2B"
      />
      <path
        d="m53.043 47.576 3.938 1.184 3.347 8.288-2.053 25.835s-.411 1.563.347 1.335c.757-.228.449 1.73.449 1.73l2.792 10.765-26.639-2.176 2.658-11.442s-1.96.063-.582-1.318c1.378-1.381.905-.543-.42-2.176a2.867 2.867 0 0 1-.376-3.215l-.591-8.09-.974-11.387a10.96 10.96 0 0 1 4.124-9.53c4.113-2.448 8.879-1.895 13.98.197Z"
        fill="#3F3D56"
      />
      <path
        d="M30.377 99.452a2.146 2.146 0 0 1 .53-2.94c.093-.065.19-.121.293-.17l-.717-7.438 3.638-1.693-.117 10.296a2.14 2.14 0 0 1-.755 2.496 2.052 2.052 0 0 1-1.524.337 2.03 2.03 0 0 1-1.348-.888Z"
        fill="#A0616A"
      />
      <path
        d="m27.773 78.735 2.76 14.106.328-.022 3.199-.23.337-.024-.276-12.724c-.734-.75.51-3.316 2.144-6.414.605-1.142 1.261-2.359 1.893-3.582.114-.218.224-.436.334-.655a37.696 37.696 0 0 0 2.065-4.694l-4.573-13.005-.116-.332s-.974 2.33-2.25 5.7c-.096.252-.193.51-.29.772-2.434 6.511-5.715 16.264-5.555 21.104Z"
        fill="#3F3D56"
      />
      <path
        d="M85.742 37.229a2.14 2.14 0 0 1-2.67 1.33 2.047 2.047 0 0 1-.31-.135l-5.525 5.02-3.527-1.914 8.31-6.055a2.132 2.132 0 0 1 2.448-.883 2.037 2.037 0 0 1 1.391 1.793 2.048 2.048 0 0 1-.117.844Z"
        fill="#A0616A"
      />
      <path
        d="M43.81 61.656s8.201-2.032 15.8-4.724c.201-.07.399-.142.596-.214 4.323-1.558 8.371-3.318 10.509-5.024l9.644-10.643-.215-.25-2.096-2.432-.22-.257-10.017 7.82c-.16 1.013-2.833 1.546-6.183 2.07-.187.03-.386.145-.573.086-3.152-.98-6.712.64-9.37 1.835l-7.874 11.733Z"
        fill="#3F3D56"
      />
      <path
        d="M47.635 41.618c3.829 0 6.932-3.11 6.932-6.947 0-3.836-3.103-6.946-6.932-6.946-3.828 0-6.931 3.11-6.931 6.946 0 3.837 3.103 6.947 6.931 6.947Z"
        fill="#A0616A"
      />
      <path
        d="M43.074 41.936c1.16-.546 2.513-.214 3.793-.164 1.28.05 2.831-.433 3.103-1.687.2-.928-.403-1.944-.023-2.814.415-.948 1.66-1.083 2.658-1.348a6.126 6.126 0 0 0 3.15-2.149 6.148 6.148 0 0 0 1.274-3.599c.07.518-.815.688-1.105.254-.29-.434-.09-1.035.23-1.447.32-.412.752-.742.994-1.205.242-.463.195-1.151-.277-1.374a3.86 3.86 0 0 1-2.44 2.011c.215-.653-.088-1.387-.577-1.87a5.584 5.584 0 0 0-1.762-1.04c-1.598-.695-3.464-1.385-5.011-.585a2.997 2.997 0 0 0-1.55 2.102c-2.861.242-5.8 3.35-5.638 6.223.176 3.094.304 3.345 2.874 8.551"
        fill="#2F2E41"
      />
      <path
        d="m12.725 162.715.002-.082a9.467 9.467 0 0 1 3.528-7.121 9.172 9.172 0 0 1 1.967-1.188l.067-.029.011.072c.136.867.352 1.751.452 2.144l.673-2.632.075-.022a1.785 1.785 0 0 1 1.91.612 1.825 1.825 0 0 1 .189 2.035c-.157.293-.311.598-.46.894-.513 1.015-1.043 2.066-1.815 2.882a5.695 5.695 0 0 1-4.6 1.719l-1.999.716Z"
        fill="#F2F2F2"
      />
      <path
        d="m78.802 162.623-66.169.085a.33.33 0 0 1 0-.659l66.17-.085a.328.328 0 0 1 .328.329.328.328 0 0 1-.329.33Z"
        fill="#CACACA"
      />
    </svg>
  );
}

export function SvgTimeQuarterPast(props) {
  return (
    <svg width={props.size || '12px'} height={props.size || '12px'} viewBox="0 0 12 12" fill="none" {...props}>
      <path
        d="M7.75 6.75h-1.1a1 1 0 0 1-1.4-1.4V3.5a.75.75 0 0 1 1.5 0v1.75h1a.75.75 0 0 1 0 1.5ZM6 0a.75.75 0 1 0 0 1.5A4.5 4.5 0 0 1 10.5 6 .75.75 0 1 0 12 6a6.006 6.006 0 0 0-6-6ZM1.5 6.25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0ZM3.37.947a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM1.457 2.875a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm1.913 7.178a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM1.457 8.125a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM6 10.5A.75.75 0 1 0 6 12a.75.75 0 0 0 0-1.5Zm4.553-2.62a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM8.625 9.793a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z"
        fill="#C3C3C3"
      />
    </svg>
  );
}

export function SvgAnonymous(props) {
  return (
    <svg width={props.size || '55px'} height={props.size || '55px'} viewBox="0 0 55 55" fill="none" {...props}>
      <mask
        id="anonymous"
        style={{
          maskType: 'luminance',
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={55}
        height={55}
      >
        <path
          d="M27.43 54.478c14.91 0 26.997-12.087 26.999-26.997C54.43 12.57 42.344.484 27.434.484S.436 12.57.434 27.48c0 14.91 12.085 26.997 26.995 26.997Z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#anonymous)">
        <path
          d="M32.836 36.946c1.672-1.513 2.917-3.698 3.731-6.15.49.672 1.232 0 1.326-.633-.008-.961 1.778-5.32-.24-5.152l-.025.053c1.37-18.548-21.768-18.524-20.384.008l-.029-.061c-2.02-.162-.232 4.183-.24 5.152.09.629.835 1.308 1.326.63.808 2.453 2.06 4.641 3.732 6.153 1.583 1.226 3.43 1.932 5.404 1.932 1.975 0 3.816-.706 5.4-1.932Z"
          fill="#FDBC91"
        />
        <path
          d="M32.615 38.55a8.1 8.1 0 0 1 .185-1.567c.014-.011.026-.025.039-.035-1.583 1.226-3.43 1.932-5.404 1.932-1.974 0-3.821-.706-5.404-1.932l.037.035a8.25 8.25 0 0 1 .187 1.565c1.531 1.123 3.297 1.765 5.18 1.765 1.883 0 3.645-.645 5.18-1.764Z"
          fill="#F2AD80"
        />
        <path
          d="M48.075 46.298c-2.214-3.636-9.563-3.741-12.728-3.713-2.038 0-2.776-2.01-2.734-4.032-1.532 1.121-3.299 1.763-5.18 1.763-1.881 0-3.649-.642-5.18-1.765.043 2.025-.693 4.031-2.734 4.034-3.166-.023-10.517.082-12.728 3.713-2.212 3.63-3.4 8.18-3.4 8.18h48.087s-1.188-4.545-3.403-8.18Z"
          fill="#FDBC91"
        />
        <path
          d="M31.435 18.682c-2.505.417-5.064.298-7.557-.194-1.897-.375-3.88-.207-4.19 1.989-.615 4.354-1.988 7.293-1.988 7.293s-.853-4.165-1.09-7.195c-.768-6.223.97-8.619 4.82-10.67 1.713-.915 4.263-1.557 6.538-1.778 6.342-.615 11.933 4.26 9.797 8.046 0 0 1.326 1.042.852 2.982-.473 1.94-1.278 8.377-1.278 8.377s-.852-3.123-1.136-6.099c-.21-2.253-1.54-3.291-4.768-2.751Z"
          fill="#6B3911"
        />
        <path
          d="m34.15 43.854 1.466-1.278h-.265c-.247 0-.493-.032-.73-.098-4.32 4.11-10.052 4.11-14.372 0a2.723 2.723 0 0 1-.726.098h-.227l1.682 1.41a10.139 10.139 0 0 0 13.171-.132Z"
          fill="#00619E"
        />
        <path
          d="M48.075 46.298c-2.153-3.537-9.163-3.732-12.463-3.72l-1.462 1.276a10.138 10.138 0 0 1-13.171.133l-1.688-1.413c-3.276-.014-10.342.167-12.503 3.72-2.214 3.636-3.4 8.18-3.4 8.18h48.087s-1.186-4.54-3.4-8.176Z"
          fill="#2099DC"
        />
      </g>
    </svg>
  );
}

export function SvgNoOverdueTask(props) {
  return (
    <svg width={props.size || '215px'} height={props.size || '124px'} viewBox="0 0 215 124" fill="none" {...props}>
      <path
        d="M198.5 49.47c0 26.301-43.898 64.909-93.88 64.909-49.981 0-87.12-38.608-87.12-64.91 0-26.301 45.776-29.985 95.757-29.985 49.982 0 85.243 3.684 85.243 29.985Z"
        fill="#FAFAFA"
      />
      <path d="M168.764 22.156H38V103.2h130.764V22.156Z" fill="#E6E6E6" />
      <path
        d="M70.718 37.77h-23.95v15.493h23.95V37.77Zm29.759 0h-23.95v15.493h23.95V37.77Zm29.759 0h-23.949v15.493h23.949V37.77Zm29.759 0h-23.949v15.493h23.949V37.77ZM70.718 59.7h-23.95v15.493h23.95V59.699Zm29.759 0h-23.95v15.493h23.95V59.699Zm29.759 0h-23.949v15.493h23.949V59.699Zm29.759 0h-23.949v15.493h23.949V59.699ZM70.718 81.628h-23.95v15.494h23.95V81.628Zm29.759 0h-23.95v15.494h23.95V81.628Zm29.759 0h-23.949v15.494h23.949V81.628Zm29.759 0h-23.949v15.494h23.949V81.628ZM72.248 31.691c1.984 0 3.592-1.6 3.592-3.575a3.584 3.584 0 0 0-3.592-3.576 3.584 3.584 0 0 0-3.593 3.576 3.584 3.584 0 0 0 3.593 3.575Zm59.394 0c1.984 0 3.593-1.6 3.593-3.575a3.585 3.585 0 0 0-3.593-3.576 3.584 3.584 0 0 0-3.592 3.576 3.584 3.584 0 0 0 3.592 3.575Z"
        fill="#fff"
      />
      <path d="M73.684 12.622h-2.873V29.07h2.873V12.622Zm59.395 0h-2.874V29.07h2.874V12.622Z" fill="#E6E6E6" />
      <path
        d="M94.087 44.38a5.36 5.36 0 0 1-1.325 3.522 5.42 5.42 0 0 1-7.01.986 5.378 5.378 0 0 1-2.253-3.019 5.352 5.352 0 0 1 .286-3.75 5.388 5.388 0 0 1 2.685-2.645 5.424 5.424 0 0 1 3.77-.247 5.398 5.398 0 0 1 3.01 2.274c.548.861.838 1.86.837 2.88Zm29 23a5.36 5.36 0 0 1-1.325 3.522 5.421 5.421 0 0 1-7.01.986 5.374 5.374 0 0 1-2.253-3.019 5.348 5.348 0 0 1 .286-3.75 5.384 5.384 0 0 1 2.685-2.645 5.423 5.423 0 0 1 3.77-.247 5.395 5.395 0 0 1 3.01 2.274c.548.861.838 1.86.837 2.88Z"
        fill="#E83A3A"
      />
      <path
        d="m93.25 41.502-5.33 5.305c-.336-.516-2.203-2.916-2.203-2.916.24-.24.495-.465.764-.671l1.548 2.054 4.597-4.575c.233.248.442.516.624.803Zm29 23-5.331 5.305c-.335-.516-2.202-2.916-2.202-2.916.24-.24.495-.465.764-.671l1.548 2.054 4.597-4.575c.233.248.442.516.624.803Z"
        fill="#fff"
      />
      <path
        d="M64.087 89.38a5.36 5.36 0 0 1-1.325 3.522 5.421 5.421 0 0 1-7.01.986 5.378 5.378 0 0 1-2.253-3.019 5.352 5.352 0 0 1 .286-3.75 5.388 5.388 0 0 1 2.685-2.645 5.424 5.424 0 0 1 3.77-.247 5.398 5.398 0 0 1 3.01 2.274c.548.861.838 1.86.837 2.88Z"
        fill="#E83A3A"
      />
      <path
        d="m63.25 86.502-5.33 5.305c-.336-.516-2.203-2.916-2.203-2.916.24-.24.495-.465.765-.671l1.548 2.054 4.596-4.575c.233.248.442.516.625.803Z"
        fill="#fff"
      />
      <path
        d="M154.671 117.306c16.229 0 29.385-13.157 29.385-29.386S170.9 58.535 154.671 58.535s-29.385 13.156-29.385 29.385 13.156 29.386 29.385 29.386Z"
        fill="#3F3D56"
      />
      <path
        d="M154.671 114.873c14.886 0 26.953-12.067 26.953-26.953 0-14.885-12.067-26.952-26.953-26.952-14.885 0-26.952 12.067-26.952 26.953 0 14.885 12.067 26.952 26.952 26.952Z"
        fill="#fff"
      />
      <path
        d="M154.574 91.618a3.6 3.6 0 1 0 0-7.2 3.6 3.6 0 0 0 0 7.2Zm.778-29.288h-1.557v2.92h1.557v-2.92Zm0 48.457h-1.557v2.919h1.557v-2.919Zm-23.547-21.99V87.24h-2.919v1.557h2.919Zm48.457 0V87.24h-2.919v1.557h2.919Z"
        fill="#3F3D56"
      />
      <path
        d="m153.536 89.581 1.33-3.042 16.672 9.233-18.002-6.19Zm4.93-38.148h-7.59v8.757h7.59v-8.757Z"
        fill="#3F3D56"
      />
      <path
        d="M154.671 53.865c4.837 0 8.757-1.089 8.757-2.432 0-1.344-3.92-2.433-8.757-2.433-4.836 0-8.757 1.09-8.757 2.433 0 1.343 3.921 2.432 8.757 2.432Z"
        fill="#3F3D56"
      />
      <path
        d="m171.067 93.126-.487.681s-2.238 2.628-2.335 1.363c-.098-1.265 1.654-2.14 1.654-2.14l.973-.585.195.681Zm13.85 2.298.407.731s1.417 3.147.232 2.694c-1.185-.453-1.227-2.411-1.227-2.411l-.111-1.13.699.116Z"
        fill="#FFB8B8"
      />
      <path d="M182.727 82.459a2.962 2.962 0 1 0 0-5.925 2.962 2.962 0 0 0 0 5.925Z" fill="#2F2E41" />
      <path
        d="m182.451 103.83.389 2.53v.778h2.238v-.973s.097-1.751-.292-2.238c-.389-.486-2.335-.097-2.335-.097Zm-3.989 0 .389 2.53v.778h2.238v-.973s.097-1.751-.292-2.238c-.389-.486-2.335-.097-2.335-.097Z"
        fill="#FFB8B8"
      />
      <path
        d="M179.967 83.509s-.86.454-.272 1.486c.588 1.031 4.037 11.708 4.037 11.708l1.99-.565-1.755-6.752-1.005-4.244-2.995-1.633Z"
        fill="#E6E6E6"
      />
      <path d="M182.402 82.57a2.238 2.238 0 1 0 0-4.476 2.238 2.238 0 0 0 0 4.476Z" fill="#FFB8B8" />
      <path d="m183.424 80.672-.292 4.573-2.043-1.46s.681-2.724.486-2.918l1.849-.195Z" fill="#FFB8B8" />
      <path
        d="m183.424 84.855-2.201-1.63s-1.01-.413-1.302.074c-.292.486-1.751 7.686-.973 9.049 0 0 4.184.875 5.06.389l.389-2.53s.487-1.557-.292-2.53l-.681-2.822Z"
        fill="#E6E6E6"
      />
      <path
        d="M180.505 83.396s-.779-.584-1.46.39c-.681.973-8.854 8.66-8.854 8.66l1.362 1.556 5.352-4.476 3.405-2.724.195-3.406Z"
        fill="#E6E6E6"
      />
      <path
        d="M184.057 92.689s-4.817-.924-5.303-.243l-.098 1.07s-1.07 2.043-.486 5.352c.584 3.308.194 5.351.194 5.351s2.627-.292 4.574 0c1.946.292 2.237 0 2.237 0l-1.118-11.53Zm1.216 14.059-2.822.097.973 7.298s-.778 3.114.097 3.308a9.903 9.903 0 0 0 1.849.195s.876.876 1.849.778a5.422 5.422 0 0 0 1.848-.584s.195-.583-.486-.778c-.681-.195-2.53-.778-2.919-2.822l-.389-7.492Z"
        fill="#2F2E41"
      />
      <path
        d="m181.283 106.748-2.821.097.973 7.298s-.779 3.114.097 3.308a9.903 9.903 0 0 0 1.849.195s.875.876 1.848.778a5.42 5.42 0 0 0 1.849-.584s.195-.583-.486-.778c-.682-.195-2.53-.778-2.919-2.822l-.39-7.492Zm2.48-29.144a1.226 1.226 0 1 0 0-2.452 1.226 1.226 0 0 0 0 2.452Z"
        fill="#2F2E41"
      />
      <path
        d="M185.398 75.713a1.23 1.23 0 0 0-1.099-1.22c.043-.003.085-.006.128-.006a1.227 1.227 0 1 1-.128 2.446 1.226 1.226 0 0 0 1.099-1.22Zm-3.016 4.381c1.129 0 2.043-.55 2.043-1.226 0-.677-.914-1.226-2.043-1.226-1.128 0-2.043.549-2.043 1.226 0 .677.915 1.226 2.043 1.226Z"
        fill="#2F2E41"
      />
    </svg>
  );
}

export function SvgNoLastTaskFound(props) {
  return (
    <svg width={props.size || '215px'} height={props.size || '124px'} viewBox="0 0 215 124" fill="none" {...props}>
      <path
        d="M198.5 49.47c0 26.301-43.898 64.909-93.88 64.909-49.981 0-87.12-38.608-87.12-64.91 0-26.301 45.776-29.985 95.757-29.985 49.982 0 85.243 3.684 85.243 29.985Z"
        fill="#FAFAFA"
      />
      <path d="M173.478 22.156H42.714V103.2h130.764V22.156Z" fill="#E6E6E6" />
      <path
        d="M75.432 37.77h-23.95v15.493h23.95V37.77Zm29.759 0h-23.95v15.493h23.95V37.77Zm29.759 0H111v15.493h23.95V37.77Zm29.759 0H140.76v15.493h23.949V37.77ZM75.432 59.7h-23.95v15.493h23.95V59.699Zm29.759 0h-23.95v15.493h23.95V59.699Zm29.759 0H111v15.493h23.95V59.699Zm29.759 0H140.76v15.493h23.949V59.699ZM75.432 81.628h-23.95v15.494h23.95V81.628Zm29.759 0h-23.95v15.494h23.95V81.628Zm29.759 0H111v15.494h23.95V81.628Zm29.759 0H140.76v15.494h23.949V81.628ZM76.962 31.691c1.984 0 3.592-1.6 3.592-3.575a3.584 3.584 0 0 0-3.592-3.576 3.584 3.584 0 0 0-3.593 3.576 3.584 3.584 0 0 0 3.593 3.575Zm59.394 0c1.984 0 3.593-1.6 3.593-3.575a3.585 3.585 0 0 0-3.593-3.576 3.584 3.584 0 0 0-3.592 3.576 3.584 3.584 0 0 0 3.592 3.575Z"
        fill="#fff"
      />
      <path d="M78.398 12.622h-2.874V29.07h2.874V12.622Zm59.395 0h-2.874V29.07h2.874V12.622Z" fill="#E6E6E6" />
      <path
        d="M158.15 45.517a5.356 5.356 0 0 1-1.325 3.522 5.422 5.422 0 0 1-7.01.986 5.374 5.374 0 0 1-2.253-3.02 5.348 5.348 0 0 1 .286-3.75 5.388 5.388 0 0 1 2.685-2.645 5.426 5.426 0 0 1 3.771-.246 5.396 5.396 0 0 1 3.009 2.274c.548.861.838 1.86.837 2.879Z"
        fill="#009F2B"
      />
      <path
        d="m157.313 42.637-5.331 5.305c-.335-.517-2.202-2.916-2.202-2.916.24-.24.495-.465.764-.671l1.548 2.054 4.597-4.575c.233.247.442.516.624.803Z"
        fill="#fff"
      />
      <path
        d="M98.632 67.445a5.36 5.36 0 0 1-1.325 3.522 5.421 5.421 0 0 1-7.01.986 5.378 5.378 0 0 1-2.253-3.02 5.352 5.352 0 0 1 .286-3.75 5.388 5.388 0 0 1 2.685-2.645 5.425 5.425 0 0 1 3.77-.246 5.398 5.398 0 0 1 3.01 2.273c.548.862.838 1.86.837 2.88Z"
        fill="#009F2B"
      />
      <path
        d="m97.795 64.566-5.33 5.305c-.336-.516-2.203-2.915-2.203-2.915.24-.24.495-.465.765-.672l1.547 2.055 4.597-4.575c.233.247.442.516.624.802Z"
        fill="#fff"
      />
      <path
        d="M68.873 67.445a5.36 5.36 0 0 1-1.325 3.522 5.421 5.421 0 0 1-7.01.986 5.378 5.378 0 0 1-2.253-3.02 5.352 5.352 0 0 1 .286-3.75 5.389 5.389 0 0 1 2.685-2.645 5.425 5.425 0 0 1 3.77-.246 5.398 5.398 0 0 1 3.01 2.273c.548.862.838 1.86.837 2.88Z"
        fill="#009F2B"
      />
      <path
        d="m68.036 64.566-5.33 5.305c-.336-.516-2.203-2.915-2.203-2.915.24-.24.495-.465.764-.672l1.548 2.055 4.597-4.575c.233.247.442.516.624.802Z"
        fill="#fff"
      />
    </svg>
  );
}

export function SvgSuspendedUser(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 15 15" fill="none" {...props}>
      <path
        d="M5.333.5a3.67 3.67 0 0 0-3.666 3.667V6c0 .643.523 1.167 1.166 1.167h2.5A2.33 2.33 0 0 1 3 4.833c1.555 0 2.333-1.166 2.333-2.333 0 1.167.778 2.333 2.334 2.333a2.33 2.33 0 0 1-2.334 2.334h2.5C8.477 7.167 9 6.643 9 6V4.167A3.67 3.67 0 0 0 5.333.5Zm2.471 8H2.5A2.503 2.503 0 0 0 0 11v2.333a.5.5 0 0 0 .5.5h6.104a5.296 5.296 0 0 1 1.2-5.333Z"
        fill="currentColor"
        opacity=".5"
      />
      <path
        d="M10.668 8.13a3.339 3.339 0 0 0-3.335 3.335 3.339 3.339 0 0 0 3.335 3.335 3.339 3.339 0 0 0 3.335-3.335 3.339 3.339 0 0 0-3.335-3.335Zm0 .77c.569 0 1.09.191 1.515.506L8.61 12.98a2.543 2.543 0 0 1-.506-1.515 2.568 2.568 0 0 1 2.565-2.566Zm0 5.13a2.54 2.54 0 0 1-1.515-.506l3.575-3.574c.314.426.506.946.506 1.515a2.568 2.568 0 0 1-2.566 2.565Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function SvgIcChangeManager(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 14 14" fill="none" {...props}>
      <g clipPath="url(#change)" fill="currentColor">
        <path d="M3.063 3.5a1.75 1.75 0 1 1 0-3.5 1.75 1.75 0 0 1 0 3.5Zm0-2.625a.875.875 0 1 0 0 1.75.875.875 0 0 0 0-1.75Z" />
        <path d="M5.25 7H.875a.437.437 0 0 1-.438-.438V5.25a2.625 2.625 0 0 1 5.25 0v1.313A.437.437 0 0 1 5.25 7Zm-3.938-.875h3.5V5.25a1.75 1.75 0 1 0-3.5 0v.875Zm9.626 4.375a1.75 1.75 0 1 1 0-3.5 1.75 1.75 0 0 1 0 3.5Zm0-2.625a.875.875 0 1 0 0 1.75.875.875 0 0 0 0-1.75Z" />
        <path d="M13.125 14H8.75a.438.438 0 0 1-.438-.438V12.25a2.625 2.625 0 0 1 5.25 0v1.313a.438.438 0 0 1-.437.437Zm-3.938-.875h3.5v-.875a1.75 1.75 0 0 0-3.5 0v.875Zm1.751-7a.438.438 0 0 1-.438-.438V3.5a1.314 1.314 0 0 0-1.313-1.313H6.126a.437.437 0 1 1 0-.874h3.063A2.19 2.19 0 0 1 11.374 3.5v2.188a.438.438 0 0 1-.438.437Z" />
        <path d="M10.938 6.125a.436.436 0 0 1-.31-.128l-.875-.875a.438.438 0 0 1 .619-.619l.566.566.565-.566a.437.437 0 0 1 .619.619l-.875.875a.436.436 0 0 1-.31.128ZM7 12.688H3.937A2.19 2.19 0 0 1 1.75 10.5V8.312a.437.437 0 1 1 .875 0V10.5a1.314 1.314 0 0 0 1.313 1.313H7a.438.438 0 0 1 0 .874Z" />
        <path d="M3.062 9.625a.436.436 0 0 1-.309-.128l-.566-.566-.565.566a.438.438 0 0 1-.619-.619l.875-.875a.437.437 0 0 1 .619 0l.875.875a.438.438 0 0 1-.31.747Z" />
      </g>
      <defs>
        <clipPath id="change">
          <path fill="#fff" d="M0 0h14v14H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SvgIcIntervention(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 14 15" fill="none" {...props}>
      <path
        d="M13.46 2.654 12.148 1.34a.328.328 0 0 0-.464 0L7.746 5.28a.328.328 0 0 0-.096.232v1.312c0 .181.147.328.328.328h1.313c.087 0 .17-.034.232-.096l3.937-3.937a.328.328 0 0 0 0-.464ZM9.155 6.495h-.848v-.848l3.609-3.61.848.849-3.609 3.61Z"
        fill="currentColor"
      />
      <path
        d="M12.572 5.183a.328.328 0 0 0-.328.328v4.593a.986.986 0 0 1-.985.985H7.98a.326.326 0 0 0-.198.065l-2.1 1.575v-1.312a.328.328 0 0 0-.328-.328H2.072a.985.985 0 0 1-.984-.985V4.198c0-.543.44-.984.984-.984h5.906a.328.328 0 1 0 0-.656H2.072a1.64 1.64 0 0 0-1.64 1.64v5.906c0 .906.734 1.64 1.64 1.641h2.953v1.64a.328.328 0 0 0 .525.263l2.538-1.903h3.171c.906 0 1.64-.735 1.641-1.64V5.51a.328.328 0 0 0-.328-.328Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={0.5}
      />
      <path
        d="M6.01 4.526H2.727a.328.328 0 1 0 0 .657H6.01a.328.328 0 1 0 0-.657ZM2.728 7.151H6.01a.328.328 0 0 0 0-.656H2.73a.328.328 0 1 0 0 .656Zm0 1.969h7.875a.328.328 0 0 0 0-.656H2.728a.328.328 0 1 0 0 .656Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function SvgIcViewIntervention(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 14 15" fill="none" {...props}>
      <g clipPath="url(#view)">
        <path
          d="M5.879 13.953a.547.547 0 0 1-.547.547H2.926a2.19 2.19 0 0 1-2.188-2.188V2.688A2.19 2.19 0 0 1 2.926.5h6.723a2.19 2.19 0 0 1 2.188 2.188V7.91a.547.547 0 0 1-1.094 0V2.687c0-.603-.49-1.093-1.094-1.093H2.926c-.603 0-1.094.49-1.094 1.093v9.626c0 .603.49 1.093 1.094 1.093h2.406c.302 0 .547.245.547.547ZM9.102 3.781H3.47a.547.547 0 1 0 0 1.094h5.632a.547.547 0 0 0 0-1.094Zm.547 2.735a.547.547 0 0 0-.547-.547H3.47a.547.547 0 1 0 0 1.093h5.632a.547.547 0 0 0 .547-.546Zm-6.18 1.64a.547.547 0 1 0 0 1.094h2.875a.547.547 0 1 0 0-1.094H3.47Zm9.72 4.006c-.019.027-.085.12-.125.172-.184.23-.612.77-1.209 1.246-.765.61-1.552.92-2.34.92-.787 0-1.574-.31-2.339-.92a7.675 7.675 0 0 1-1.208-1.246 4.66 4.66 0 0 1-.126-.172.547.547 0 0 1 0-.629 7.691 7.691 0 0 1 1.334-1.418c.765-.61 1.552-.92 2.34-.92.787 0 1.574.31 2.34.92.596.476 1.024 1.016 1.207 1.246.041.052.107.145.127.172a.547.547 0 0 1 0 .629Zm-1.14-.314c-.87-1.035-1.721-1.559-2.533-1.559-.813 0-1.664.524-2.534 1.559.87 1.034 1.721 1.558 2.534 1.558.812 0 1.663-.524 2.533-1.558Zm-2.506-1.04a1.039 1.039 0 1 0 0 2.079 1.039 1.039 0 0 0 0-2.078Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="view">
          <path fill="#fff" transform="translate(0 .5)" d="M0 0h14v14H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function IcKpiAffiliates(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M5.644 14.511h1.334V8.4H5.644v6.111Zm3.69 0h1.333V5.49H9.333v9.022Zm3.688 0h1.334v-3.289h-1.334v3.29ZM3.333 18a1.28 1.28 0 0 1-.933-.4 1.28 1.28 0 0 1-.4-.933V3.333c0-.355.133-.666.4-.933s.578-.4.933-.4h13.334c.355 0 .666.133.933.4s.4.578.4.933v13.334c0 .355-.133.666-.4.933a1.28 1.28 0 0 1-.933.4H3.333Zm0-1.333h13.334V3.333H3.333v13.334Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function IcKpiSupport(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 20 20" fill="none" {...props}>
      <path d="M2 18V7h3.5v11H2Zm6.25 0V2h3.5v16h-3.5Zm6.25 0v-7H18v7h-3.5Z" fill="currentColor" />
    </svg>
  );
}

export function IcProductivity(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="m6.875 6.5-.77-1.646-1.647-.77 1.646-.771.771-1.646.77 1.645 1.647.771-1.646.771L6.875 6.5ZM12.5 9.02l-.646-1.374L10.48 7l1.375-.646.646-1.375.646 1.375L14.52 7l-1.375.646L12.5 9.02Zm-9.646 1.668-.646-1.376-1.375-.645 1.375-.646.646-1.375L3.5 8.02l1.375.646-1.375.646-.646 1.374Zm.604 6.395-.958-.958 6.25-6.25 3.333 3.354 6.209-6.958.875.854-7.084 7.98-3.333-3.313-5.292 5.291Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function IcKpiSales(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 20 20" fill="none" {...props}>
      <g clipPath="url(#a)" fill="currentColor" stroke="currentColor" strokeWidth={0.4}>
        <path d="M11.103 1.111a.357.357 0 0 0-.356.357v7.494a.357.357 0 0 0 .356.357h7.495a.356.356 0 0 0 .356-.357 7.847 7.847 0 0 0-7.85-7.85Zm.357 7.495V1.833a7.148 7.148 0 0 1 6.772 6.773H11.46Z" />
        <path d="M16.457 10.747H9.319V3.609a.357.357 0 0 0-.357-.357 7.851 7.851 0 1 0 7.851 7.851.357.357 0 0 0-.356-.356ZM8.962 18.24a7.138 7.138 0 0 1-.356-14.267v7.13a.356.356 0 0 0 .356.356h7.13a7.146 7.146 0 0 1-7.13 6.781Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="currentColor" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
export function SvgIcApplyDiscount(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 22 23" fill="none" {...props}>
      <path
        d="M17.203 10.703c.06-.192.093-.392.097-.593V7.32c0-1.99-3-3.49-6.978-3.49-3.978 0-6.977 1.5-6.977 3.49v2.79a2.715 2.715 0 0 0 1.494 2.2c-.078.184-.125.38-.14.58v2.79c0 1.99 3 3.49 6.978 3.49 3.978 0 6.979-1.5 6.979-3.49v-2.785a2.639 2.639 0 0 0-1.453-2.192Zm-6.88 2.896a9.524 9.524 0 0 0 6.099-1.745c.557.33.837.691.837 1.04 0 .851-2.177 2.09-5.583 2.09-3.405 0-5.517-1.202-5.582-2.054 1.36.462 2.792.688 4.23.67Zm0-8.373c3.41 0 5.583 1.242 5.583 2.09 0 .848-2.177 2.09-5.583 2.09-3.405 0-5.582-1.242-5.582-2.09 0-.848 2.177-2.09 5.582-2.09ZM4.741 9.454a10.418 10.418 0 0 0 5.582 1.354c1.95.081 3.885-.388 5.582-1.354v.66c0 .852-2.177 2.09-5.583 2.09s-5.582-1.242-5.582-2.09v-.66Zm6.935 8.326c-3.41 0-5.582-1.242-5.582-2.09v-.66a10.418 10.418 0 0 0 5.582 1.354 10.413 10.413 0 0 0 5.583-1.354v.66c0 .852-2.177 2.09-5.583 2.09Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function SvgIcMarketing(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 22 23" fill="none" {...props}>
      <path
        d="M13.218 8.288c-1.777-2.613-4.149-4.002-5.391-3.15a1.433 1.433 0 0 0-.351.353c0 .01-2.876 5.83-2.876 5.83l-1.606 1.088a2.268 2.268 0 0 0-.602 3.15l.072.107a2.272 2.272 0 0 0 3.137.602l2.58 3.8c.378.467 1.107.932 2.006.384a1.359 1.359 0 0 0 .602-.923 1.438 1.438 0 0 0-.223-1.083l-2.271-3.352s5.37-.428 5.39-.436a1.29 1.29 0 0 0 .468-.2c.638-.434.867-1.343.646-2.561-.199-1.122-.763-2.392-1.581-3.609ZM3.048 15.27l-.072-.106a1.564 1.564 0 0 1 .418-2.173l1.386-.944 1.83 2.696-1.386.943a1.566 1.566 0 0 1-2.176-.415Zm6.94 3.57a.742.742 0 0 1-1.232.83l-2.57-3.787 1.033-.703.273-.022 2.496 3.683Zm-2.713-4.37L5.28 11.532l1.903-3.88c.184 1.09.724 2.384 1.587 3.655.863 1.27 1.867 2.25 2.81 2.824l-4.305.339Zm5.92-.468c-.959-.062-2.52-1.144-3.843-3.093C8.03 8.961 7.6 7.116 7.895 6.2a.855.855 0 0 1 .803-.602c.951 0 2.57 1.088 3.932 3.093.766 1.128 1.324 2.308 1.477 3.34.299 1.972-.912 1.972-.912 1.972Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={0.3}
      />
      <path
        d="M10.708 8.363a1.885 1.885 0 0 0-1.429.295.353.353 0 1 0 .402.58 1.204 1.204 0 1 1 1.353 1.993.351.351 0 0 0 .2.64.344.344 0 0 0 .2-.06 1.904 1.904 0 0 0-.712-3.448h-.014Zm2.942-2.517h.035a.351.351 0 0 0 .35-.316l.27-2.633a.35.35 0 0 0-.312-.395.351.351 0 0 0-.386.323l-.27 2.635a.351.351 0 0 0 .314.386Zm4.541-.542a.353.353 0 0 0-.488-.1l-2.446 1.605a.352.352 0 0 0 .2.644.357.357 0 0 0 .201-.056l2.447-1.605a.35.35 0 0 0 .086-.488Zm.749 4.286-2.846-.511a.352.352 0 0 0-.125.692l2.844.512h.062a.351.351 0 0 0 .063-.698l.002.006Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={0.3}
      />
    </svg>
  );
}

export function SvgIcSetting(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 22 23" fill="none" {...props}>
      <path
        d="m19.358 9.376-.771.615a1.913 1.913 0 0 0 0 3.018l.773.617.34.272-.223.374-1.525 2.561-.212.356-.388-.142-.938-.34c-1.22-.443-2.524.311-2.731 1.515l-.165.956-.071.416H9.553l-.071-.416-.165-.956c-.207-1.206-1.513-1.957-2.732-1.515l-.937.34-.388.142-.212-.356-1.525-2.56-.224-.375.341-.272.773-.617a1.913 1.913 0 0 0 0-3.018l-.773-.617-.34-.272.223-.374 1.525-2.561.212-.355.388.14.937.34c1.22.444 2.525-.31 2.732-1.514l.165-.956.071-.416h3.894l.071.416.165.956c.207 1.206 1.513 1.957 2.732 1.515l.937-.34.388-.141.212.355 1.526 2.56.201.34-.282.275h-.001l-.001.001-.002.002-.004.004m-.504 3.356a1.534 1.534 0 0 1 0-2.41l.773-.617a.873.873 0 0 0 .217-1.142l-1.526-2.56a.969.969 0 0 0-1.165-.4l-.937.34c-.92.334-1.95-.222-2.119-1.2l-.164-.956a.934.934 0 0 0-.939-.76h-3.05c-.48 0-.865.33-.939.76l-.164.957c-.169.979-1.202 1.532-2.119 1.199l-.937-.34a.969.969 0 0 0-1.165.4l-1.526 2.56a.873.873 0 0 0 .217 1.142l.772.617c.78.623.78 1.789 0 2.41l-.772.617a.873.873 0 0 0-.217 1.142l1.526 2.56a.969.969 0 0 0 1.165.4l.937-.34c.92-.334 1.95.223 2.118 1.2l.165.956c.074.43.458.76.938.76h3.051c.48 0 .865-.33.939-.76l.164-.956c.168-.98 1.201-1.533 2.119-1.2l.937.34a.969.969 0 0 0 1.165-.4l1.526-2.56a.873.873 0 0 0-.217-1.143l-.773-.616ZM8.421 11.5c0-1.622 1.367-2.969 3.079-2.969 1.712 0 3.079 1.347 3.079 2.969 0 1.622-1.367 2.969-3.08 2.969-1.711 0-3.078-1.347-3.078-2.969Zm.45 0c0 1.428 1.194 2.563 2.629 2.563s2.628-1.135 2.628-2.563c0-1.428-1.193-2.563-2.628-2.563S8.872 10.072 8.872 11.5Z"
        stroke="currentColor"
      />
    </svg>
  );
}

export function SvgIcPayment(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 22 23" fill="none" {...props}>
      <path
        d="M2.343 6a1.32 1.32 0 0 1 1.324-1.333h14.666c.742 0 1.334.591 1.334 1.333v11c0 .741-.592 1.333-1.334 1.333H3.668A1.327 1.327 0 0 1 2.334 17l.009-11Zm15.99 11.5h.5V11H3.168v6.5h15.166Zm0-9.167h.5V5.5H3.168v2.833h15.166Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </svg>
  );
}

export function SvgIcProjects(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 22 23" fill="none" {...props}>
      <path
        d="m12.467 9.234 6.46 1.283c.521.11.873.55.873 1.07v7.48c0 .61-.491 1.1-1.1 1.1h-6.6a.363.363 0 0 0 .367-.366v-.367H18.7a.368.368 0 0 0 .367-.366v-7.48a.369.369 0 0 0-.286-.36l-6.314-1.246v-.748Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={0.3}
      />
      <path
        d="M16.5 12.834c.206 0 .367.162.367.367a.363.363 0 0 1-.367.367h-1.466a.363.363 0 0 1-.367-.367c0-.205.161-.367.367-.367H16.5Zm0 2.2c.206 0 .367.161.367.367a.363.363 0 0 1-.367.367h-1.466a.363.363 0 0 1-.367-.367c0-.206.161-.367.367-.367H16.5Zm0 2.2c.206 0 .367.161.367.367a.363.363 0 0 1-.367.367h-1.466a.363.363 0 0 1-.367-.367c0-.206.161-.367.367-.367H16.5ZM12.467 19.8a.363.363 0 0 1-.367.368.363.363 0 0 1-.367-.367V9.534a.39.39 0 0 1 .132-.286.385.385 0 0 1 .308-.073l.294.059V19.8Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={0.3}
      />
      <path
        d="M11.734 19.434v.367c0 .205.161.367.366.367H9.167a.363.363 0 0 0 .367-.367v-.367h2.2ZM9.9 6.234c.206 0 .367.161.367.367a.363.363 0 0 1-.367.366H8.434a.363.363 0 0 1-.367-.366c0-.206.161-.367.367-.367H9.9Zm.367 2.567a.363.363 0 0 1-.367.367H8.434a.363.363 0 0 1-.367-.367c0-.205.161-.367.367-.367H9.9c.206 0 .367.162.367.367ZM9.9 10.634c.206 0 .367.162.367.367a.363.363 0 0 1-.367.367H8.434A.363.363 0 0 1 8.067 11c0-.205.161-.367.367-.367H9.9Zm0 2.2c.206 0 .367.162.367.367a.363.363 0 0 1-.367.367H8.434a.363.363 0 0 1-.367-.367c0-.205.161-.367.367-.367H9.9Zm-3.3.366a.363.363 0 0 1-.366.368H4.767A.363.363 0 0 1 4.4 13.2c0-.205.162-.367.367-.367h1.467c.205 0 .366.162.366.367Zm-.366-6.966c.205 0 .366.161.366.367a.363.363 0 0 1-.366.366H4.767a.363.363 0 0 1-.367-.366c0-.206.162-.367.367-.367h1.467Zm0 2.2c.205 0 .366.162.366.367a.363.363 0 0 1-.366.367H4.767A.363.363 0 0 1 4.4 8.8c0-.205.162-.367.367-.367h1.467Zm0 2.2c.205 0 .366.162.366.367a.363.363 0 0 1-.366.367H4.767A.363.363 0 0 1 4.4 11c0-.205.162-.367.367-.367h1.467Zm2.566 5.5a.368.368 0 0 0-.367-.367h-2.2a.363.363 0 0 0-.366.367v3.3h-.734v-3.3c0-.609.492-1.1 1.1-1.1h2.2c.609 0 1.1.491 1.1 1.1v3.3H8.8v-3.3Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={0.3}
      />
      <path
        d="M5.867 19.434h3.666v.367a.363.363 0 0 1-.366.367H5.5a.363.363 0 0 1-.367-.367v-.367h.734Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={0.3}
      />
      <path
        d="m3.484 2.714 8.059 1.225c.535.088.924.543.924 1.085v4.21l-.293-.06a.385.385 0 0 0-.308.074.39.39 0 0 0-.133.286v-4.51a.37.37 0 0 0-.308-.366L3.367 3.44c-.022-.007-.044-.007-.066-.007a.346.346 0 0 0-.234.088.35.35 0 0 0-.132.279v15.268c0 .205.168.366.366.366h1.834v.367c0 .205.16.367.366.367H3.3a1.1 1.1 0 0 1-1.1-1.1V3.8c0-.323.14-.631.389-.836a1.1 1.1 0 0 1 .895-.25Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={0.3}
      />
    </svg>
  );
}

export function SvgIcBuilder(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 22 23" fill="none" {...props}>
      <path
        d="m19.117 20-.931-2.394a3.668 3.668 0 0 0-3.438-2.352H13.38a.392.392 0 0 1-.39-.39v-.91c1.153-1.27 1.884-3.256 1.884-4.736 0-.109-.007-.214-.014-.32h.791a.365.365 0 1 0 0-.731h-.337v-.063a4.75 4.75 0 0 0-3.273-4.507A1.145 1.145 0 0 0 10.898 2.5h-.66c-.612 0-1.115.485-1.14 1.093A4.75 4.75 0 0 0 5.825 8.1v.063h-.337a.365.365 0 1 0 0 .732h.79c-.01.105-.013.21-.013.32 0 1.48.731 3.462 1.884 4.735v.91c0 .215-.176.39-.39.39H6.395a3.663 3.663 0 0 0-3.438 2.353l-.932 2.394c-.074.19.021.4.208.474a.365.365 0 0 0 .474-.207l.932-2.394a2.945 2.945 0 0 1 2.756-1.885h1.24l2.567 1.888v2.254a.365.365 0 1 0 .731 0v-2.254l2.567-1.888h1.24c1.228 0 2.31.739 2.757 1.881l.931 2.394c.074.19.285.281.475.208a.356.356 0 0 0 .214-.468ZM6.557 8.1a4.014 4.014 0 0 1 2.538-3.726v1.374c0 .204.165.37.365.37.2 0 .37-.166.37-.37V3.643c0-.225.182-.408.407-.408h.661c.225 0 .408.183.408.408v2.105c0 .204.165.37.366.37.2 0 .365-.166.365-.37V4.37a4.01 4.01 0 0 1 2.535 3.727v.063H6.557V8.1Zm4.01 9.137-2.073-1.526c.235-.207.386-.51.386-.847v-.25c.514.37 1.083.591 1.691.591.605 0 1.174-.222 1.688-.59v.245c0 .338.15.64.386.848l-2.077 1.529ZM7.015 8.898h7.108c.01.102.018.208.018.32 0 2.025-1.635 5.252-3.569 5.252C8.634 14.47 7 11.243 7 9.218a2.356 2.356 0 0 1 .014-.32Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={0.3}
      />
    </svg>
  );
}

export function SvgIcReceipt(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 22 23" fill="none" {...props}>
      <path
        d="M11.302 7.167H6.651a.581.581 0 0 0 0 1.163h4.651a.581.581 0 1 0 0-1.163Zm0 3.111H6.651a.582.582 0 0 0 0 1.163h4.651a.581.581 0 1 0 0-1.163Zm0 3.179H6.651a.582.582 0 0 0 0 1.163h4.651a.581.581 0 0 0 0-1.162Z"
        fill="currentColor"
      />
      <mask id="svgIcReceipt" fill="#fff">
        <path d="M16.738 2.778H5.262A2.267 2.267 0 0 0 3 5.057v14.18a.82.82 0 0 0 1.244.703l2.14-1.285a.203.203 0 0 1 .215 0l2.378 1.425c.125.08.27.122.418.122.15 0 .296-.04.425-.116l2.39-1.43a.203.203 0 0 1 .214 0l2.128 1.284a.808.808 0 0 0 .826 0 .82.82 0 0 0 .413-.709V9.43h1.825A1.39 1.39 0 0 0 19 8.045V5.057a2.266 2.266 0 0 0-2.262-2.28Zm-2.11 15.848-1.605-.965a1.383 1.383 0 0 0-1.413 0l-2.209 1.326-2.203-1.331a1.385 1.385 0 0 0-1.43.005l-1.605.971V5.057A1.099 1.099 0 0 1 5.262 3.94h9.604a2.08 2.08 0 0 0-.238.947v13.738Zm3.209-10.58a.22.22 0 0 1-.22.22H15.79v-3.36a.946.946 0 0 1 .947-.965 1.099 1.099 0 0 1 1.099 1.098v3.006Z" />
      </mask>
      <path
        d="M16.738 2.778H5.262A2.267 2.267 0 0 0 3 5.057v14.18a.82.82 0 0 0 1.244.703l2.14-1.285a.203.203 0 0 1 .215 0l2.378 1.425c.125.08.27.122.418.122.15 0 .296-.04.425-.116l2.39-1.43a.203.203 0 0 1 .214 0l2.128 1.284a.808.808 0 0 0 .826 0 .82.82 0 0 0 .413-.709V9.43h1.825A1.39 1.39 0 0 0 19 8.045V5.057a2.266 2.266 0 0 0-2.262-2.28Zm-2.11 15.848-1.605-.965a1.383 1.383 0 0 0-1.413 0l-2.209 1.326-2.203-1.331a1.385 1.385 0 0 0-1.43.005l-1.605.971V5.057A1.099 1.099 0 0 1 5.262 3.94h9.604a2.08 2.08 0 0 0-.238.947v13.738Zm3.209-10.58a.22.22 0 0 1-.22.22H15.79v-3.36a.946.946 0 0 1 .947-.965 1.099 1.099 0 0 1 1.099 1.098v3.006Z"
        fill="currentColor"
      />
      <path
        d="m16.738 2.778.041-16h-.04v16Zm-11.476 0v-16H5.22l.04 16ZM3 5.057h16v-.082L3 5.057Zm0 14.18 16 .042v-.042H3Zm1.244.703L-3.993 6.224l-.023.014-.024.014L4.244 19.94Zm2.14-1.285 8.237 13.717.11-.066.11-.068-8.457-13.582Zm.107-.03v16-16Zm.108.03-8.457 13.583.117.073.118.07 8.222-13.726Zm2.378 1.425 8.6-13.493-.188-.119-.19-.114L8.977 20.08Zm.418.122-.002 16h.086l-.084-16Zm.425-.116 8.083 13.808.067-.04.067-.04L9.82 20.087Zm2.39-1.43 8.216 13.728.121-.072.12-.074-8.458-13.582Zm.107-.031v16-16Zm.107.03L3.967 32.239l.093.058.094.056 8.27-13.696Zm2.128 1.285-8.27 13.697.049.03.049.029 8.172-13.756Zm.826 0L7.435 6.051l-.116.066-.114.068 8.173 13.755Zm.413-.709 16 .045v-.045h-16Zm0-9.802v-16h-16v16h16Zm1.825 0v16h.067l-.067-16ZM19 8.045l16 .067v-.067H19Zm0-2.988L3 4.975v.082h16Zm-4.372 13.57L6.38 32.337l24.247 14.584V18.627h-16Zm-1.605-.966 8.247-13.71-.04-.024-.039-.024-8.168 13.758Zm-1.413 0L3.442 3.903l-.032.02-.032.018 8.232 13.72Zm-2.209 1.326L1.127 32.68l8.245 4.982 8.261-4.956-8.232-13.72Zm-2.203-1.331L15.472 3.96l-.03-.018-.031-.019-8.213 13.732Zm-1.43.005 8.282 13.69.021-.013.021-.013-8.325-13.664Zm-1.605.971h-16v28.382l24.283-14.693-8.283-13.689Zm0-13.575h16V4.93l-.002-.127-15.998.254ZM5.262 3.94l-.002 16h.002v-16Zm9.604 0 14.167 7.436L41.335-12.06H14.866v16Zm-.238.947-16-.151v.151h16Zm2.988 3.378v16-16Zm-1.825 0h-16v16h16v-16Zm0-3.36h16v-.148l-.003-.147-15.997.295Zm.947-.965-.003 16h.003v-16Zm0-17.163H5.262v32h11.476v-32Zm-11.517 0a18.258 18.258 0 0 0-6.998 1.413l12.34 29.525a13.733 13.733 0 0 1-5.26 1.062l-.082-32Zm-6.998 1.413A18.267 18.267 0 0 0-7.7-7.822l22.714 22.54a13.732 13.732 0 0 1-4.452 2.998L-1.777-11.81ZM-7.7-7.822a18.268 18.268 0 0 0-3.942 5.952l29.62 12.113a13.732 13.732 0 0 1-2.964 4.475L-7.699-7.822Zm-3.942 5.952A18.27 18.27 0 0 0-13 5.14l32-.164a13.732 13.732 0 0 1-1.022 5.268L-11.64-1.87ZM-13 5.057v14.18h32V5.057h-32Zm0 14.138a16.82 16.82 0 0 0 2.28 8.5l27.662-16.088A15.181 15.181 0 0 1 19 19.279l-32-.084Zm2.28 8.5a16.82 16.82 0 0 0 6.261 6.185l15.75-27.855a15.18 15.18 0 0 1 5.651 5.582L-10.72 27.695Zm6.261 6.185a16.82 16.82 0 0 0 8.528 2.177L3.595 4.06a15.18 15.18 0 0 1 7.696 1.965L-4.459 33.88Zm8.528 2.177a16.82 16.82 0 0 0 8.459-2.428L-4.04 6.252A15.18 15.18 0 0 1 3.595 4.06l.474 31.997Zm8.413-2.4 2.14-1.285L-1.855 4.94l-2.14 1.285 16.476 27.433Zm2.359-1.42a15.797 15.797 0 0 1-8.35 2.388v-32c-3.027 0-5.994.848-8.564 2.448L14.84 32.238Zm-8.35 2.388c-2.951 0-5.844-.827-8.35-2.387L15.057 5.073a16.204 16.204 0 0 0-8.565-2.448v32Zm-8.114-2.244 2.378 1.425L17.199 6.354 14.82 4.93-1.623 32.38Zm2 1.191a16.78 16.78 0 0 0 9.016 2.63l.005-32c2.897 0 5.735.828 8.178 2.385L.377 33.572Zm9.102 2.63a16.849 16.849 0 0 0 8.424-2.308L1.736 6.278a15.151 15.151 0 0 1 7.576-2.076l.167 32Zm8.558-2.387 2.39-1.43L3.991 4.926l-2.39 1.43 16.435 27.457Zm2.63-1.577a15.798 15.798 0 0 1-8.35 2.387v-32c-3.028 0-5.995.848-8.565 2.448l16.914 27.165Zm-8.35 2.387c-2.952 0-5.844-.827-8.35-2.387L20.882 5.073a16.204 16.204 0 0 0-8.565-2.448v32Zm-8.163-2.273 2.128 1.285 16.54-27.393-2.127-1.285L4.154 32.352Zm2.226 1.344a16.808 16.808 0 0 0 8.585 2.358v-32c2.731 0 5.412.736 7.76 2.131L6.38 33.695Zm8.585 2.358c3.022 0 5.988-.815 8.585-2.358L7.205 6.186a15.192 15.192 0 0 1 7.76-2.132v32Zm8.356-2.225a16.82 16.82 0 0 0 6.187-6.14L1.851 11.593a15.18 15.18 0 0 1 5.584-5.542L23.32 33.83Zm6.187-6.14a16.82 16.82 0 0 0 2.283-8.413l-32-.09a15.18 15.18 0 0 1 2.06-7.593L29.508 27.69Zm2.283-8.458V9.43h-32v9.802h32Zm-16 6.198h1.825v-32h-1.825v32Zm1.892 0a17.39 17.39 0 0 0 12.224-5.093L7.279-2.292A14.61 14.61 0 0 1 17.55-6.57l.134 32Zm12.224-5.093A17.39 17.39 0 0 0 35 8.112L3 7.978a14.61 14.61 0 0 1 4.28-10.27l22.627 22.628ZM35 8.046v-2.99H3v2.99h32Zm0-2.907a18.267 18.267 0 0 0-1.36-7.009L4.023 10.243A13.733 13.733 0 0 1 3 4.975l32 .164ZM33.64-1.87a18.268 18.268 0 0 0-3.94-5.952L6.985 14.718a13.733 13.733 0 0 1-2.963-4.475L33.64-1.87ZM29.7-7.822a18.268 18.268 0 0 0-5.922-3.987l-12.34 29.525a13.732 13.732 0 0 1-4.452-2.998L29.7-7.822Zm-5.922-3.987a18.266 18.266 0 0 0-6.998-1.413l-.082 32a13.732 13.732 0 0 1-5.26-1.062l12.34-29.525Zm-.903 16.724L21.27 3.95 4.777 31.372l1.604.966L22.874 4.915Zm-1.683-1.012a17.384 17.384 0 0 0-8.874-2.436v32c-2.626 0-5.204-.707-7.462-2.048L21.191 3.903Zm-8.874-2.436c-3.124 0-6.19.842-8.875 2.436L19.78 31.42a14.617 14.617 0 0 1-7.462 2.049v-32Zm-8.94 2.474L1.17 5.267l16.464 27.44 2.21-1.326L3.377 3.941Zm14.297 1.352L15.473 3.96l-16.55 27.39 2.204 1.331L17.676 5.293Zm-2.264-1.369A17.384 17.384 0 0 0 6.417 1.46l.13 32a14.616 14.616 0 0 1-7.563-2.072L15.411 3.924ZM6.417 1.46a17.38 17.38 0 0 0-8.974 2.538l16.649 27.328a14.616 14.616 0 0 1-7.545 2.134l-.13-32Zm-8.932 2.513-1.605.971 16.566 27.378 1.604-.97L-2.516 3.971Zm22.678 14.66V5.057h-32v13.575h32Zm-.002-13.83a14.9 14.9 0 0 1-1.066 5.776L-10.612-1.316a17.098 17.098 0 0 0-1.223 6.627l31.996-.508Zm-1.066 5.776a14.902 14.902 0 0 1-3.214 4.915L-6.924-6.956a17.098 17.098 0 0 0-3.688 5.64l29.707 11.894Zm-3.214 4.915a14.903 14.903 0 0 1-4.864 3.291l-12.36-29.516a17.1 17.1 0 0 0-5.581 3.776l22.805 22.449Zm-4.864 3.291a14.9 14.9 0 0 1-5.757 1.157l.004-32c-2.269 0-4.515.45-6.607 1.327l12.36 29.516Zm-5.755 1.157h9.604v-32H5.262v32ZM.699-3.496a18.081 18.081 0 0 0-2.07 8.233l31.998.303a13.918 13.918 0 0 1-1.594 6.337L.699-3.496Zm-2.071 8.384V18.61h32V4.889h-32Zm0 13.721v.017h32v-.017h-32Zm3.21-10.564a15.78 15.78 0 0 1 4.62-11.157l22.628 22.627a16.22 16.22 0 0 0 4.751-11.47h-32Zm4.62-11.157a15.78 15.78 0 0 1 11.158-4.622v32a16.22 16.22 0 0 0 11.47-4.75L6.459-3.113Zm11.158-4.622h-1.825v32h1.825v-32Zm14.175 16v-3.36h-32v3.36h32Zm-.003-3.655c.037 2-.326 3.987-1.065 5.846L.993-1.381A16.948 16.948 0 0 0-.207 5.2l31.995-.589Zm-1.065 5.846a15.053 15.053 0 0 1-3.245 4.977L4.645-6.986A16.948 16.948 0 0 0 .993-1.38l29.73 11.838Zm-3.245 4.977a15.052 15.052 0 0 1-4.918 3.335l-12.377-29.51a16.948 16.948 0 0 0-5.538 3.755l22.833 22.42ZM22.56 18.77a15.053 15.053 0 0 1-5.825 1.172l.006-32a16.96 16.96 0 0 0-6.559 1.319L22.561 18.77Zm-5.822 1.172c-3.952 0-7.742-1.57-10.537-4.365L28.83-7.05a17.099 17.099 0 0 0-12.09-5.008v32ZM6.201 15.576A14.901 14.901 0 0 1 1.837 5.04h32c0-4.534-1.801-8.884-5.008-12.09L6.2 15.576ZM1.837 5.04v3.006h32V5.04h-32Z"
        fill="currentColor"
        mask="url(#svgIcReceipt)"
      />
    </svg>
  );
}

export function SvgIcBookingForm(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 22 23" fill="none" {...props}>
      <path
        d="M16.817 6.528 13.615 3.5A1.819 1.819 0 0 0 12.36 3H6.265A1.828 1.828 0 0 0 4.44 4.826v13.345a1.828 1.828 0 0 0 1.826 1.826h9.296a1.828 1.828 0 0 0 1.826-1.826V7.855a1.834 1.834 0 0 0-.57-1.327Zm-.967.452h-2.48a.166.166 0 0 1-.166-.166V4.482L15.85 6.98Zm-.288 12.018H6.265a.83.83 0 0 1-.832-.827V4.826a.83.83 0 0 1 .83-.83h5.943v2.822A1.163 1.163 0 0 0 13.37 7.98h3.021v10.191a.831.831 0 0 1-.83.832v-.005Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={0.2}
      />
      <path
        d="M14.466 9.64H7.162a.498.498 0 1 0 0 .993h7.304a.498.498 0 1 0 0-.993Zm0 2.656H7.162a.496.496 0 0 0-.486.694.498.498 0 0 0 .486.3h7.304a.498.498 0 1 0 0-.994Zm-4.89 2.656H7.161a.498.498 0 1 0 0 .993h2.415a.497.497 0 0 0 0-.993Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={0.2}
      />
    </svg>
  );
}

export function SvgIcPrice(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 22 23" fill="none" {...props}>
      <g opacity={1} fill="currentColor">
        <path d="M15.09 4.955H3.638c-.9 0-1.637.736-1.637 1.636v6.546c0 .9.737 1.636 1.637 1.636H15.09c.9 0 1.636-.736 1.636-1.636V6.59c0-.9-.736-1.636-1.636-1.636ZM3.638 13.137V6.59H15.09v6.546H3.637Z" />
        <path d="M9.364 7.41a2.451 2.451 0 0 0-2.455 2.454 2.451 2.451 0 0 0 2.455 2.455 2.451 2.451 0 0 0 2.454-2.455A2.451 2.451 0 0 0 9.364 7.41ZM20 7.41v9c0 .9-.736 1.636-1.636 1.636H4.455v-1.637h13.909v-9H20Z" />
      </g>
    </svg>
  );
}

export function SvgAnalyzerIcon(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 28 29" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 .5c7.732 0 14 6.266 14 13.998C28 22.23 21.732 28.5 14 28.5S0 22.23 0 14.498C0 6.766 6.268.5 14 .5Z"
        fill="url(#d)"
      />
      <rect x={7} y={11} width={1.75} height={7} rx={0.875} fill="#fff" />
      <rect x={10.25} y={12.5} width={1.75} height={4} rx={0.875} fill="#fff" />
      <rect x={13.5} y={9.5} width={1.75} height={10} rx={0.875} fill="#fff" />
      <rect x={16.75} y={12} width={1.75} height={5} rx={0.875} fill="#fff" />
      <rect x={20} y={10.5} width={1.75} height={8} rx={0.875} fill="#fff" />
      <defs>
        <linearGradient id="d" x1={14} y1={28.5} x2={14} y2={0.5} gradientUnits="userSpaceOnUse">
          <stop stopColor="#6C54A3" />
          <stop offset={1} stopColor="#00B1D2" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function SvgIconAi(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 18 18" fill="none" {...props}>
      <foreignObject x="0" y="0" width="100%" height="100%">
        <div
          xmlns="http://www.w3.org/1999/xhtml"
          style={{
            background: 'linear-gradient(0deg, #6C54A3 0%, #00B1D2 100%)',
            borderRadius: '5rem',
            width: '100%',
            height: '100%',
          }}
        />
      </foreignObject>
      <path d="M12.288 5.403v.023l.018-.023h-.018Z" fill="#000" />
      <path
        d="M11.577 8.99v3.699H7.873c-1.01 0-1.878-.36-2.605-1.08a3.55 3.55 0 0 1-1.09-2.62c0-1.026.364-1.902 1.09-2.628.727-.726 1.595-1.09 2.605-1.09s1.88.364 2.61 1.09c.729.726 1.094 1.602 1.094 2.628Zm-1.551 2.225V8.989c0-.612-.209-1.138-.626-1.58a2.026 2.026 0 0 0-1.532-.663c-.603 0-1.113.22-1.531.663a2.222 2.222 0 0 0-.626 1.58c0 .612.208 1.136.626 1.572a2.04 2.04 0 0 0 1.531.654h2.158Zm3.028-3.72c-.31 0-.588-.133-.766-.34v4.138c0 .382.15.71.452.985a1.55 1.55 0 0 0 1.08.411V7.437a1.33 1.33 0 0 0-.023-.255 1.013 1.013 0 0 1-.743.313Z"
        fill="#E6E6E6"
      />
      <path
        d="M13.056 6.966a.758.758 0 0 0 .751-.764.758.758 0 0 0-.752-.764.758.758 0 0 0-.751.764c0 .422.336.764.752.764Z"
        fill="#fff"
      />
    </svg>
  );
}

export function IcRevenueReports(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 20 20" fill="none" {...props}>
      <path
        fill="currentColor"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.2}
        d="M2.5 14.438a45.055 45.055 0 0 1 11.848 1.575.86.86 0 0 0 1.09-.822v-.754M3.624 3.75v.563a.563.563 0 0 1-.563.562H2.5m0 0v-.281c0-.466.378-.844.844-.844H16M2.5 4.875v6.75M16 3.75v.563c0 .31.252.562.563.562h.562M16 3.75h.281c.466 0 .844.378.844.844v7.312a.844.844 0 0 1-.844.844H16M2.5 11.625v.281a.844.844 0 0 0 .844.844h.281M2.5 11.625h.563a.563.563 0 0 1 .562.563v.562m12.375 0v-.563a.562.562 0 0 1 .563-.562h.562M16 12.75H3.625m8.438-4.5a2.25 2.25 0 1 1-4.501 0 2.25 2.25 0 0 1 4.5 0Zm2.25 0h.005v.006h-.005V8.25Zm-9 0h.006v.006h-.006V8.25Z"
      />
    </svg>
  );
}

export function IcCoins(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 15 15" fill="none" {...props}>
      <path
        d="M12.858 6.775a1.96 1.96 0 0 0 .09-.539V3.7c0-1.808-2.729-3.172-6.345-3.172C2.989.527.26 1.891.26 3.7v2.537a2.468 2.468 0 0 0 1.359 2c-.07.168-.114.346-.127.527V11.3c0 1.808 2.728 3.172 6.343 3.172 3.616 0 6.345-1.364 6.345-3.171V8.768a2.4 2.4 0 0 0-1.322-1.993ZM6.604 9.408a8.658 8.658 0 0 0 5.545-1.587c.507.3.76.63.76.946 0 .774-1.979 1.9-5.075 1.9-3.095 0-5.015-1.093-5.074-1.867 1.237.42 2.538.626 3.845.608Zm0-7.612c3.1 0 5.076 1.13 5.076 1.9 0 .771-1.98 1.9-5.075 1.9-3.097 0-5.075-1.129-5.075-1.9 0-.77 1.979-1.9 5.074-1.9ZM1.53 5.64a9.471 9.471 0 0 0 5.074 1.231 9.471 9.471 0 0 0 5.074-1.23v.6c0 .773-1.979 1.9-5.075 1.9-3.095 0-5.074-1.13-5.074-1.9v-.6Zm6.304 7.57c-3.1 0-5.074-1.13-5.074-1.9v-.6a9.472 9.472 0 0 0 5.075 1.23 9.472 9.472 0 0 0 5.074-1.23v.6c0 .774-1.979 1.9-5.075 1.9Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function IcQualityControl(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 20 21" fill="none" {...props}>
      <g clipPath="url(#iqc)" fill="currentColor">
        <path d="M2.803 17.68c.436.437 1.187.46 1.63.017l4.558-4.558a2.825 2.825 0 0 0 3.559-3.853l-2.158 2.158H9.61l-.553-.553v-.78l2.16-2.16a2.825 2.825 0 0 0-3.857 3.557l-4.558 4.559a1.141 1.141 0 0 0 0 1.614Z" />
        <path d="M18 11.5v-2l-1.092-.137a6.983 6.983 0 0 0-.357-1.333l.877-.664-1-1.732-1.015.428a7.052 7.052 0 0 0-.975-.975l.428-1.015-1.732-1-.664.877a6.985 6.985 0 0 0-1.333-.357L11 2.5H9l-.137 1.092a6.984 6.984 0 0 0-1.333.357l-.664-.877-1.732 1 .428 1.015a7.019 7.019 0 0 0-.975.975l-1.015-.428-1 1.732.877.664c-.16.426-.281.872-.357 1.333L2 9.5v2l1.092.137a7 7 0 0 0 .357 1.333l-.877.664.49.848 2.112-2.112a5.148 5.148 0 0 1-.35-1.87A5.182 5.182 0 0 1 10 5.324a5.182 5.182 0 0 1 5.176 5.176A5.182 5.182 0 0 1 10 15.676c-.66 0-1.29-.124-1.87-.35l-2.112 2.112.848.49.664-.877c.426.16.872.281 1.333.357L9 18.5h2l.137-1.092a6.985 6.985 0 0 0 1.333-.357l.664.877 1.732-1-.428-1.015a7.05 7.05 0 0 0 .975-.975l1.015.428 1-1.732-.877-.664c.16-.426.281-.872.357-1.333L18 11.5Z" />
      </g>
      <defs>
        <clipPath id="iqc">
          <path fill="#fff" transform="translate(2 2.5)" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function IcTeams(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 20 21" fill="none" {...props}>
      <g clipPath="url(#sit)" fill="currentColor">
        <path d="M11.412 5.15c.421-.384.688-.936.688-1.55 0-1.158-.942-2.1-2.1-2.1-1.158 0-2.1.942-2.1 2.1 0 .614.267 1.166.688 1.55A2.703 2.703 0 0 0 6.4 7.8V9a.3.3 0 0 0 .3.3h6.6a.3.3 0 0 0 .3-.3V7.8c0-1.314-.944-2.41-2.188-2.65ZM8.5 3.6c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5-.673 1.5-1.5 1.5-1.5-.673-1.5-1.5ZM13 8.7H7v-.9c0-1.158.942-2.1 2.1-2.1h1.8c1.158 0 2.1.942 2.1 2.1v.9Zm-6.988 6.65c.421-.384.688-.936.688-1.55 0-1.158-.942-2.1-2.1-2.1-1.158 0-2.1.942-2.1 2.1 0 .614.267 1.166.688 1.55A2.703 2.703 0 0 0 1 18v1.2a.3.3 0 0 0 .3.3h6.6a.3.3 0 0 0 .3-.3V18c0-1.314-.943-2.41-2.188-2.65ZM3.1 13.8c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5-.673 1.5-1.5 1.5-1.5-.673-1.5-1.5Zm4.5 5.1h-6V18c0-1.158.942-2.1 2.1-2.1h1.8c1.158 0 2.1.942 2.1 2.1v.9Zm9.212-3.55c.421-.384.688-.936.688-1.55 0-1.158-.942-2.1-2.1-2.1-1.158 0-2.1.942-2.1 2.1 0 .614.267 1.166.688 1.55A2.703 2.703 0 0 0 11.8 18v1.2a.3.3 0 0 0 .3.3h6.6a.3.3 0 0 0 .3-.3V18c0-1.314-.944-2.41-2.188-2.65ZM13.9 13.8c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5-.673 1.5-1.5 1.5-1.5-.673-1.5-1.5Zm4.5 5.1h-6V18c0-1.158.942-2.1 2.1-2.1h1.8c1.158 0 2.1.942 2.1 2.1v.9ZM2.806 11.09l-.6.024c.008.206.025.416.05.622l.595-.072a7.213 7.213 0 0 1-.045-.574Zm-.551-1.22a7.759 7.759 0 0 0-.049.62l.6.024a6.83 6.83 0 0 1 .045-.574l-.596-.07Zm3.017-5.275a7.83 7.83 0 0 0-.481.399l.4.446c.144-.129.293-.252.444-.367l-.363-.478ZM2.94 7.479c-.088.188-.17.38-.243.575l.562.211c.067-.18.142-.357.224-.53L2.94 7.48ZM2.5 8.647a7.789 7.789 0 0 0-.147.606l.589.118a6.79 6.79 0 0 1 .136-.559L2.5 8.647ZM4.344 5.43a7.935 7.935 0 0 0-.411.468l.466.377c.12-.147.248-.293.38-.433l-.435-.413ZM6.32 3.921a7.713 7.713 0 0 0-.538.317l.325.504c.162-.104.329-.202.496-.292l-.283-.529ZM3.56 6.397a7.795 7.795 0 0 0-.331.53l.52.297c.095-.165.198-.33.306-.487l-.495-.34ZM8.579 17.86l-.119.588c.202.04.41.073.617.098l.07-.596a7.105 7.105 0 0 1-.568-.09Zm2.861-.004a7.366 7.366 0 0 1-.568.092l.072.596c.207-.025.414-.059.615-.1l-.119-.588Zm-1.142.138a7.376 7.376 0 0 1-.576 0l-.024.6a7.205 7.205 0 0 0 .624 0l-.024-.6ZM15.21 4.996l-.4.446c.142.129.281.264.412.402l.436-.413a7.76 7.76 0 0 0-.448-.435Zm.858.904-.466.377c.12.148.235.304.344.462l.495-.34a8.063 8.063 0 0 0-.373-.5Zm1.726 4.592-.6.023a6.926 6.926 0 0 1 0 .576l.6.024a7.84 7.84 0 0 0 0-.623Zm-1.021-3.564-.521.298c.095.166.184.338.266.51l.543-.255a7.853 7.853 0 0 0-.288-.553Zm.53 1.128-.561.21c.067.18.128.364.18.547l.577-.165a7.727 7.727 0 0 0-.195-.592Zm.343 1.198-.588.118c.038.188.069.38.091.57l.596-.072a7.717 7.717 0 0 0-.099-.616ZM14.22 4.239l-.325.505c.16.103.319.214.472.33l.364-.476a7.813 7.813 0 0 0-.51-.359Zm-1.099-.589-.24.55c.175.076.349.16.518.251l.284-.528a7.5 7.5 0 0 0-.562-.273Z" />
      </g>
      <defs>
        <clipPath id="sit">
          <path fill="#fff" transform="translate(1 1.5)" d="M0 0h18v18H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function IcRules(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 20 21" fill="none" {...props}>
      <path
        d="M13.818 16.732H3.08a.891.891 0 1 0 0 1.783h10.737a.891.891 0 1 0 0-1.783Zm-.483-1.515c0-.37-.3-.67-.67-.67H4.233c-.37 0-.67.3-.67.67v1.015h9.773v-1.015Zm4.132-2.057-3.315-3.313a1.178 1.178 0 0 0-1.182-.293l-.791-.793a7.291 7.291 0 0 0 1.107-1.656l-3.2-3.2c-.7.332-1.41.832-2.056 1.477A7.521 7.521 0 0 0 6.553 7.44l3.197 3.197a7.315 7.315 0 0 0 1.66-1.106l.792.793a1.204 1.204 0 0 0-.052.353c0 .3.112.6.342.827l3.315 3.315c.458.458 1.2.458 1.66 0a1.177 1.177 0 0 0 0-1.66ZM13.66 6.772a.612.612 0 1 0 .865-.866l-3.24-3.241a.612.612 0 1 0-.866.865l3.24 3.242Zm-5.107 5.107a.612.612 0 0 0 .866-.866L6.177 7.772a.612.612 0 0 0-.865.865l3.24 3.242Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function IcKpiManagement(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 20 21" fill="none" {...props}>
      <g clipPath="url(#kpim)" fill="currentColor">
        <path d="M18 13.642v-.667c.177 0 .322-.15.322-.334V10.64a.328.328 0 0 0-.322-.334h-1.736l-.062-.25a6.293 6.293 0 0 0-.656-1.63l-.128-.224 1.232-1.28a.34.34 0 0 0 0-.468l-1.365-1.418a.318.318 0 0 0-.45 0L13.6 6.316l-.215-.133a5.838 5.838 0 0 0-1.572-.68l-.242-.066V3.635a.328.328 0 0 0-.321-.334H9.321A.328.328 0 0 0 9 3.635v1.8l-.241.066a5.835 5.835 0 0 0-1.571.68l-.215.133-1.234-1.278a.318.318 0 0 0-.452 0L3.92 6.452a.338.338 0 0 0 0 .47l1.235 1.28-.128.224a6.293 6.293 0 0 0-.656 1.63l-.063.25H2.57a.328.328 0 0 0-.321.334v2.001c0 .184.144.334.321.334v.667c-.532 0-.964-.448-.964-1V10.64c0-.553.432-1.001.964-1.001h1.244c.133-.461.312-.907.535-1.329l-.884-.917a1.017 1.017 0 0 1-.282-.706c0-.265.101-.52.282-.706l1.366-1.418a.959.959 0 0 1 1.361 0l.884.917a6.435 6.435 0 0 1 1.28-.555v-1.29c0-.553.432-1.001.964-1.001h1.929c.533 0 .964.448.964 1v1.291c.445.138.874.324 1.28.555l.884-.917a.959.959 0 0 1 1.362 0l1.366 1.417a1.022 1.022 0 0 1 0 1.413l-.884.917c.223.422.402.868.534 1.329H18c.532 0 .964.448.964 1v2.002c0 .553-.431 1-.964 1Z" />
        <path d="M14.786 11.64h-.643c0-2.21-1.727-4.003-3.857-4.003S6.429 9.43 6.429 11.64h-.643c0-2.579 2.014-4.67 4.5-4.67 2.485 0 4.5 2.091 4.5 4.67Z" />
        <path d="M10.286 14.309c-1.065 0-1.929-.896-1.929-2.002 0-1.105.864-2.001 1.929-2.001s1.928.896 1.928 2.002c0 1.104-.864 2-1.928 2Zm0-3.336c-.71 0-1.286.598-1.286 1.334 0 .737.576 1.335 1.286 1.335.71 0 1.286-.598 1.286-1.335 0-.736-.576-1.334-1.286-1.334Zm5.464 4.67c-1.065 0-1.928-.896-1.928-2.001 0-1.106.863-2.002 1.928-2.002s1.929.896 1.929 2.002c-.002 1.105-.864 2-1.929 2.001Zm0-3.336c-.71 0-1.286.598-1.286 1.335s.576 1.334 1.286 1.334c.71 0 1.286-.597 1.286-1.334 0-.737-.576-1.335-1.286-1.335ZM4.821 15.643c-1.065 0-1.928-.896-1.928-2.001 0-1.106.863-2.002 1.928-2.002 1.066 0 1.929.896 1.929 2.002-.001 1.105-.864 2-1.929 2.001Zm0-3.336c-.71 0-1.285.598-1.285 1.335s.575 1.334 1.285 1.334 1.286-.597 1.286-1.334c0-.737-.576-1.335-1.286-1.335Z" />
        <path d="M18.664 16.5a2.788 2.788 0 0 0-1.628-.523h-2.572a2.777 2.777 0 0 0-.466.044 2.948 2.948 0 0 0-.935-.948 2.791 2.791 0 0 0-1.492-.43H9a2.837 2.837 0 0 0-2.426 1.378 2.789 2.789 0 0 0-.467-.044H3.536a2.788 2.788 0 0 0-1.628.521A3.035 3.035 0 0 0 .643 18.98v1.334c.001.911.512 1.738 1.309 2.12.294.144.616.217.94.215h3.215v-.667H3.214v-3.67h-.643v3.637a1.471 1.471 0 0 1-.35-.121 1.675 1.675 0 0 1-.935-1.514V18.98c0-.773.37-1.495.985-1.93a2.167 2.167 0 0 1 1.265-.405h2.571c.057 0 .111.006.167.01a3.104 3.104 0 0 0-.167.99v3.336c.001.921.72 1.667 1.607 1.668h.965v-5.337h-.643v4.67h-.322c-.532 0-.964-.448-.964-1v-3.336c0-1.29 1.007-2.335 2.25-2.335h2.571a2.185 2.185 0 0 1 1.266.405c.301.214.548.5.72.834a2.4 2.4 0 0 1 .264 1.096v3.335c0 .553-.431 1.001-.964 1.001h-.321v-4.67h-.643v5.337h.964c.887 0 1.606-.747 1.607-1.668v-3.335a3.115 3.115 0 0 0-.166-.99c.055-.005.11-.011.166-.011h2.572c.451-.001.893.14 1.265.405.615.435.984 1.157.985 1.93v1.334a1.675 1.675 0 0 1-.941 1.517c-.11.054-.226.093-.345.118v-3.636h-.643v3.67h-2.893v.666h3.214a2.1 2.1 0 0 0 .936-.213c.8-.38 1.313-1.209 1.314-2.122V18.98c0-.993-.473-1.921-1.264-2.48Z" />
      </g>
      <defs>
        <clipPath id="kpim">
          <path fill="#fff" transform="translate(0 2)" d="M0 0h20v17H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function IcInventory(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 21 21" fill="none" {...props}>
      <path
        d="M9.566 17.525h.025v-1.201H5.097V5.21h1.848v2.494h6.674V5.21h1.848v3.894h1.123V5.185c0-.313-.11-.588-.329-.822-.219-.235-.476-.353-.77-.353h-3.596a1.903 1.903 0 0 0-.622-1.097 1.698 1.698 0 0 0-1.153-.438c-.436 0-.82.146-1.153.438a1.903 1.903 0 0 0-.622 1.097H4.75a.404.404 0 0 0-.232.09c-.081.06-.169.148-.262.264a1.273 1.273 0 0 0-.283.821V16.35c0 .314.11.588.33.823.218.235.475.353.77.353h4.493Zm3.365-.487.019.02.018-.02 5.049-5.41.015-.017-.015-.017-.77-.825-.019-.02-.018.02-4.26 4.565-2.077-2.224-.018-.02-.018.02-.77.824-.016.017.016.018 2.864 3.069Zm-2.318-12.37a.645.645 0 0 1-.492.212.645.645 0 0 1-.492-.213.746.746 0 0 1-.2-.53c0-.211.067-.387.2-.529a.645.645 0 0 1 .492-.213c.196 0 .36.071.492.213.133.142.2.318.2.53a.746.746 0 0 1-.2.53Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function IcCallRecord(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 20 21" fill="none" {...props}>
      <g clipPath="url(#sicr)" fill="currentColor">
        <path d="M15.759 10.796a.624.624 0 0 0-.635-.635.624.624 0 0 0-.636.635A4.492 4.492 0 0 1 10 15.286a4.492 4.492 0 0 1-4.49-4.49.624.624 0 0 0-.635-.635.624.624 0 0 0-.635.635c0 2.944 2.202 5.421 5.125 5.739v1.694h-2.31a.624.624 0 0 0-.635.635c0 .36.275.636.635.636h5.888c.36 0 .635-.276.635-.636a.624.624 0 0 0-.635-.635h-2.309v-1.694c2.923-.318 5.125-2.795 5.125-5.739Z" />
        <path d="M10.001 1.5a3.543 3.543 0 0 0-3.536 3.536v5.74A3.56 3.56 0 0 0 10 14.332a3.543 3.543 0 0 0 3.537-3.537v-5.76A3.543 3.543 0 0 0 10 1.5Z" />
      </g>
      <defs>
        <clipPath id="sicr">
          <path fill="#fff" transform="translate(1 1.5)" d="M0 0h18v18H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function IcProjects(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 21 21" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.491 3.626 4.165 2.513a1 1 0 0 0-.814.227.982.982 0 0 0-.353.76v13.88a1 1 0 0 0 1 1h8a.33.33 0 0 1-.333-.334v-.333h-2v-3a1 1 0 0 0-1-1h-2c-.554 0-1 .447-1 1v3.333-.333H3.998a.334.334 0 0 1-.333-.333V3.5c0-.1.04-.187.12-.254a.314.314 0 0 1 .213-.08c.02 0 .04 0 .06.007l7.327 1.107c.16.026.28.166.28.333v13.433a.33.33 0 0 0 .333.334h6a1 1 0 0 0 1-1v-6.8a.985.985 0 0 0-.793-.974L12.332 8.44V4.613a.996.996 0 0 0-.84-.987Zm-1.16 2.42a.33.33 0 0 0-.333-.333H8.665a.33.33 0 0 0-.334.333.33.33 0 0 0 .334.334h1.333a.33.33 0 0 0 .333-.334Zm2 3.074v8.593h5.667c.18 0 .333-.147.333-.333v-6.8a.335.335 0 0 0-.26-.327l-5.74-1.133Zm3.667 2.593a.33.33 0 0 1 .333.333.33.33 0 0 1-.333.334h-1.333a.33.33 0 0 1-.334-.334.33.33 0 0 1 .334-.333h1.333Zm.333 2.333a.33.33 0 0 0-.333-.333h-1.333a.33.33 0 0 0-.334.333.33.33 0 0 0 .334.334h1.333a.33.33 0 0 0 .333-.334Zm-.333 1.667a.33.33 0 0 1 .333.333.33.33 0 0 1-.333.334h-1.333a.33.33 0 0 1-.334-.334.33.33 0 0 1 .334-.333h1.333Zm-7 2H6.331v-3a.33.33 0 0 1 .334-.333h2c.18 0 .333.146.333.333v3Zm1.333-9.667a.33.33 0 0 1-.333.334H8.665a.33.33 0 0 1-.334-.334.33.33 0 0 1 .334-.333h1.333a.33.33 0 0 1 .333.333Zm0 2a.33.33 0 0 0-.333-.333H8.665a.33.33 0 0 0-.334.333.33.33 0 0 0 .334.334h1.333a.33.33 0 0 0 .333-.334Zm-.333 1.667a.33.33 0 0 1 .333.333.33.33 0 0 1-.333.334H8.665a.33.33 0 0 1-.334-.334.33.33 0 0 1 .334-.333h1.333Zm-3.333.667a.33.33 0 0 0 .333-.334.33.33 0 0 0-.333-.333H5.33a.33.33 0 0 0-.333.333.33.33 0 0 0 .333.334h1.334Zm0-6.667a.33.33 0 0 1 .333.333.33.33 0 0 1-.333.334H5.33a.33.33 0 0 1-.333-.334.33.33 0 0 1 .333-.333h1.334Zm.333 2.333a.33.33 0 0 0-.333-.333H5.33a.33.33 0 0 0-.333.333.33.33 0 0 0 .333.334h1.334a.33.33 0 0 0 .333-.334Zm-.333 1.667a.33.33 0 0 1 .333.333.33.33 0 0 1-.333.334H5.33a.33.33 0 0 1-.333-.334.33.33 0 0 1 .333-.333h1.334Z"
        fill="currentColor"
      />
      <path
        d="m4.165 2.513-.024.148h.001l.023-.148Zm7.326 1.113.025-.148h-.002l-.023.148Zm-8.14-.886.096.115.002-.001-.098-.114Zm2.642 15.64.002-.15h-.002v.15Zm5.672-.667h.15v-.15h-.15v.15Zm-2 0h-.15v.15h.15v-.15Zm-3.8.64-.058.138.117-.276-.059.138Zm-.2-.64h.15v-.15h-.15v.15ZM3.785 3.246l.096.116.003-.004-.1-.112Zm.273-.073-.047.142.012.004.013.002.022-.148Zm7.327 1.107.024-.148h-.002l-.022.148Zm.4 4.173-.09-.12-.011.009.1.111Zm.261-.07-.021.149.042-.297-.021.148Zm-.261.07-.09-.12-.006.004-.005.005.1.111Zm.301 9.915.039.145-.077-.29.038.145Zm6.119-8.762.03-.146h-.001l-.03.146ZM12.332 8.44h-.15v.123l.12.024.03-.147Zm0 0h.15v-.125l-.124-.023-.027.148Zm0 0h-.15v.125l.123.022.026-.147Zm0 .68.028-.147-.178-.036v.183h.15Zm0 8.593h-.15v.15h.15v-.15Zm5.74-7.46.031-.147H18.1l-.029.147Zm-11.74 7.46h-.15v.15h.15v-.15Zm2.666 0v.15h.15v-.15h-.15ZM4.142 2.661l7.327 1.114.045-.297-7.327-1.113-.045.296Zm-.693.193a.85.85 0 0 1 .692-.193l.047-.296a1.15 1.15 0 0 0-.934.26l.195.229Zm-.3.646a.829.829 0 0 1 .298-.645l-.191-.231c-.263.216-.408.54-.408.876h.3Zm-.001 13.88V3.5h-.3v13.88h.3Zm.85.85a.85.85 0 0 1-.85-.85h-.3c0 .636.514 1.15 1.15 1.15v-.3Zm1.995 0H3.998v.3h1.995v-.3Zm-.002.3h.007v-.3h-.003l-.004.3Zm.007 0h3.333v-.3H5.998v.3Zm3.333 0v-.3.3Zm0 0h2.667v-.3H9.331v.3Zm2.667-.3a.18.18 0 0 1-.183-.184h-.3c0 .27.213.484.483.484v-.3Zm-.183-.184v-.333h-.3v.333h.3Zm-.15-.483h-2v.3h2v-.3Zm-1.85.15v-3h-.3v3h.3Zm0-3c0-.636-.514-1.15-1.15-1.15v.3c.47 0 .85.38.85.85h.3Zm-1.15-1.15h-2v.3h2v-.3Zm-2 0c-.636 0-1.15.514-1.15 1.15h.3c0-.47.38-.85.85-.85v-.3Zm-1.15 1.15v3h.3v-3h-.3Zm0 3v.333h.3v-.333h-.3Zm0 .333c0 .2.118.371.292.445l.117-.276a.18.18 0 0 1-.11-.169h-.3Zm0 0c0 .2.118.372.292.445l.117-.276a.18.18 0 0 1-.11-.169h-.3Zm0-.333v.333h.3v-.333h-.3Zm-1.517.15h1.667v-.3H3.998v.3Zm-.483-.483c0 .271.222.483.483.483v-.3a.184.184 0 0 1-.183-.183h-.3Zm0-13.88v13.88h.3V3.5h-.3Zm.174-.369a.469.469 0 0 0-.174.369h.3c0-.055.02-.1.066-.138l-.192-.23Zm.31-.115a.464.464 0 0 0-.314.118l.2.224a.165.165 0 0 1 .113-.042v-.3Zm.106.015c-.046-.016-.09-.015-.107-.015v.3a.639.639 0 0 1 .018 0H4.01l.094-.285Zm7.302 1.1L4.08 3.025l-.044.296 7.326 1.107.045-.297Zm.408.482a.487.487 0 0 0-.406-.481l-.049.296a.187.187 0 0 1 .155.185h.3Zm0 4.1v-4.1h-.3v4.1h.3Zm-.131-.371a.504.504 0 0 0-.17.371h.3c0-.053.025-.107.072-.149l-.202-.222Zm.383-.107a.502.502 0 0 0-.372.098l.18.24a.202.202 0 0 1 .15-.041l.042-.297Zm0 0a.502.502 0 0 0-.372.098l.18.24a.202.202 0 0 1 .15-.041l.042-.297Zm-.383.107a.504.504 0 0 0-.17.371h.3c0-.053.026-.107.072-.149l-.202-.222Zm-.17.371v9h.3v-9h-.3Zm0 9v.333h.3v-.333h-.3Zm0 .333c0 .27.215.484.484.484v-.3a.18.18 0 0 1-.183-.184h-.3Zm.484.484a.494.494 0 0 0 .127-.017l-.077-.29a.195.195 0 0 1-.05.007v.3Zm.05-.307a.195.195 0 0 1-.05.007v.3a.494.494 0 0 0 .127-.017l-.077-.29Zm-.05.307h6v-.3h-6v.3Zm6 0c.636 0 1.15-.514 1.15-1.15h-.3c0 .47-.38.85-.85.85v.3Zm1.15-1.15v-6.8h-.3v6.8h.3Zm0-6.8c0-.544-.37-1.006-.912-1.12l-.062.293a.835.835 0 0 1 .674.827h.3Zm-.914-1.12L12.36 8.292l-.059.294 5.873 1.166.059-.294ZM12.48 8.44h-.3.3Zm-.123-.148-.053.295.053-.295Zm-.177-3.679V8.44h.3V4.613h-.3Zm-.714-.839c.415.068.714.42.714.839h.3c0-.567-.407-1.043-.965-1.135l-.049.296ZM9.998 5.863a.18.18 0 0 1 .183.183h.3a.48.48 0 0 0-.483-.483v.3Zm-1.333 0h1.333v-.3H8.665v.3Zm-.184.183a.18.18 0 0 1 .184-.183v-.3a.48.48 0 0 0-.484.483h.3Zm.184.184a.18.18 0 0 1-.184-.184h-.3c0 .27.214.484.484.484v-.3Zm1.333 0H8.665v.3h1.333v-.3Zm.183-.184a.18.18 0 0 1-.183.184v.3a.48.48 0 0 0 .483-.484h-.3Zm2.3 11.667V9.12h-.3v8.593h.3Zm0 0h-.3.3Zm5.517-.15h-5.667v.3h5.667v-.3Zm.183-.183a.184.184 0 0 1-.183.183v.3c.26 0 .483-.212.483-.483h-.3Zm0-6.8v6.8h.3v-6.8h-.3Zm-.142-.18a.185.185 0 0 1 .142.18h.3a.485.485 0 0 0-.378-.473l-.064.293Zm-5.737-1.133 5.74 1.133.058-.294-5.74-1.133-.058.294Zm4.18 2.78a.48.48 0 0 0-.484-.484v.3a.18.18 0 0 1 .183.183h.3Zm-.484.483a.48.48 0 0 0 .483-.484h-.3a.18.18 0 0 1-.183.184v.3Zm-1.333 0h1.333v-.3h-1.333v.3Zm-.484-.484c0 .27.214.484.484.484v-.3a.18.18 0 0 1-.184-.184h-.3Zm.484-.483a.48.48 0 0 0-.484.483h.3a.18.18 0 0 1 .184-.183v-.3Zm1.333 0h-1.333v.3h1.333v-.3Zm0 2.3a.18.18 0 0 1 .183.183h.3a.48.48 0 0 0-.483-.483v.3Zm-1.333 0h1.333v-.3h-1.333v.3Zm-.184.183a.18.18 0 0 1 .184-.183v-.3a.48.48 0 0 0-.484.483h.3Zm.184.184a.18.18 0 0 1-.184-.184h-.3c0 .27.214.484.484.484v-.3Zm1.333 0h-1.333v.3h1.333v-.3Zm.183-.184a.18.18 0 0 1-.183.184v.3a.48.48 0 0 0 .483-.484h-.3Zm.3 2a.48.48 0 0 0-.483-.483v.3a.18.18 0 0 1 .183.183h.3Zm-.483.484a.48.48 0 0 0 .483-.484h-.3a.18.18 0 0 1-.183.184v.3Zm-1.333 0h1.333v-.3h-1.333v.3Zm-.484-.484c0 .27.214.484.484.484v-.3a.18.18 0 0 1-.184-.184h-.3Zm.484-.483a.48.48 0 0 0-.484.483h.3a.18.18 0 0 1 .184-.183v-.3Zm1.333 0h-1.333v.3h1.333v-.3Zm-9.667 2.3h2.667v-.3H6.331v.3Zm-.15-3.15v3h.3v-3h-.3Zm.484-.483a.48.48 0 0 0-.484.483h.3a.18.18 0 0 1 .184-.183v-.3Zm2 0h-2v.3h2v-.3Zm.483.483a.484.484 0 0 0-.483-.483v.3c.099 0 .183.081.183.183h.3Zm0 3v-3h-.3v3h.3Zm.85-9.183a.48.48 0 0 0 .483-.484h-.3a.18.18 0 0 1-.183.184v.3Zm-1.333 0h1.333v-.3H8.665v.3Zm-.484-.484c0 .27.214.484.484.484v-.3a.18.18 0 0 1-.184-.184h-.3Zm.484-.483a.48.48 0 0 0-.484.483h.3a.18.18 0 0 1 .184-.183v-.3Zm1.333 0H8.665v.3h1.333v-.3Zm.483.483a.48.48 0 0 0-.483-.483v.3a.18.18 0 0 1 .183.183h.3Zm-.483 1.817a.18.18 0 0 1 .183.183h.3a.48.48 0 0 0-.483-.483v.3Zm-1.333 0h1.333v-.3H8.665v.3Zm-.184.183a.18.18 0 0 1 .184-.183v-.3a.48.48 0 0 0-.484.483h.3Zm.184.184a.18.18 0 0 1-.184-.184h-.3c0 .27.214.484.484.484v-.3Zm1.333 0H8.665v.3h1.333v-.3Zm.183-.184a.18.18 0 0 1-.183.184v.3a.48.48 0 0 0 .483-.484h-.3Zm.3 2a.48.48 0 0 0-.483-.483v.3a.18.18 0 0 1 .183.183h.3Zm-.483.484a.48.48 0 0 0 .483-.484h-.3a.18.18 0 0 1-.183.184v.3Zm-1.333 0h1.333v-.3H8.665v.3Zm-.484-.484c0 .27.214.484.484.484v-.3a.18.18 0 0 1-.184-.184h-.3Zm.484-.483a.48.48 0 0 0-.484.483h.3a.18.18 0 0 1 .184-.183v-.3Zm1.333 0H8.665v.3h1.333v-.3Zm-3.15.483a.18.18 0 0 1-.183.184v.3a.48.48 0 0 0 .483-.484h-.3Zm-.183-.183a.18.18 0 0 1 .183.183h.3a.48.48 0 0 0-.483-.483v.3Zm-1.334 0h1.334v-.3H5.33v.3Zm-.183.183a.18.18 0 0 1 .183-.183v-.3a.48.48 0 0 0-.483.483h.3Zm.183.184a.18.18 0 0 1-.183-.184h-.3c0 .27.214.484.483.484v-.3Zm1.334 0H5.33v.3h1.334v-.3Zm.483-6.184a.48.48 0 0 0-.483-.483v.3a.18.18 0 0 1 .183.183h.3Zm-.483.484a.48.48 0 0 0 .483-.484h-.3a.18.18 0 0 1-.183.184v.3Zm-1.334 0h1.334v-.3H5.33v.3Zm-.483-.484c0 .27.214.484.483.484v-.3a.18.18 0 0 1-.183-.184h-.3Zm.483-.483a.48.48 0 0 0-.483.483h.3a.18.18 0 0 1 .183-.183v-.3Zm1.334 0H5.33v.3h1.334v-.3Zm0 2.3a.18.18 0 0 1 .183.183h.3a.48.48 0 0 0-.483-.483v.3Zm-1.334 0h1.334v-.3H5.33v.3Zm-.183.183a.18.18 0 0 1 .183-.183v-.3a.48.48 0 0 0-.483.483h.3Zm.183.184a.18.18 0 0 1-.183-.184h-.3c0 .27.214.484.483.484v-.3Zm1.334 0H5.33v.3h1.334v-.3Zm.183-.184a.18.18 0 0 1-.183.184v.3a.48.48 0 0 0 .483-.484h-.3Zm.3 2a.48.48 0 0 0-.483-.483v.3a.18.18 0 0 1 .183.183h.3Zm-.483.484a.48.48 0 0 0 .483-.484h-.3a.18.18 0 0 1-.183.184v.3Zm-1.334 0h1.334v-.3H5.33v.3Zm-.483-.484c0 .27.214.484.483.484v-.3a.18.18 0 0 1-.183-.184h-.3Zm.483-.483a.48.48 0 0 0-.483.483h.3a.18.18 0 0 1 .183-.183v-.3Zm1.334 0H5.33v.3h1.334v-.3Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function IcAiCallAnalysisReport(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 21 21" fill="none" {...props}>
      <path
        fill="currentColor"
        d="M13.06 11.272c-.777 1.6-2.423 2.742-4.342 2.742-2.605 0-4.799-2.148-4.799-4.799 0-2.605 2.102-4.798 4.799-4.798 1.28 0 2.514.502 3.428 1.417a4.7 4.7 0 0 1 1.142 1.873l1.051-1.05a6.3 6.3 0 0 0-1.28-1.829C11.872 3.686 10.319 3 8.673 3c-3.382.046-6.17 2.834-6.17 6.215 0 3.428 2.788 6.17 6.17 6.17 3.2 0 5.759-2.422 6.124-5.393-.685.64-.96 1.28-1.736 1.28m3.883 6.17c-.685.685-1.828.685-2.56 0l-2.101-2.103c.502-.32 1.005-.685 1.416-1.096a7 7 0 0 0 1.143-1.463l2.102 2.103a1.807 1.807 0 0 1 0 2.559"
      />
      <path
        fill="currentColor"
        d="m16.533 7.022-.868.868-2.377 2.33a.44.44 0 0 1-.64 0L11.14 8.714 8.764 11.09a.44.44 0 0 1-.64 0l-1.051-1.05-1.509 1.507a5 5 0 0 1-.502-.822l1.69-1.6a.44.44 0 0 1 .64 0l1.052 1.051L10.82 7.8a.44.44 0 0 1 .64 0l1.097 1.097.411.41 2.422-2.421.503-.503a.44.44 0 0 1 .64 0 .44.44 0 0 1 0 .64"
      />
    </svg>
  );
}

export function IcVisibilitySettings(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 22 21" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.76 2.123a.85.85 0 0 0-1.52 0L7.757 7.088l-5.361.826a.85.85 0 0 0-.477 1.437l3.836 3.898-.911 5.48a.85.85 0 0 0 1.23.894L11 17.066l4.926 2.557a.85.85 0 0 0 1.23-.893l-.91-5.481 3.838-3.898a.85.85 0 0 0-.476-1.437l-5.365-.826-2.483-4.965Zm1.49 5.664L11 3.286l-2.25 4.5v.001a.85.85 0 0 1-.631.46l-4.865.75 3.481 3.537a.85.85 0 0 1 .233.736l-.826 4.966 4.466-2.319a.85.85 0 0 1 .783 0l4.467 2.319-.826-4.966a.85.85 0 0 1 .233-.736l3.484-3.538-4.867-.75a.85.85 0 0 1-.631-.459Zm.108 2.965.424-.424-.848-.848-.425.424-2.154 2.154-.864-.865-.425-.424-.848.848.424.424 1.112 1.113a.85.85 0 0 0 1.203 0l2.4-2.402Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function IcExtraInfo(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 22 23" fill="none" {...props}>
      <path
        d="M11.75 18.25a.5.5 0 0 1-.5-.5v-.92a.5.5 0 0 1 .146-.353l4.45-4.45a.5.5 0 0 1 .708 0l.92.92a.5.5 0 0 1 0 .707l-4.45 4.45a.5.5 0 0 1-.354.146h-.92ZM3.5 13.437a.5.5 0 0 1-.5-.5v-.374a.5.5 0 0 1 .5-.5h5.875a.5.5 0 0 1 .5.5v.374a.5.5 0 0 1-.5.5H3.5Zm15.666-1.476a.5.5 0 0 1-.707 0l-.92-.92a.5.5 0 0 1 0-.707l.311-.311a.65.65 0 0 1 .481-.183.65.65 0 0 1 .482.183l.664.665a.65.65 0 0 1 .183.48.65.65 0 0 1-.183.482l-.31.311ZM3.5 9.656a.5.5 0 0 1-.5-.5v-.375a.5.5 0 0 1 .5-.5h9.77a.5.5 0 0 1 .5.5v.375a.5.5 0 0 1-.5.5H3.5Zm0-3.781a.5.5 0 0 1-.5-.5V5a.5.5 0 0 1 .5-.5h9.77a.5.5 0 0 1 .5.5v.375a.5.5 0 0 1-.5.5H3.5Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function SvgGoogle(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 28 29" fill="none" {...props}>
      <path d="M25.999.5h-24a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2v-24a2 2 0 0 0-2-2Z" fill="#fff" />
      <mask
        id="googleLoginA"
        style={{
          maskType: 'luminance',
        }}
        maskUnits="userSpaceOnUse"
        x={4}
        y={5}
        width={20}
        height={20}
      >
        <path
          d="M23.068 12.772H14.21v3.671h5.1c-.475 2.332-2.462 3.671-5.1 3.671a5.615 5.615 0 0 1 0-11.23 5.494 5.494 0 0 1 3.5 1.253l2.764-2.764a9.5 9.5 0 1 0-6.264 16.629c4.75 0 9.07-3.456 9.07-9.5a7.878 7.878 0 0 0-.213-1.73Z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#googleLoginA)">
        <path d="M3.847 20.114V8.884l7.343 5.615-7.343 5.615Z" fill="#FBBC05" />
      </g>
      <mask
        id="googleLoginB"
        style={{
          maskType: 'luminance',
        }}
        maskUnits="userSpaceOnUse"
        x={4}
        y={5}
        width={20}
        height={20}
      >
        <path
          d="M23.068 12.772H14.21v3.671h5.1c-.475 2.332-2.462 3.671-5.1 3.671a5.615 5.615 0 0 1 0-11.23 5.494 5.494 0 0 1 3.5 1.253l2.764-2.764a9.5 9.5 0 1 0-6.264 16.629c4.75 0 9.07-3.456 9.07-9.5a7.878 7.878 0 0 0-.213-1.73Z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#googleLoginB)">
        <path d="m3.847 8.884 7.343 5.615 3.024-2.635L24.58 10.18V4.133H3.847v4.751Z" fill="#EA4335" />
      </g>
      <mask
        id="googleLoginC"
        style={{
          maskType: 'luminance',
        }}
        maskUnits="userSpaceOnUse"
        x={4}
        y={5}
        width={20}
        height={20}
      >
        <path
          d="M23.068 12.772H14.21v3.671h5.1c-.475 2.332-2.462 3.671-5.1 3.671a5.615 5.615 0 0 1 0-11.23 5.494 5.494 0 0 1 3.5 1.253l2.764-2.764a9.5 9.5 0 1 0-6.264 16.629c4.75 0 9.07-3.456 9.07-9.5a7.878 7.878 0 0 0-.213-1.73Z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#googleLoginC)">
        <path d="m3.847 20.115 12.958-9.935 3.412.432 4.363-6.479v20.733H3.847v-4.751Z" fill="#34A853" />
      </g>
      <mask
        id="googleLoginD"
        style={{
          maskType: 'luminance',
        }}
        maskUnits="userSpaceOnUse"
        x={4}
        y={5}
        width={20}
        height={20}
      >
        <path
          d="M23.068 12.772H14.21v3.671h5.1c-.475 2.332-2.462 3.671-5.1 3.671a5.615 5.615 0 0 1 0-11.23 5.494 5.494 0 0 1 3.5 1.253l2.764-2.764a9.5 9.5 0 1 0-6.264 16.629c4.75 0 9.07-3.456 9.07-9.5a7.878 7.878 0 0 0-.213-1.73Z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#googleLoginD)">
        <path d="M24.58 24.866 11.19 14.499l-1.728-1.296L24.58 8.884v15.982Z" fill="#4285F4" />
      </g>
    </svg>
  );
}

export function SvgForgotPassword(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 23 22" fill="none" {...props}>
      <path
        d="M16.302 10.44h-2.4a.6.6 0 0 1-.6-.6V6.162a1.8 1.8 0 1 0-3.6 0V9.84a.6.6 0 0 1-.6.6h-2.4a.6.6 0 0 1-.6-.6V6.162a5.4 5.4 0 1 1 10.8 0V9.84a.601.601 0 0 1-.6.6Z"
        fill="#F3F5F9"
      />
      <path
        d="M13.3 6.162V9.84a.6.6 0 0 0 .6.6h2.4a.599.599 0 0 0 .6-.6V6.162a5.4 5.4 0 0 0-5.4-5.4v3.6a1.8 1.8 0 0 1 1.8 1.8Z"
        fill="#E1E6F0"
      />
      <path
        d="M17.502 21.24h-12a1.801 1.801 0 0 1-1.8-1.8v-8.4a1.8 1.8 0 0 1 1.8-1.8h12a1.8 1.8 0 0 1 1.8 1.8v8.4a1.799 1.799 0 0 1-1.8 1.8Z"
        fill="#FFBE40"
      />
      <path d="M17.5 9.24h-6v12h6a1.801 1.801 0 0 0 1.8-1.8v-8.4a1.8 1.8 0 0 0-1.8-1.8Z" fill="#FF9F40" />
      <path
        d="M13.302 13.44a1.825 1.825 0 0 1-.732 1.452 1.153 1.153 0 0 0-.468.924.612.612 0 0 1-.83.572.584.584 0 0 1-.37-.548 2.34 2.34 0 0 1 .6-1.584c.104-.12.22-.229.348-.324l.012-.012a.576.576 0 0 0 .24-.48.6.6 0 1 0-1.2 0 .6.6 0 0 1-1.2 0 1.8 1.8 0 1 1 3.6 0Zm-1.801 5.559a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
        fill="#4D5E80"
      />
      <path
        d="M13.301 13.44a1.825 1.825 0 0 1-.732 1.452 1.153 1.153 0 0 0-.468.924.612.612 0 0 1-.6.612v-2.172c.104-.12.221-.229.348-.324l.012-.012a.576.576 0 0 0 .24-.48.593.593 0 0 0-.6-.6v-1.2a1.801 1.801 0 0 1 1.8 1.8ZM12.1 18.239a.601.601 0 0 0-.6-.6v1.2a.6.6 0 0 0 .6-.6Z"
        fill="#3D4B66"
      />
    </svg>
  );
}

export function SvgResetPassword(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 22 22" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.064 10.203h.542V7.599a3.807 3.807 0 0 1 3.796-3.796 3.807 3.807 0 0 1 3.795 3.796v2.604h.542c1.159 0 2.107.948 2.107 2.105v6.587A2.112 2.112 0 0 1 13.739 21H5.064a2.111 2.111 0 0 1-2.106-2.105v-6.587c0-1.157.947-2.105 2.106-2.105Zm2.76 0h3.155V7.599c0-.864-.714-1.578-1.577-1.578-.864 0-1.578.714-1.578 1.578v2.604Z"
        fill="#23A8FE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.846 13.016v5.347h-4.984l-2.286 2.215v-7.562h7.27Z"
        fill="#0083E0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.902 8.054a8.599 8.599 0 0 0-2.496-4.63A8.604 8.604 0 0 0 9.402 1C4.634 1 .754 4.879.754 9.646a.443.443 0 0 0 .886 0c0-4.279 3.482-7.76 7.762-7.76A7.73 7.73 0 0 1 17 8.054h-1.197l1.746 2.038 1.745-2.038h-1.392Z"
        fill="#FFB74D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.098 3.815A3.807 3.807 0 0 1 13.197 7.6v2.603a2.251 2.251 0 0 0-.125-.004h-.542V7.593a3.809 3.809 0 0 0-3.432-3.778Zm4.123 6.388h.518c1.158 0 2.107.948 2.107 2.105v6.587A2.112 2.112 0 0 1 13.739 21h-.085c.883-.267 1.524-1.147 1.524-2.111v-6.585a2.113 2.113 0 0 0-1.957-2.101Zm-4.14-4.148a1.59 1.59 0 0 0-1.257 1.544v2.6h-.668V7.592c0-.862.715-1.577 1.578-1.577.119 0 .234.014.346.039Z"
        fill="#0083E0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.054 12.18H7.116c-.655 0-1.191.537-1.191 1.192v2.963c0 .656.536 1.191 1.191 1.191h1.46v2.216l2.286-2.216h9.192c.655 0 1.191-.535 1.191-1.19v-2.964c0-.655-.536-1.191-1.191-1.191Z"
        fill="#FFB74D"
      />
      <path
        d="M11.155 14.079a.282.282 0 0 0-.385-.103l-.675.39v-.78a.282.282 0 0 0-.564 0v.78l-.675-.39a.282.282 0 0 0-.281.488l.675.39-.675.39a.282.282 0 1 0 .281.488l.675-.39v.779a.282.282 0 1 0 .564 0v-.779l.675.39a.281.281 0 0 0 .385-.103.282.282 0 0 0-.103-.386l-.675-.39.675-.39a.282.282 0 0 0 .103-.384Zm3.771 0a.282.282 0 0 0-.385-.103l-.675.39v-.78a.282.282 0 0 0-.564 0v.78l-.675-.39a.282.282 0 0 0-.281.488l.675.39-.675.39a.282.282 0 1 0 .281.488l.675-.39v.779a.282.282 0 1 0 .564 0v-.779l.675.39a.281.281 0 0 0 .385-.103.282.282 0 0 0-.103-.385l-.675-.39.675-.39a.282.282 0 0 0 .103-.385Zm3.667 1.165-.674-.39.674-.39a.282.282 0 1 0-.281-.488l-.674.39v-.78a.282.282 0 0 0-.564 0v.78l-.675-.39a.282.282 0 1 0-.282.488l.675.39-.675.39a.282.282 0 0 0 .282.488l.675-.39v.779a.282.282 0 1 0 .564 0v-.778l.674.389a.28.28 0 0 0 .385-.103.282.282 0 0 0-.104-.385Z"
        fill="#EAF6FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.362 12.935h12.936c.655 0 1.192.536 1.192 1.191v2.965c0 .13-.022.256-.06.375.471-.159.815-.606.815-1.13v-2.964c0-.655-.536-1.191-1.191-1.191H7.116c-.524 0-.972.342-1.13.815.118-.04.244-.061.376-.061Z"
        fill="#E09109"
      />
    </svg>
  );
}

export function SvgIcAllocation(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 21 21" fill="none" {...props}>
      <path
        d="M1.757 17.376v-2.08a2.71 2.71 0 0 1 .373-1.405c.24-.413.602-.742 1.036-.941a15.73 15.73 0 0 1 2.726-1.02 10.041 10.041 0 0 1 2.5-.31 9.918 9.918 0 0 1 2.488.31c.934.257 1.843.598 2.716 1.02.436.2.8.529 1.047.94.256.425.389.912.383 1.407v2.079H1.756Zm14.51 0v-2.08a3.754 3.754 0 0 0-.662-2.291 4.918 4.918 0 0 0-1.741-1.451c.91.11 1.81.283 2.695.52a9.11 9.11 0 0 1 2.052.786c.434.26.803.616 1.078 1.04.264.42.401.906.394 1.4v2.076h-3.815ZM8.392 10.27a2.93 2.93 0 0 1-2.24-.93 3.36 3.36 0 0 1-.87-2.392 3.36 3.36 0 0 1 .87-2.392 2.929 2.929 0 0 1 2.24-.93 2.929 2.929 0 0 1 2.239.93 3.36 3.36 0 0 1 .87 2.392 3.36 3.36 0 0 1-.87 2.392 2.93 2.93 0 0 1-2.24.93Zm7.466-3.322a3.36 3.36 0 0 1-.871 2.392 2.93 2.93 0 0 1-2.24.93 4.357 4.357 0 0 1-.507-.033 2.075 2.075 0 0 1-.508-.122c.346-.395.604-.86.757-1.362a5.9 5.9 0 0 0 .259-1.8 5.475 5.475 0 0 0-.26-1.761 4.8 4.8 0 0 0-.756-1.406 4.13 4.13 0 0 1 1.016-.155 2.929 2.929 0 0 1 2.239.93 3.36 3.36 0 0 1 .87 2.387Zm-12.852 9.1H13.78v-.753a1.329 1.329 0 0 0-.2-.687 1.11 1.11 0 0 0-.487-.465c-.802-.4-1.643-.72-2.508-.952a9.4 9.4 0 0 0-2.2-.244 9.533 9.533 0 0 0-2.208.244c-.87.231-1.714.55-2.52.952-.204.1-.372.262-.476.465a1.385 1.385 0 0 0-.187.687l.01.753Zm5.39-7.11a1.753 1.753 0 0 0 1.333-.562c.357-.388.547-.901.529-1.428a2.008 2.008 0 0 0-.53-1.428 1.753 1.753 0 0 0-1.336-.565 1.753 1.753 0 0 0-1.337.565 2.008 2.008 0 0 0-.53 1.428c-.016.527.175 1.04.533 1.428a1.753 1.753 0 0 0 1.334.565l.004-.002Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function SvgIcMerge(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 20 21" fill="none" {...props}>
      <path
        d="M10 2 5.955 6.044h8.09L10 2Zm5.145 11.832a4.646 4.646 0 0 0-1.011-1.513l-2.19-2.19a1.873 1.873 0 0 1-.552-1.332V6.045H8.609v2.752a1.87 1.87 0 0 1-.552 1.331l-2.19 2.191a4.64 4.64 0 0 0-1.011 1.513 4.637 4.637 0 0 0-.356 1.786v2.752h2.783v-2.753c0-.248.048-.49.144-.72a1.85 1.85 0 0 1 .407-.61L10 12.12l2.166 2.166a1.877 1.877 0 0 1 .551 1.33v2.753H15.5v-2.752c0-.616-.119-1.216-.355-1.786Z"
        fill="#9D9D9D"
      />
    </svg>
  );
}

export function SvgIcArchive(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 20 21" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 7.276c0-.34.124-.67.35-.937l2.13-2.495A2.463 2.463 0 0 1 6.352 3h7.293c.73 0 1.42.31 1.875.844l2.128 2.495c.227.266.351.597.351.937v8.474c0 1.243-1.075 2.25-2.4 2.25H4.4C3.075 18 2 16.993 2 15.75V7.276ZM6.354 4.5h7.292c.243 0 .473.104.625.281l1.42 1.664c.105.123.012.305-.156.305H4.465c-.168 0-.26-.182-.156-.305l1.42-1.664a.821.821 0 0 1 .625-.281Zm4.448 5.25c0-.415-.359-.75-.8-.75-.442 0-.8.335-.8.75v3.814l-.636-.596a.838.838 0 0 0-1.132 0 .717.717 0 0 0 0 1.061l1.436 1.346a1.676 1.676 0 0 0 2.263 0l1.433-1.343a.717.717 0 0 0 0-1.06.838.838 0 0 0-1.132 0l-.632.592V9.75Z"
        fill="#9D9D9D"
      />
    </svg>
  );
}

export function SvgIcEmail(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 20 21" fill="none" {...props}>
      <path
        d="M3.077 16.466a1.534 1.534 0 0 1-1.576-1.47V5.472A1.535 1.535 0 0 1 3.08 4h13.643a1.535 1.535 0 0 1 1.578 1.47v9.524a1.535 1.535 0 0 1-1.578 1.472H3.077Zm-.13-1.356h13.909V6.846L9.9 10.889 2.944 6.846l.003 8.264ZM9.9 9.578l7.263-4.221H2.638L9.9 9.577Z"
        fill="#9D9D9D"
      />
      <path
        d="M16.73 16.616H3.077a1.684 1.684 0 0 1-1.726-1.623V5.472A1.685 1.685 0 0 1 3.077 3.85h13.646a1.684 1.684 0 0 1 1.728 1.623v9.521a1.686 1.686 0 0 1-1.724 1.622h.003ZM16.723 4.15H3.08a1.385 1.385 0 0 0-1.429 1.319v9.527a1.384 1.384 0 0 0 1.43 1.32h13.642a1.386 1.386 0 0 0 1.43-1.319V5.47a1.385 1.385 0 0 0-1.43-1.32Zm.284 11.11H2.798V6.585l7.106 4.13 7.106-4.13-.003 8.675Zm-13.909-.3h13.61V7.106L9.9 11.062 3.095 7.106l.003 7.854Zm6.8-5.209L2.08 5.207h15.644L9.898 9.751ZM3.192 5.507l6.706 3.9 6.706-3.9H3.192Z"
        fill="#9D9D9D"
      />
    </svg>
  );
}

export function SvgIcTaskLogs(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 20 21" fill="none" {...props}>
      <path
        d="M13.8 3.384v.79c0 .763-.628 1.384-1.4 1.384H7.6c-.772 0-1.4-.62-1.4-1.384v-.79C6.2 2.62 6.828 2 7.6 2h4.8c.772 0 1.4.62 1.4 1.384ZM17 5.756v11.07C17 18.025 16.013 19 14.8 19H5.2C3.987 19 3 18.025 3 16.826V5.756c0-1.132.882-2.053 2-2.155v.573c0 1.417 1.166 2.57 2.6 2.57h4.8c1.434 0 2.6-1.153 2.6-2.57v-.573c1.118.102 2 1.023 2 2.155Zm-3.2 10.279a.597.597 0 0 0-.6-.593H6.8c-.331 0-.6.265-.6.593 0 .327.269.593.6.593h6.4c.331 0 .6-.266.6-.593Zm0-3.163a.597.597 0 0 0-.6-.593H6.8c-.331 0-.6.266-.6.593 0 .328.269.593.6.593h6.4c.331 0 .6-.265.6-.593Zm0-3.163a.597.597 0 0 0-.6-.593H6.8c-.331 0-.6.266-.6.593 0 .328.269.593.6.593h6.4c.331 0 .6-.265.6-.593Z"
        fill="currentColor"
      />
    </svg>
  );
}
export function SvgIcQuestionnaire(props) {
  return (
    <svg width="221" height="148" viewBox="0 0 221 148" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_26929_60286)">
        <path d="M232.716 -7.48242H-11.7285V155.481H232.716V-7.48242Z" fill="white" />
        <path
          d="M88.9228 75.0965C88.0078 75.653 87.0276 76.0922 86.0433 76.5102C85.0052 76.9518 83.9639 77.3853 82.9217 77.818C80.8032 78.6972 78.6749 79.5552 76.5181 80.3366C74.9634 80.9004 73.3933 81.4235 71.806 81.8863C70.6498 81.1172 69.5245 80.3023 68.4351 79.4419C67.0328 78.3346 63.5633 80.4034 62.2841 79.1567C61.0048 77.9092 59.7907 76.5941 58.6492 75.2187C58.0976 74.5546 59.6889 70.6256 59.1723 69.9346C60.6838 69.5329 62.1993 69.1467 63.7198 68.7776C66.0265 68.2186 68.3414 67.6963 70.6653 67.2132C72.9891 66.73 75.3203 66.2843 77.658 65.8769C79.9705 65.4743 82.3041 65.027 84.6532 64.926C86.5427 64.8453 88.5211 65.014 90.2004 65.9608C90.9444 66.3796 91.6068 66.9655 92.0297 67.7143C92.5007 68.5462 92.6319 69.5142 92.4738 70.452C92.1291 72.4997 90.6364 74.0535 88.922 75.0973L88.9228 75.0965Z"
          fill="#FFEDE5"
        />
        <path
          d="M83.4962 83.3821C82.8875 81.5602 82.1501 79.7815 81.2872 78.0647C80.2279 75.9559 78.9829 73.9401 77.5676 72.0521C77.205 71.569 76.8424 71.076 76.4342 70.6303C76.039 70.2001 75.5802 69.8652 74.9985 69.7503C74.3539 69.6232 73.676 69.7201 73.0274 69.7707C72.3544 69.8228 71.6813 69.875 71.0083 69.9336C68.3708 70.1634 65.7275 70.4967 63.1771 71.2308C60.9274 71.8786 58.7788 72.8523 56.7833 74.0745C54.7805 75.3016 52.9341 76.7773 51.2702 78.4338C49.4931 80.2035 47.9303 82.1795 46.5753 84.289C45.1477 86.5118 38.8647 97.0653 38.8516 97.3709C37.9757 97.9779 21.5189 111.173 21.5189 111.173C19.7825 112.592 22.293 118.538 27.1265 124.454C31.9599 130.37 37.2864 134.016 39.0228 132.598C40.2401 131.637 51.4992 122.453 51.6125 122.358C52.9096 122.364 54.2068 122.258 55.4877 122.05C57.9713 121.647 60.3896 120.875 62.6785 119.836C67.8208 117.503 72.1654 113.782 75.0311 108.903C77.2091 105.195 78.8468 101.075 80.2956 97.0352C81.0827 94.8401 81.6848 92.5602 82.2136 90.291C82.5885 88.685 84.0193 84.9507 83.4954 83.383L83.4962 83.3821Z"
          fill="#FFEDE5"
        />
        <path
          d="M61.6033 81.4036C64.2816 83.9809 66.4889 87.034 68.09 90.3886C68.5422 91.3354 68.9448 92.305 69.2992 93.2926C69.3937 93.5566 69.7889 93.3716 69.6944 93.1092C68.4282 89.5778 66.5199 86.2786 64.0933 83.4186C63.4146 82.6185 62.6951 81.8534 61.939 81.1258C61.7385 80.9335 61.4012 81.2089 61.6033 81.4036Z"
          fill="#3F3D56"
        />
        <path
          d="M97.5602 81.986C96.6451 82.5425 95.6649 82.9817 94.6806 83.3997C93.6425 83.8413 92.6012 84.2748 91.5591 84.7075C89.4405 85.5866 87.3122 86.4446 85.1554 87.226C83.6008 87.7899 82.0306 88.313 80.4434 88.7758C79.2871 88.0066 78.1619 87.191 77.0725 86.3314C75.6702 85.224 74.3257 84.0434 73.0457 82.7959C71.7664 81.5484 70.5523 80.2333 69.4108 78.8579C68.8591 78.1938 68.3262 77.5151 67.8088 76.8233C69.3203 76.4216 70.8359 76.0354 72.3563 75.6663C74.6631 75.1073 76.9779 74.585 79.3018 74.1018C81.6257 73.6186 83.9568 73.1729 86.2945 72.7655C88.607 72.363 90.9406 71.9157 93.2897 71.8146C95.1793 71.734 97.1576 71.9026 98.837 72.8495C99.5809 73.2683 100.243 73.8541 100.666 74.6029C101.137 75.4349 101.268 76.4029 101.11 77.3407C100.766 79.3883 99.2729 80.9422 97.5585 81.986H97.5602Z"
          fill="#FFEDE5"
        />
        <path
          d="M96.4076 90.7815C95.4845 91.3242 94.4969 91.7471 93.5069 92.1504C92.4623 92.5757 91.4136 92.9938 90.365 93.4101C88.2334 94.2567 86.0921 95.0813 83.9239 95.8301C82.3611 96.3695 80.7828 96.8682 79.1882 97.3066C78.0442 96.5203 76.9319 95.6867 75.8556 94.81C74.4704 93.6815 73.1439 92.4796 71.8842 91.2126C70.6236 89.9455 69.4308 88.6117 68.3104 87.2192C67.7693 86.5469 67.2462 85.8592 66.7402 85.1601C68.2582 84.782 69.7795 84.4186 71.3048 84.074C73.6197 83.55 75.9428 83.0644 78.2731 82.6171C80.6035 82.1697 82.942 81.7599 85.2862 81.3892C87.6044 81.0225 89.9445 80.611 92.2953 80.5466C94.1856 80.4945 96.1616 80.6949 97.8262 81.667C98.5637 82.098 99.2163 82.6937 99.6286 83.4482C100.087 84.2875 100.203 85.2571 100.03 86.1925C99.6539 88.2344 98.1375 89.7655 96.4068 90.7823L96.4076 90.7815Z"
          fill="#FFEDE5"
        />
        <path
          d="M144.699 126.893L68.1037 133.083C66.5572 133.208 65.203 132.055 65.0775 130.51L56.5073 24.46C56.3826 22.9135 57.5348 21.5592 59.0805 21.4338L135.676 15.2436C137.223 15.1189 138.577 16.2711 138.703 17.8168L147.273 123.867C147.397 125.413 146.245 126.767 144.7 126.893H144.699Z"
          fill="#3F3D56"
        />
        <path
          d="M134.929 24.341C134.84 23.0528 133.732 22.0758 132.443 22.1483C128.989 22.3431 125.535 22.5402 122.08 22.7562C110.467 23.4805 98.853 24.3125 87.2403 25.2577C79.4335 25.8924 71.6259 26.5719 63.8208 27.302C62.5171 27.4242 61.5638 28.5854 61.6958 29.8882C62.104 33.9273 62.5049 37.9671 62.8968 42.0094C64.6837 60.4511 66.2995 78.9205 67.7434 97.4144C68.4229 106.119 69.0691 114.829 69.6737 123.546C69.7633 124.838 70.8771 125.816 72.1702 125.736L139.261 121.571C140.567 121.49 141.558 120.36 141.468 119.055L134.929 24.3426V24.341Z"
          fill="white"
        />
        <path
          d="M115.433 17.1476C115.56 18.7137 115.687 20.2797 115.813 21.845C115.913 23.0835 115.308 24.2846 114.179 24.85C113.743 25.0692 113.28 25.1442 112.803 25.1833C111.859 25.2599 110.915 25.3357 109.971 25.4123C108.271 25.55 106.57 25.6869 104.871 25.8246C102.757 25.9957 100.643 26.166 98.5291 26.3371C96.3837 26.5106 94.2383 26.6842 92.0929 26.8569C90.253 27.0052 88.4132 27.1543 86.5733 27.3026C85.4187 27.3963 84.2633 27.4892 83.1087 27.5829C82.8952 27.6 82.6817 27.618 82.4683 27.6351C81.3014 27.7263 80.1493 27.1177 79.5895 26.0845C79.1903 25.3479 79.2 24.4907 79.134 23.6759C79.0534 22.6729 78.9719 21.6706 78.8912 20.6676C78.8749 20.4663 78.8586 20.2659 78.8423 20.0646C78.8195 19.786 78.3909 19.8626 78.4129 20.1404C78.54 21.7138 78.6671 23.2872 78.7943 24.8606C78.9002 26.1766 79.7117 27.3401 80.9478 27.8363C81.519 28.0661 82.113 28.1003 82.7168 28.0514C83.6383 27.9773 84.5599 27.9023 85.4814 27.8282C87.1983 27.6897 88.9151 27.5503 90.6319 27.4118C92.7618 27.2399 94.8917 27.068 97.0217 26.8952C99.1964 26.7192 101.371 26.544 103.546 26.368C105.398 26.2181 107.249 26.069 109.101 25.9191C110.249 25.8262 111.395 25.7341 112.542 25.6412C112.734 25.6257 112.925 25.6111 113.117 25.5948C114.451 25.4791 115.631 24.5754 116.072 23.3068C116.363 22.4708 116.228 21.6079 116.159 20.7491C116.076 19.7249 115.994 18.7006 115.911 17.6764C115.894 17.4751 115.878 17.2747 115.862 17.0734C115.839 16.794 115.41 16.8714 115.432 17.1492L115.433 17.1476Z"
          fill="#040404"
        />
        <path
          d="M209.35 70.1598L189.071 54.5602C189.071 54.5602 181.589 42.2182 175.19 40.5625C169.253 39.0265 163.733 40.5323 158.42 42.9711C152.181 45.8351 141.455 50.491 137.878 53.4716C134.902 55.9511 133.275 61.2433 138.328 63.119C139.546 63.5712 140.868 63.5044 142.121 63.2445C143.467 62.9658 144.784 62.5062 146.053 61.9823C147.819 61.2539 149.508 60.3592 151.158 59.3985C151.219 59.7285 151.299 60.0553 151.398 60.3763C150.46 61.3451 149.823 62.6048 149.652 63.9501C149.38 66.0963 150.25 68.2784 151.913 69.6571C152.966 70.5305 154.217 71.0594 155.532 71.3494C155.498 71.457 155.468 71.5654 155.443 71.6754C155.229 72.6083 155.363 73.5731 155.837 74.4058C156.302 75.2231 157.029 75.8651 157.814 76.3679C158.686 76.9277 159.659 77.34 160.651 77.6341C162.732 78.2517 164.956 78.3218 167.094 77.9967C168.856 77.7286 170.559 77.1835 172.185 76.4608C172.731 76.9089 192.598 92.1777 192.598 92.1777C194.383 93.5352 199.58 89.7072 204.205 83.6271C208.831 77.5469 211.134 71.5173 209.35 70.1598Z"
          fill="#FFEDE5"
        />
        <path
          d="M133.667 80.5498C133.737 80.6338 133.833 80.6981 133.943 80.7315C134.304 80.8399 134.603 80.5873 134.81 80.3201C135.118 79.9241 135.42 79.5224 135.724 79.1231C135.832 78.9805 135.771 78.8273 135.656 78.7483C135.662 78.719 135.663 78.688 135.659 78.653C135.63 78.4631 135.557 78.292 135.443 78.1372C135.336 77.9897 135.115 78.0109 135.01 78.1445C134.696 78.5462 134.383 78.9471 134.068 79.3488C133.885 79.5835 133.632 79.8149 133.56 80.1139C133.522 80.2761 133.568 80.4325 133.665 80.5498H133.667Z"
          fill="#6A687D"
        />
        <path
          d="M135.914 71.6365C136.818 70.5039 145.76 60.6569 145.76 60.6569L172.899 28.3316C173.607 27.4434 174.902 27.2967 175.79 28.0056C176.678 28.7145 176.823 30.0093 176.114 30.8974L150.616 64.5313C150.616 64.5313 142.998 75.436 142.094 76.5686C141.283 77.5863 137.919 78.7596 137.919 78.7596L135.237 79.7635C135.237 79.7635 134.947 79.2624 134.32 79.0318L134.704 76.1938C134.704 76.1938 135.102 72.6542 135.914 71.6365Z"
          fill="#3F3D56"
        />
        <path
          d="M138.939 78.5944C139.761 78.231 140.6 77.8716 141.358 77.3852C141.854 77.0674 142.273 76.6698 142.634 76.2054C142.879 75.8908 143.101 75.5592 143.323 75.2292C143.481 74.997 143.126 74.7419 142.97 74.975C142.626 75.4842 142.286 76.0155 141.846 76.4482C141.396 76.8906 140.85 77.2059 140.289 77.4887C139.786 77.7421 139.271 77.9719 138.756 78.1992C138.5 78.3125 138.683 78.7085 138.94 78.5944H138.939Z"
          fill="#6A687D"
        />
        <path
          d="M138.392 69.2479C139.758 67.6965 141.124 66.1459 142.49 64.5945C142.676 64.3834 142.32 64.1308 142.136 64.3402C140.771 65.8916 139.404 67.4422 138.039 68.9936C137.853 69.2047 138.209 69.4573 138.392 69.2479Z"
          fill="#6A687D"
        />
        <path
          d="M141.89 76.4356C140.365 74.445 138.394 72.8202 136.155 71.6958C135.904 71.5695 135.751 71.9785 136 72.1032C138.171 73.1934 140.078 74.7848 141.554 76.7134C141.725 76.9367 142.06 76.658 141.89 76.4356Z"
          fill="#6A687D"
        />
        <path
          d="M175.346 31.5136C174.563 30.4959 173.514 29.6859 172.371 29.1099C172.12 28.9836 171.968 29.3926 172.216 29.5173C173.291 30.0591 174.276 30.8348 175.01 31.7906C175.182 32.013 175.517 31.7352 175.346 31.5127V31.5136Z"
          fill="#040404"
        />
        <path
          d="M173.768 29.9197C173.468 29.7413 173.168 29.5637 172.869 29.3844C172.72 29.2956 172.574 29.1913 172.42 29.1131C172.298 29.0512 172.12 29.0463 171.984 29.03C171.385 28.9591 170.775 29.0161 170.195 29.1783C169.692 29.3184 169.214 29.5368 168.769 29.8097C167.619 30.5194 166.746 31.5494 166.079 32.7129C164.71 35.102 164.147 37.9098 162.443 40.1147C162.048 40.6264 161.591 41.0909 161.07 41.4746C160.899 41.6009 160.679 41.6906 160.558 41.8698C160.444 42.0393 160.381 42.2495 160.42 42.4532C160.539 43.0757 161.33 43.2403 161.855 43.1287C162.335 43.0269 162.75 42.6439 163.105 42.3245C165.15 40.4822 165.903 37.7379 166.987 35.3081C167.549 34.046 168.237 32.8026 169.261 31.8549C170.18 31.0051 171.381 30.3141 172.657 30.2571C172.961 30.2432 173.269 30.2644 173.567 30.3272C173.799 30.3769 174.01 30.0648 173.767 29.9206L173.768 29.9197ZM160.958 42.098C160.958 42.098 160.958 42.098 160.958 42.0971C160.981 42.0613 160.974 42.0833 160.958 42.098Z"
          fill="#040404"
        />
        <path
          d="M190.442 61.41C190.432 60.2701 190.156 59.0951 189.508 58.1491C189.613 58.0212 189.676 57.8541 189.692 57.6838C189.732 57.2561 189.455 56.909 189.125 56.6718C188.673 56.3459 188.143 56.1137 187.652 55.853C187.099 55.5596 186.546 55.2655 185.993 54.9721C183.845 53.8306 181.709 52.6589 179.524 51.5874C177.42 50.5567 175.251 49.6327 172.982 49.0305C168.371 47.8067 163.522 48.6296 159.047 50.0132C156.702 50.7384 154.414 51.6338 152.144 52.5676C150.2 53.367 147.975 54.0155 146.3 55.3201C142.647 58.1654 144.038 63.0934 148.446 64.0614C150.091 64.4224 151.792 64.2301 153.428 63.9221C154.269 63.764 155.104 63.5766 155.941 63.3973C156.801 63.2124 157.661 63.0282 158.521 62.8432C160.228 62.4774 161.935 62.1107 163.642 61.7449C163.76 61.7196 163.879 61.6944 163.997 61.6683C165.019 63.2164 166.179 64.6733 167.46 66.0161C168.468 67.0713 169.549 68.0556 170.694 68.9576C173.08 70.835 175.626 72.0001 178.694 72.1794C181.241 72.3285 183.788 71.8885 186.27 71.2986C186.922 71.1438 187.586 70.971 188.132 70.5856C189.288 69.7692 189.35 67.6759 189.632 66.404C189.994 64.767 190.459 63.1007 190.442 61.4108V61.41Z"
          fill="#FFEDE5"
        />
        <path
          d="M152.567 52.2013C151.718 52.4718 150.878 52.7692 150.048 53.0943C149.222 53.4178 148.393 53.7625 147.624 54.2074C145.991 55.1525 144.564 56.598 144.184 58.5039C143.982 59.52 144.105 60.6126 144.628 61.5163C144.767 61.7566 145.164 61.5765 145.023 61.3329C144.089 59.7196 144.571 57.7265 145.699 56.3471C146.819 54.9774 148.432 54.2065 150.042 53.5645C150.932 53.2092 151.837 52.8874 152.751 52.5965C153.017 52.5117 152.832 52.1165 152.567 52.2013Z"
          fill="#3F3D56"
        />
        <path
          d="M150.705 64.707C154.772 64.5204 158.821 63.9655 162.787 63.0464C163.901 62.7881 165.009 62.5012 166.108 62.1867C166.374 62.1101 166.302 61.6799 166.032 61.7573C162.118 62.8769 158.103 63.6412 154.051 64.0347C152.913 64.1447 151.772 64.2254 150.629 64.2784C150.351 64.2914 150.428 64.72 150.705 64.7078V64.707Z"
          fill="#3F3D56"
        />
        <path
          d="M156.075 71.6536C159.834 72.1775 163.704 71.9062 167.35 70.851C168.172 70.6131 169.033 70.3735 169.784 69.9531C170.519 69.5416 171.083 68.9256 171.34 68.114C171.805 66.6408 171.349 65.0259 170.365 63.8737C169.308 62.636 167.713 61.8514 166.091 61.7544C165.811 61.7373 165.769 62.1716 166.049 62.1879C168.753 62.35 171.578 64.6983 171.017 67.6235C170.866 68.4106 170.409 69.0666 169.725 69.4837C169.019 69.9148 168.19 70.1519 167.402 70.3841C165.697 70.886 163.942 71.2177 162.172 71.3749C160.155 71.5542 158.12 71.4988 156.115 71.2193C155.837 71.1802 155.796 71.6145 156.073 71.6528L156.075 71.6536Z"
          fill="#3F3D56"
        />
        <path
          d="M172.253 76.5683C173.577 75.9889 174.51 74.6926 174.724 73.2731C174.942 71.8203 174.294 70.3863 173.158 69.481C172.519 68.9717 171.737 68.6466 170.921 68.579C170.642 68.5562 170.6 68.9897 170.879 69.0125C172.192 69.1217 173.387 69.9731 173.968 71.1489C174.544 72.3141 174.401 73.696 173.696 74.7748C173.297 75.3868 172.74 75.8781 172.07 76.1723C171.813 76.2847 171.996 76.6807 172.253 76.5674V76.5683Z"
          fill="#3F3D56"
        />
        <path
          d="M162.446 49.1914C165.884 48.2894 169.551 48.2968 172.985 49.2175C173.952 49.4766 174.899 49.8074 175.818 50.205C176.076 50.3167 176.229 49.9085 175.972 49.7976C172.656 48.3636 168.976 47.8209 165.385 48.2063C164.367 48.3155 163.359 48.5021 162.37 48.7612C162.101 48.8321 162.174 49.2615 162.446 49.1906V49.1914Z"
          fill="#3F3D56"
        />
        <path
          d="M174.443 72.1953C176.099 73.7459 178.105 74.9974 180.329 75.523C180.957 75.6713 181.595 75.7625 182.24 75.787C182.52 75.7976 182.562 75.3633 182.282 75.3535C180.049 75.2696 177.945 74.3668 176.158 73.0582C175.647 72.6834 175.16 72.276 174.698 71.8433C174.612 71.7626 174.457 71.8066 174.394 71.893C174.317 71.9981 174.359 72.1171 174.444 72.1969L174.443 72.1953Z"
          fill="#3F3D56"
        />
        <path
          d="M70.0941 62.6437C70.2677 61.5258 70.2555 60.2986 69.7772 59.2524C69.2818 58.1687 68.2543 57.5103 67.0549 57.5527C65.6436 57.6032 64.3668 58.4099 63.1967 59.1212C60.217 60.9326 57.2372 62.7431 54.2574 64.5544C51.5938 66.1735 48.8593 67.7208 46.3447 69.5688C44.0127 71.2832 41.9073 73.3283 40.5424 75.9089C39.0415 78.746 38.4345 81.9515 37.9913 85.0992C37.0314 91.9061 36.4024 98.7709 36.0267 105.633C36.0145 105.857 36.0047 106.081 35.9941 106.305C37.5146 105.888 39.0057 105.351 40.4724 104.782C44.61 103.174 48.5741 101.364 52.0264 98.5232C53.4361 97.3629 54.3389 95.3536 55.2344 93.803C56.9593 90.8143 57.471 88.0309 57.533 84.6217C57.5729 82.4184 57.4694 80.2127 57.2233 78.0225C61.77 75.1438 66.2425 71.8772 68.6927 66.9598C69.3698 65.6015 69.8619 64.1446 70.095 62.6429L70.0941 62.6437Z"
          fill="#FFEDE5"
        />
        <path
          d="M56.8727 78.516C57.5905 81.2147 57.8806 84.0193 57.7429 86.8084C57.6052 89.5975 57.0503 92.3622 56.0888 94.9843C55.5486 96.4574 54.8813 97.8834 54.0909 99.2384C53.9507 99.4788 54.3036 99.7354 54.4445 99.4926C55.8778 97.0368 56.9118 94.3699 57.5335 91.5962C58.1519 88.834 58.3475 85.9797 58.1161 83.1588C57.9849 81.5659 57.7127 79.9851 57.3021 78.4403C57.2304 78.1714 56.8001 78.2439 56.8727 78.516Z"
          fill="#3F3D56"
        />
        <path
          d="M43.851 108.934C46.3199 108.96 48.7603 108.071 50.6237 106.448C50.8356 106.264 50.5577 105.927 50.3459 106.112C48.5729 107.657 46.2457 108.525 43.8917 108.501C43.6131 108.497 43.5699 108.932 43.8502 108.934H43.851Z"
          fill="#3F3D56"
        />
        <path
          d="M57.2284 78.6513C59.5416 77.0722 61.7783 75.3847 64.0916 73.8064C64.3238 73.6483 64.0443 73.3134 63.8137 73.4707C61.5005 75.0498 59.2638 76.7373 56.9505 78.3156C56.7183 78.4736 56.9978 78.8085 57.2284 78.6513Z"
          fill="#3F3D56"
        />
        <rect
          x="73.834"
          y="39.5742"
          width="14.6667"
          height="14.6667"
          rx="7.33333"
          transform="rotate(-4 73.834 39.5742)"
          fill="#009F2B"
        />
        <path
          d="M101.581 41.9231L92.1078 42.5856C91.9889 42.594 91.87 42.5866 91.7579 42.5637C91.6459 42.5408 91.5428 42.5029 91.4547 42.4522C91.3666 42.4014 91.2951 42.3388 91.2444 42.268C91.1937 42.1972 91.1647 42.1194 91.1591 42.0393C91.1535 41.9592 91.1714 41.8782 91.2118 41.801C91.2521 41.7238 91.3142 41.6518 91.3944 41.5893C91.4746 41.5268 91.5713 41.475 91.6791 41.4367C91.7869 41.3984 91.9036 41.3745 92.0225 41.3663L101.496 40.7039C101.735 40.6874 101.97 40.7357 102.147 40.8381C102.324 40.9406 102.43 41.0888 102.442 41.2504C102.453 41.4119 102.369 41.5734 102.207 41.6996C102.046 41.8257 101.821 41.9061 101.581 41.9231Z"
          fill="#E6E6E6"
        />
        <path
          d="M123.071 44.0965L92.3622 46.2439C92.1223 46.2607 91.8877 46.2125 91.71 46.1101C91.5324 46.0076 91.4262 45.8592 91.4149 45.6975C91.4036 45.5358 91.4881 45.3741 91.6498 45.2479C91.8114 45.1217 92.037 45.0414 92.277 45.0246L122.986 42.8773C123.226 42.8605 123.46 42.9086 123.638 43.0111C123.816 43.1135 123.922 43.2619 123.933 43.4236C123.944 43.5853 123.86 43.747 123.698 43.8732C123.537 43.9994 123.311 44.0797 123.071 44.0965Z"
          fill="#E6E6E6"
        />
        <path
          d="M110.678 48.6392L92.2559 49.9274C92.112 49.9375 91.9694 49.8829 91.8597 49.7757C91.7499 49.6685 91.6819 49.5174 91.6706 49.3557C91.6593 49.194 91.7056 49.035 91.7994 48.9135C91.8931 48.7921 92.0267 48.7182 92.1706 48.7081L110.593 47.4199C110.737 47.4099 110.88 47.4644 110.989 47.5716C111.099 47.6788 111.167 47.8299 111.178 47.9916C111.19 48.1533 111.143 48.3123 111.05 48.4338C110.956 48.5552 110.822 48.6291 110.678 48.6392Z"
          fill="#E6E6E6"
        />
        <path d="M78.5146 46.7683L80.8953 48.8131L84.8809 44.0261" stroke="white" strokeWidth="1.22222" />
        <rect
          x="77.5"
          y="70.1309"
          width="14.6667"
          height="14.6667"
          rx="7.33333"
          transform="rotate(-4 77.5 70.1309)"
          fill="#009F2B"
        />
        <g clipPath="url(#clip1_26929_60286)">
          <path d="M82.1845 77.3249L84.5652 79.3698L88.5509 74.5827" stroke="white" strokeWidth="1.22222" />
        </g>
        <path
          d="M105.247 72.4798L95.7738 73.1422C95.6549 73.1507 95.536 73.1432 95.4239 73.1203C95.3119 73.0974 95.2089 73.0595 95.1207 73.0088C95.0326 72.9581 94.9612 72.8955 94.9104 72.8246C94.8597 72.7538 94.8307 72.6761 94.8251 72.596C94.8195 72.5158 94.8374 72.4348 94.8778 72.3576C94.9182 72.2804 94.9802 72.2085 95.0604 72.146C95.1406 72.0835 95.2374 72.0316 95.3451 71.9933C95.4529 71.9551 95.5696 71.9312 95.6885 71.923L105.162 71.2605C105.401 71.244 105.636 71.2923 105.813 71.3948C105.99 71.4972 106.096 71.6455 106.108 71.807C106.119 71.9685 106.035 72.1301 105.873 72.2562C105.712 72.3824 105.487 72.4628 105.247 72.4798Z"
          fill="#E6E6E6"
        />
        <path
          d="M126.737 74.6531L96.0282 76.8005C95.7883 76.8173 95.5537 76.7692 95.3761 76.6667C95.1984 76.5642 95.0923 76.4158 95.081 76.2542C95.0697 76.0925 95.1541 75.9307 95.3158 75.8046C95.4774 75.6784 95.703 75.598 95.943 75.5813L126.652 73.4339C126.892 73.4171 127.126 73.4653 127.304 73.5677C127.482 73.6702 127.588 73.8186 127.599 73.9803C127.61 74.1419 127.526 74.3037 127.364 74.4299C127.203 74.556 126.977 74.6364 126.737 74.6531Z"
          fill="#E6E6E6"
        />
        <path
          d="M114.344 79.1958L95.9219 80.484C95.778 80.4941 95.6354 80.4395 95.5257 80.3323C95.4159 80.2251 95.3479 80.074 95.3366 79.9124C95.3253 79.7507 95.3716 79.5916 95.4654 79.4702C95.5592 79.3487 95.6927 79.2748 95.8366 79.2648L114.259 77.9766C114.403 77.9665 114.546 78.0211 114.655 78.1283C114.765 78.2355 114.833 78.3866 114.844 78.5482C114.856 78.7099 114.809 78.869 114.716 78.9904C114.622 79.1119 114.488 79.1857 114.344 79.1958Z"
          fill="#E6E6E6"
        />
        <rect
          x="79.9434"
          y="99.4668"
          width="14.6667"
          height="14.6667"
          rx="7.33333"
          transform="rotate(-4 79.9434 99.4668)"
          fill="#FAFAFA"
        />
        <path
          d="M107.69 101.816L98.2172 102.478C98.0982 102.487 97.9794 102.479 97.8673 102.456C97.7552 102.433 97.6522 102.395 97.5641 102.345C97.476 102.294 97.4045 102.231 97.3538 102.161C97.3031 102.09 97.2741 102.012 97.2685 101.932C97.2629 101.852 97.2808 101.771 97.3211 101.694C97.3615 101.616 97.4236 101.544 97.5038 101.482C97.584 101.419 97.6807 101.368 97.7885 101.329C97.8963 101.291 98.013 101.267 98.1319 101.259L107.605 100.596C107.845 100.58 108.079 100.628 108.256 100.731C108.434 100.833 108.54 100.981 108.551 101.143C108.562 101.304 108.478 101.466 108.317 101.592C108.155 101.718 107.93 101.799 107.69 101.816Z"
          fill="#E6E6E6"
        />
        <path
          d="M129.18 103.989L98.4716 106.136C98.2317 106.153 97.9971 106.105 97.8194 106.003C97.6418 105.9 97.5356 105.752 97.5243 105.59C97.513 105.428 97.5975 105.267 97.7591 105.14C97.9208 105.014 98.1464 104.934 98.3863 104.917L129.095 102.77C129.335 102.753 129.57 102.801 129.747 102.904C129.925 103.006 130.031 103.155 130.042 103.316C130.054 103.478 129.969 103.64 129.808 103.766C129.646 103.892 129.42 103.972 129.18 103.989Z"
          fill="#E6E6E6"
        />
        <path
          d="M116.788 108.532L98.3653 109.82C98.2213 109.83 98.0788 109.775 97.969 109.668C97.8593 109.561 97.7912 109.41 97.7799 109.248C97.7686 109.087 97.815 108.928 97.9087 108.806C98.0025 108.685 98.1361 108.611 98.28 108.601L116.703 107.312C116.846 107.302 116.989 107.357 117.099 107.464C117.209 107.571 117.277 107.722 117.288 107.884C117.299 108.046 117.253 108.205 117.159 108.326C117.065 108.448 116.932 108.522 116.788 108.532Z"
          fill="#E6E6E6"
        />
      </g>
      <defs>
        <clipPath id="clip0_26929_60286">
          <rect width="220" height="146.667" fill="white" transform="translate(0.5 0.666016)" />
        </clipPath>
        <clipPath id="clip1_26929_60286">
          <rect width="8.55555" height="8.55555" fill="white" transform="translate(80.8789 73.084) rotate(-4)" />
        </clipPath>
      </defs>
    </svg>
  );
}
export function SvgIcAllSet(props) {
  return (
    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.8333 27.209L23.4583 32.834L32.8333 19.709M47.8333 25.334C47.8333 28.2887 47.2513 31.2145 46.1205 33.9444C44.9898 36.6742 43.3325 39.1546 41.2432 41.2439C39.1538 43.3332 36.6735 44.9905 33.9436 46.1213C31.2138 47.252 28.288 47.834 25.3333 47.834C22.3785 47.834 19.4527 47.252 16.7229 46.1213C13.9931 44.9905 11.5127 43.3332 9.42335 41.2439C7.33403 39.1546 5.67669 36.6742 4.54596 33.9444C3.41523 31.2145 2.83325 28.2887 2.83325 25.334C2.83325 19.3666 5.20378 13.6437 9.42335 9.42408C13.6429 5.20451 19.3659 2.83398 25.3333 2.83398C31.3006 2.83398 37.0236 5.20451 41.2432 9.42408C45.4627 13.6437 47.8333 19.3666 47.8333 25.334Z"
        stroke="#009F2B"
        strokeWidth="4.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function SvgIcApproveReject(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size || '1em'}
      height={props.size || '1em'}
      viewBox="0 0 20 21"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        d="M2 11.296v7.208h7.21v-7.208H2Zm5.61 5.608H3.6v-4.008h4.01v4.008ZM2 2.5v7.2h7.21V2.5H2Zm5.61 5.6H3.6v-4h4.01v4ZM18 12.444l-1.131-1.131-2.46 2.458-2.454-2.458-1.131 1.131 2.454 2.458-2.454 2.458 1.131 1.131 2.455-2.458 2.459 2.458 1.13-1.13-2.458-2.459L18 12.444Zm-1.349-8.911-3.44 3.44-1.44-1.439-1.13 1.131 2.57 2.57 4.571-4.571-1.13-1.131Z"
      />
    </svg>
  );
}
export function SvgIcParty(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size || '1em'}
      height={props.size || '1em'}
      viewBox="0 0 60 60"
      {...props}
    >
      <path fill="#fdc70e" d="M48.327 43.965 3.656 58.892a2.013 2.013 0 0 1-2.548-2.548l14.927-44.671z" />
      <path
        fill="#d39518"
        d="M48.327 43.967s-6.579-1.49-18.684-13.607C17.859 18.587 16.119 12.02 16.036 11.677v-.012s6.591 1.491 18.7 13.6 13.591 18.702 13.591 18.702z"
      />
      <path
        fill="#2167d8"
        d="m19.46 53.61-6.62 2.21c-1.39-1.24-2.87-2.63-4.45-4.21s-2.97-3.06-4.21-4.45l2.21-6.62c1.68 2.03 3.73 4.3 6.25 6.82s4.79 4.57 6.82 6.25z"
      />
      <path
        fill="#d3374e"
        d="m37.48 47.59-7.11 2.37a82.594 82.594 0 0 1-10.93-9.4 82.594 82.594 0 0 1-9.4-10.93l2.37-7.11a74.4 74.4 0 0 0 11.28 13.79 74.4 74.4 0 0 0 13.79 11.28z"
      />
      <path
        fill="#2167d8"
        d="M25.533 20.406a1 1 0 0 1-.707-1.707 12.2 12.2 0 0 0 2.36-14.675A1 1 0 1 1 28.9 3a14.247 14.247 0 0 1-2.66 17.118.993.993 0 0 1-.707.288z"
      />
      <path
        fill="#23af6f"
        d="M23.86 10.366a1 1 0 0 1-.707-.293L21.479 8.4a1 1 0 1 1 1.415-1.414l1.673 1.673a1 1 0 0 1-.707 1.707z"
      />
      <path fill="#d3374e" d="M35.573 8.693a1 1 0 0 1-1-1V6.02a1 1 0 0 1 2 0v1.673a1 1 0 0 1-1 1z" />
      <path fill="#23af6f" d="M37.247 15.387h-1.674a1 1 0 0 1 0-2h1.674a1 1 0 0 1 0 2z" />
      <path
        fill="#2167d8"
        d="M40.593 35.467a1 1 0 0 1-.707-1.707 14.248 14.248 0 0 1 17.119-2.66 1 1 0 0 1-1.027 1.715A12.067 12.067 0 0 0 41.3 35.174a1 1 0 0 1-.707.293z"
      />
      <path
        fill="#23af6f"
        d="M52.307 38.813a1 1 0 0 1-.707-.292l-1.674-1.674a1 1 0 0 1 1.414-1.414l1.674 1.673a1 1 0 0 1-.707 1.707z"
      />
      <path
        fill="#d3374e"
        d="M53.979 25.427h-1.672a1 1 0 0 1 0-2h1.672a1 1 0 0 1 0 2zm-8.366 0a1 1 0 0 1-1-1v-1.674a1 1 0 0 1 2 0v1.674a1 1 0 0 1-1 1z"
      />
      <path
        fill="#fdc70e"
        d="M37.247 22.08a1 1 0 0 1-.707-1.707 4.061 4.061 0 0 1 3.216-1.128h.022a2.1 2.1 0 0 0 1.779-.542 2.119 2.119 0 0 0 .542-1.8 3.94 3.94 0 0 1 4.346-4.348A2 2 0 0 0 48.8 10.2a4.067 4.067 0 0 1 1.131-3.218A1 1 0 1 1 51.34 8.4a2.128 2.128 0 0 0-.545 1.8 3.942 3.942 0 0 1-4.349 4.349A1.993 1.993 0 0 0 44.1 16.9a4.054 4.054 0 0 1-1.128 3.216 4.105 4.105 0 0 1-3.216 1.128h-.023a2.094 2.094 0 0 0-1.778.542 1 1 0 0 1-.708.294z"
      />
      <path
        fill="#d3374e"
        d="M40.594 10.366a1 1 0 0 1-.925-1.381 9.272 9.272 0 0 0 .042-7.515 1 1 0 0 1 1.764-.944 11.275 11.275 0 0 1 .044 9.221 1 1 0 0 1-.925.619zm10.039 10.04a1 1 0 0 1-.381-1.925 11.266 11.266 0 0 1 9.222.044 1 1 0 0 1-.944 1.764 9.267 9.267 0 0 0-7.516.042 1.006 1.006 0 0 1-.381.075z"
      />
    </svg>
  );
}

export function SvgIcInvoicePayment(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size || '1em'}
      height={props.size || '1em'}
      viewBox="0 0 20 21"
      {...props}
    >
      <g fill={props.color || 'currentColor'} stroke="#9D9D9D" strokeWidth={0.2} clipPath="url(#a)">
        <path d="M17.378 4.789 13.21.622A.417.417 0 0 0 12.917.5h-8.75C3.247.5 2.5 1.247 2.5 2.167v16.666c0 .92.748 1.667 1.667 1.667h11.666c.92 0 1.667-.747 1.667-1.667V5.083a.416.416 0 0 0-.122-.294Zm-4.045-2.866 2.745 2.744h-1.911a.834.834 0 0 1-.834-.834v-1.91Zm3.334 16.91c0 .46-.374.834-.834.834H4.167a.834.834 0 0 1-.834-.834V2.167c0-.46.374-.834.834-.834H12.5v2.5c0 .92.748 1.667 1.667 1.667h2.5v13.333Z" />
        <path d="M14.583 12.167H8.75a.416.416 0 1 0 0 .833h5.833a.416.416 0 1 0 0-.833ZM5.417 5.5h5a.416.416 0 1 0 0-.833h-5a.416.416 0 1 0 0 .833Zm9.166 4.167H5.417a.416.416 0 1 0 0 .833h9.166a.416.416 0 1 0 0-.833ZM5 7.583c0 .23.186.417.417.417h9.166a.416.416 0 1 0 0-.833H5.417A.416.416 0 0 0 5 7.583Zm5.958 8.037c-.613.603-1.385 1.282-1.691 1.489a6.08 6.08 0 0 1-.204-.605c-.17-.56-.302-1.004-.73-1.004-.365 0-.53.334-.779.84-.122.247-.375.762-.467.827-.09-.01-.245-.115-.415-.274.46-.593.828-1.28.828-1.81 0-.91-.767-1.25-1.25-1.25-.492 0-1.25.716-1.25 1.667 0 .422.234.942.565 1.4a3.838 3.838 0 0 1-.398.35.417.417 0 0 0 .5.667 4.37 4.37 0 0 0 .454-.398c.326.29.673.481.962.481.563 0 .898-.64 1.188-1.23.193.636.378 1.23.896 1.23.139 0 .561 0 2.375-1.786a.417.417 0 1 0-.584-.594Zm-4.835.619c-.17-.258-.29-.526-.29-.739 0-.508.373-.806.417-.833.07 0 .417.02.417.416 0 .266-.225.714-.544 1.156Z" />
      </g>
    </svg>
  );
}
export function IconHelpCenter(props) {
  return (
    <svg fill="currentColor" width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 26 26" {...props}>
      <path d="M24.257 10.994c-.6-5.2-4.81-9.37-10.02-9.93-3.26-.35-6.39.66-8.81 2.84a11.375 11.375 0 0 0-3.76 8.44c0 2.68.95 5.28 2.68 7.32.14.17.2.42.15.68l-.49 3.08c-.196 1.135 1.02 1.936 1.96 1.42l2.98-1.57c.25-.12.51-.16.74-.09 1.06.33 2.17.5 3.31.5 6.749 0 12.037-5.862 11.26-12.69zm-10.475 7.493a1.1 1.1 0 0 1-1.55 0 1.091 1.091 0 0 1 0-1.56 1.107 1.107 0 0 1 1.55 0 1.113 1.113 0 0 1 0 1.56zm.916-5.929c-.363.177-.597.585-.597 1.04v.155a1.099 1.099 0 1 1-2.199 0v-.156c0-1.288.719-2.47 1.83-3.014a1.678 1.678 0 0 0 .87-1.952c-.14-.542-.598-1-1.139-1.14a1.664 1.664 0 0 0-2.122 1.6 1.098 1.098 0 1 1-2.198 0c0-2.506 2.356-4.382 4.869-3.728a3.833 3.833 0 0 1 2.718 2.719c.471 1.819-.365 3.66-2.032 4.476z" />
    </svg>
  );
}
export function IconChatbox(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 26 26" {...props}>
      <path d="M24.257 10.994c-.6-5.2-4.81-9.37-10.02-9.93-3.26-.35-6.39.66-8.81 2.84a11.38 11.38 0 0 0-3.76 8.44c0 2.68.95 5.28 2.68 7.32.14.17.2.42.15.68l-.49 3.08c-.196 1.135 1.02 1.936 1.96 1.42l2.98-1.57c.25-.12.51-.16.74-.09 1.06.33 2.17.5 3.31.5 6.749 0 12.037-5.862 11.26-12.69m-10.475 7.493a1.1 1.1 0 0 1-1.55 0 1.09 1.09 0 0 1 0-1.56 1.107 1.107 0 0 1 1.55 0 1.113 1.113 0 0 1 0 1.56m.916-5.929c-.363.177-.597.585-.597 1.04v.155a1.099 1.099 0 1 1-2.199 0v-.156c0-1.288.719-2.47 1.83-3.014a1.68 1.68 0 0 0 .87-1.952c-.14-.542-.598-1-1.139-1.14a1.664 1.664 0 0 0-2.122 1.6 1.098 1.098 0 1 1-2.198 0c0-2.506 2.356-4.382 4.869-3.728a3.83 3.83 0 0 1 2.718 2.719c.471 1.819-.365 3.66-2.032 4.476" />
    </svg>
  );
}

export function SvgIcRevenueRecognition(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size || '1em'}
      height={props.size || '1em'}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.2}
        d="M2.5 14.438a45.055 45.055 0 0 1 11.848 1.575.86.86 0 0 0 1.09-.822v-.754M3.624 3.75v.563a.563.563 0 0 1-.563.562H2.5m0 0v-.281c0-.466.378-.844.844-.844H16M2.5 4.875v6.75M16 3.75v.563c0 .31.252.562.563.562h.562M16 3.75h.281c.466 0 .844.378.844.844v7.312a.844.844 0 0 1-.844.844H16M2.5 11.625v.281a.844.844 0 0 0 .844.844h.281M2.5 11.625h.563a.563.563 0 0 1 .562.563v.562m12.375 0v-.563a.562.562 0 0 1 .563-.562h.562M16 12.75H3.625m8.438-4.5a2.25 2.25 0 1 1-4.501 0 2.25 2.25 0 0 1 4.5 0Zm2.25 0h.005v.006h-.005V8.25Zm-9 0h.006v.006h-.006V8.25Z"
      />
    </svg>
  );
}
export function SvgIcReservationLog(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 20 21" fill="none" {...props}>
      <path
        fill="currentColor"
        d="M15.394 3.004H7.899a1.61 1.61 0 0 0-1.607 1.607v9.663A1.61 1.61 0 0 0 7.9 15.881h7.495A1.61 1.61 0 0 0 17 14.274V4.611a1.61 1.61 0 0 0-1.606-1.607m-1.07 10.173H8.968a.535.535 0 1 1 0-1.071h5.354a.535.535 0 1 1 0 1.07m0-2.142H8.968a.535.535 0 0 1 0-1.07h5.354a.535.535 0 0 1 0 1.07m0-2.141H8.968a.535.535 0 0 1 0-1.071h5.354a.535.535 0 1 1 0 1.07m0-2.142H8.968a.535.535 0 0 1 0-1.07h5.354a.535.535 0 1 1 0 1.07m-.017 10.2c-.49.146-7.252.943-7.684 1.03a1.617 1.617 0 0 1-1.8-1.385L3.57 7.015a1.648 1.648 0 0 1 1.652-1.836v9.095a2.68 2.68 0 0 0 2.677 2.677z"
      />
    </svg>
  );
}

export function SvgIcPipeLine(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size || '1em'}
      height={props.size || '1em'}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={0.2}
        d="M8.225 17.313V10.18l-.022-.027L3.34 4.079l-.115-.148V2.6h13.55v1.33l-.115.147-4.863 6.076-.022.027v1.142l.163-.13A4.9 4.9 0 0 1 15 10.1a4.91 4.91 0 0 1 4.9 4.9 4.91 4.91 0 0 1-4.9 4.9c-2.36 0-4.345-1.694-4.805-3.924l-.032-.156-.126.096-.976.742H9.06zM4.551 3.65h-.208l.13.162 4.493 5.625.03.038h2.01l.03-.038 4.492-5.625.13-.162H4.55Zm4.824 6.875h-.1v4.681l.162-.127.644-.508.033-.026.005-.042a4.9 4.9 0 0 1 .593-1.876l.013-.023v-2.079h-1.35Zm6.15 6.936v.564h-1.05v-.648l-.083-.014c-.659-.11-1.167-.667-1.167-1.347v-.291h1.05v.287a.323.323 0 0 0 .337.337h.776a.322.322 0 0 0 .337-.34l-.003-.057-.052-.026-1.816-.917a1.14 1.14 0 0 1-.629-1.023c0-.68.508-1.238 1.167-1.348l.083-.014v-.649h1.05v.648l.083.014c.659.11 1.167.667 1.167 1.347v.291h-1.05v-.29a.33.33 0 0 0-.094-.24.33.33 0 0 0-.24-.094h-.782a.33.33 0 0 0-.24.094.33.33 0 0 0-.094.24v.062l.055.027 1.816.917c.389.196.629.59.629 1.023 0 .68-.508 1.238-1.166 1.348l-.084.014zM18.85 15A3.84 3.84 0 0 0 15 11.15 3.84 3.84 0 0 0 11.15 15 3.84 3.84 0 0 0 15 18.85 3.84 3.84 0 0 0 18.85 15Z"
      />
    </svg>
  );
}

export function SvgIcAuthenticator(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '22px'}
      height={props.height || '18px'}
      viewBox="0 0 22 18"
      fill="none"
      {...props}
    >
      <path
        fill="#FCBC05"
        d="M9.614 7.697H8.065l-2.26-3.805a1.283 1.283 0 0 1 .49-1.78c.212-.118.442-.175.67-.175.463 0 .914.234 1.163.652l2.26 3.804z"
      />
      <path
        fill="#E94335"
        d="M14.483 15.887a1.364 1.364 0 0 1-1.834-.477l-2.26-3.804-2.261 3.804a1.363 1.363 0 0 1-1.833.477 1.3 1.3 0 0 1-.67-1.13c0-.22.057-.445.18-.65l2.26-3.804h4.648l2.26 3.803c.371.624.15 1.421-.49 1.781"
      />
      <path
        fill="#1973E8"
        d="M18.576 9c0 .72-.6 1.303-1.342 1.303h-4.521l-.775-1.304-.774-1.303-.775-1.303 2.26-3.804a1.363 1.363 0 0 1 1.834-.477c.641.36.861 1.157.491 1.78l-2.261 3.805h4.521c.742 0 1.342.583 1.342 1.302"
      />
      <path
        fill="#34A853"
        d="M9.614 7.697 8.84 9l-.774 1.303H3.543c-.74 0-1.341-.583-1.341-1.303 0-.36.15-.685.393-.922.243-.235.577-.381.948-.381z"
      />
      <path fill="#174FA7" d="M12.713 10.303H8.065L8.84 9l.775-1.303.775-1.304.775 1.304L11.938 9z" />
    </svg>
  );
}

export function SvgIcResetPassword(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={22} height={22} viewBox="0 0 22 22" fill="none" {...props}>
      <path
        fill="#23A8FE"
        fillRule="evenodd"
        d="M5.064 10.203h.542V7.599a3.807 3.807 0 0 1 3.796-3.796 3.807 3.807 0 0 1 3.795 3.796v2.604h.542c1.159 0 2.107.948 2.107 2.105v6.587A2.11 2.11 0 0 1 13.739 21H5.064a2.11 2.11 0 0 1-2.106-2.105v-6.587c0-1.157.947-2.105 2.106-2.105m2.76 0h3.155V7.599c0-.864-.714-1.578-1.577-1.578-.864 0-1.578.714-1.578 1.578z"
        clipRule="evenodd"
      />
      <path fill="#0083E0" fillRule="evenodd" d="M15.846 13.016v5.347h-4.984l-2.286 2.215v-7.562z" clipRule="evenodd" />
      <path
        fill="#FFB74D"
        fillRule="evenodd"
        d="M17.902 8.054a8.6 8.6 0 0 0-2.496-4.63A8.6 8.6 0 0 0 9.402 1C4.634 1 .754 4.879.754 9.646a.443.443 0 0 0 .886 0c0-4.279 3.482-7.76 7.762-7.76A7.73 7.73 0 0 1 17 8.054h-1.197l1.746 2.038 1.745-2.038z"
        clipRule="evenodd"
      />
      <path
        fill="#0083E0"
        fillRule="evenodd"
        d="M9.098 3.815q.15-.012.304-.012a3.807 3.807 0 0 1 3.795 3.796v2.603l-.125-.004h-.542V7.593a3.81 3.81 0 0 0-3.432-3.778m4.123 6.388h.518c1.158 0 2.107.948 2.107 2.105v6.587A2.11 2.11 0 0 1 13.739 21h-.085c.883-.267 1.524-1.147 1.524-2.111v-6.585a2.113 2.113 0 0 0-1.957-2.101m-4.14-4.148a1.59 1.59 0 0 0-1.257 1.544v2.6h-.668V7.592c0-.862.715-1.577 1.578-1.577q.178 0 .346.039"
        clipRule="evenodd"
      />
      <path
        fill="#FFB74D"
        fillRule="evenodd"
        d="M20.054 12.18H7.116c-.655 0-1.191.537-1.191 1.192v2.963c0 .656.536 1.191 1.191 1.191h1.46v2.217l2.286-2.216h9.192c.655 0 1.191-.536 1.191-1.192v-2.963c0-.655-.536-1.191-1.191-1.191"
        clipRule="evenodd"
      />
      <path
        fill="#EAF6FF"
        d="M11.155 14.079a.28.28 0 0 0-.385-.103l-.675.39v-.78a.282.282 0 0 0-.564 0v.78l-.675-.39a.282.282 0 0 0-.281.488l.675.39-.675.39a.282.282 0 1 0 .281.488l.675-.39v.779a.282.282 0 1 0 .564 0v-.779l.675.39a.28.28 0 0 0 .385-.103.28.28 0 0 0-.103-.386l-.675-.39.675-.39a.28.28 0 0 0 .103-.384m3.771 0a.28.28 0 0 0-.385-.103l-.675.39v-.78a.282.282 0 0 0-.564 0v.78l-.675-.39a.282.282 0 0 0-.281.488l.675.39-.675.39a.282.282 0 1 0 .281.488l.675-.39v.779a.282.282 0 1 0 .564 0v-.779l.675.39a.28.28 0 0 0 .385-.103.28.28 0 0 0-.103-.385l-.675-.39.675-.39a.28.28 0 0 0 .103-.385m3.668 1.165-.675-.39.674-.39a.282.282 0 1 0-.281-.488l-.674.39v-.78a.282.282 0 0 0-.564 0v.78l-.675-.39a.282.282 0 1 0-.282.488l.675.39-.675.39a.282.282 0 0 0 .282.488l.675-.39v.779a.282.282 0 1 0 .564 0v-.778l.674.389a.28.28 0 0 0 .385-.103.28.28 0 0 0-.104-.385"
      />
      <path
        fill="#E09109"
        fillRule="evenodd"
        d="M6.362 12.935h12.936c.655 0 1.192.536 1.192 1.191v2.965q-.002.196-.06.375c.471-.159.815-.606.815-1.13v-2.964c0-.655-.536-1.191-1.191-1.191H7.116c-.524 0-.972.342-1.13.815q.178-.06.376-.061"
        clipRule="evenodd"
      />
    </svg>
  );
}

export function SvgIcPenalty(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size || '1em'}
      height={props.size || '1em'}
      viewBox="0 0 21 20"
      fill="none"
      {...props}
    >
      <mask
        id="a1"
        width={21}
        height={20}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path fill={props.color || 'currentColor'} d="M.5 0h20v20H.5z" />
      </mask>
      <g mask="url(#a1)">
        <path
          fill={props.color || 'currentColor'}
          d="m10.5 4.26 5.056 2.025v3.062c0 2.944-2.153 5.66-5.056 6.468-2.903-.808-5.056-3.524-5.056-6.468V6.285zm0-1.427L4 5.438v3.909c0 3.615 2.773 6.995 6.5 7.816 3.727-.82 6.5-4.201 6.5-7.816V5.438zm-.722 3.908h1.444v1.303H9.778zm0 2.606h1.444v3.908H9.778z"
        />
      </g>
    </svg>
  );
}

export function SvgIcBonus(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size || '1em'}
      height={props.size || '1em'}
      viewBox=" 0 0 21 20"
      fill="none"
      {...props}
    >
      <mask
        id="a2"
        width={21}
        height={20}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path fill={props.color || 'currentColor'} d="M.5 0h20v20H.5z" />
      </mask>
      <g fill={props.color || 'currentColor'} stroke={props.color || 'currentColor'} strokeWidth={0.5} mask="url(#a2)">
        <path d="m17.806 9.846-1.312-1.451.41-1.914a.23.23 0 0 0-.154-.267l-1.863-.601-.601-1.864a.23.23 0 0 0-.267-.154l-1.909.411-1.457-1.312a.23.23 0 0 0-.308 0L8.893 4.006l-1.914-.41a.23.23 0 0 0-.267.153l-.6 1.864-1.864.6a.23.23 0 0 0-.155.268l.411 1.914-1.312 1.451a.23.23 0 0 0 0 .309l1.312 1.457-.41 1.909a.23.23 0 0 0 .154.267l1.863.6.601 1.864a.23.23 0 0 0 .267.154l1.914-.41 1.452 1.312a.23.23 0 0 0 .308 0l1.457-1.313 1.915.411a.23.23 0 0 0 .267-.154l.6-1.864 1.864-.6a.23.23 0 0 0 .154-.268l-.416-1.908 1.312-1.451a.23.23 0 0 0 0-.315Zm-1.734 1.536a.23.23 0 0 0-.054.203l.393 1.825-1.778.575a.23.23 0 0 0-.148.149l-.575 1.777-1.824-.385a.23.23 0 0 0-.202.054l-1.385 1.246-1.381-1.252a.23.23 0 0 0-.155-.059.2.2 0 0 0-.048 0l-1.825.393-.576-1.777a.23.23 0 0 0-.148-.149l-1.778-.575.393-1.826a.23.23 0 0 0-.055-.2l-1.253-1.38 1.253-1.382a.23.23 0 0 0 .054-.202l-.393-1.83 1.777-.575a.23.23 0 0 0 .149-.148l.575-1.777 1.826.392a.23.23 0 0 0 .204-.052l1.38-1.252 1.382 1.252a.23.23 0 0 0 .203.054l1.825-.392.576 1.777a.23.23 0 0 0 .148.149l1.778.575-.386 1.823a.23.23 0 0 0 .054.203L17.325 10z" />
        <path d="M8.326 8.99a1.161 1.161 0 1 0-.009-2.323 1.161 1.161 0 0 0 .01 2.322Zm0-1.863a.701.701 0 1 1-.653.43.7.7 0 0 1 .653-.435zm4.346 3.883a1.161 1.161 0 1 0 .01 2.323 1.161 1.161 0 0 0-.01-2.322Zm0 1.863a.7.7 0 1 1 .653-.43.7.7 0 0 1-.653.434zm.781-5.828a.23.23 0 0 0-.325 0L7.544 12.63a.23.23 0 0 0 .162.392.23.23 0 0 0 .162-.067l5.585-5.585a.23.23 0 0 0 0-.325Z" />
      </g>
    </svg>
  );
}

export function AccessDeniedError(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="138" height="182" viewBox="0 0 238 282" fill="none">
      <path
        fill="#EDF8F0"
        d="M118.829 281.493c65.627 0 118.829-53.894 118.829-120.376S184.456 40.741 118.829 40.741C53.201 40.74 0 94.635 0 161.117s53.201 120.376 118.829 120.376Z"
      />
      <mask id="a" width="238" height="242" x="0" y="40" maskUnits="userSpaceOnUse">
        <path
          fill="#fff"
          d="M118.829 281.493c65.627 0 118.829-53.894 118.829-120.376S184.456 40.741 118.829 40.741C53.201 40.74 0 94.635 0 161.117s53.201 120.376 118.829 120.376Z"
        />
      </mask>
      <g mask="url(#a)">
        <path fill="#D9F0E3" d="m186.541 116.562 90.74 91.922L162.34 324.919l24.201-208.357Z" />
        <path
          fill="#81CDA1"
          d="M197.734 146.966v30.599c0 1.213-.971 2.197-2.17 2.197a2.183 2.183 0 0 1-2.168-2.197v-30.599a2.183 2.183 0 0 1 2.168-2.196c.599 0 1.142.245 1.534.644.393.397.636.945.636 1.552ZM44.262 146.333v31.864c0 .865-.693 1.565-1.543 1.565h-1.25a1.555 1.555 0 0 1-1.545-1.565v-31.864c0-.862.692-1.563 1.545-1.563h1.25c.85 0 1.543.701 1.543 1.563ZM44.262 187.419v31.864c0 .862-.693 1.563-1.543 1.563h-1.25a1.554 1.554 0 0 1-1.545-1.563v-31.864c0-.865.692-1.565 1.545-1.565h1.25c.85 0 1.543.701 1.543 1.565Z"
        />
        <path
          fill="#81CDA1"
          d="M189.559 120.267c-3.739-5.343-8.906-9.367-14.942-11.637a30.464 30.464 0 0 0-2.973-.949 31.388 31.388 0 0 0-8.101-1.056H73.957c-17.568 0-31.863 14.483-31.863 32.279v199.372c0 17.796 14.294 32.277 31.863 32.277h89.586c17.567 0 31.859-14.479 31.859-32.277V138.904c0-6.724-2.021-13.165-5.843-18.637Zm-4.24 218.011c0 12.167-9.767 22.059-21.776 22.059H73.957c-12.01 0-21.78-9.894-21.78-22.059V138.904c0-11.153 8.208-20.398 18.828-21.862.966-.134 1.95-.203 2.95-.203h89.586c.735 0 1.462.037 2.185.111 1.845.183 3.649.605 5.38 1.257 8.501 3.195 14.211 11.513 14.211 20.697v199.372l.002.002Z"
        />
        <path
          fill="#fff"
          d="M185.318 138.904v200.771c0 11.412-9.131 20.662-20.396 20.662H72.575c-11.267 0-20.398-9.252-20.398-20.665V137.505c0-11.413 9.133-20.666 20.398-20.666h90.968c2.609 0 5.156.46 7.566 1.366 8.5 3.195 14.211 11.513 14.211 20.697l-.002.002Z"
        />
        <path
          fill="#fff"
          d="M72.575 352.403c-6.94 0-12.568-5.699-12.568-12.731V137.505c0-7.03 5.626-12.731 12.568-12.731h90.966c1.678 0 3.306.291 4.84.869 5.446 2.047 9.105 7.375 9.105 13.259v200.771c0 7.031-5.626 12.728-12.564 12.728H72.575v.002Z"
        />
        <path
          fill="#D9F0E3"
          d="m165.294 203.382-36.878-13.026-30.523 24.207-20.233-17.079-25.483 14.974v-48.46l21.91-6.855 30.82 26.088 22.231-13.011 38.156 33.162Z"
        />
      </g>
      <path
        fill="#FF5360"
        d="M111.802 10.193 77.214 69.345c-3.225 5.517.7 12.491 7.027 12.491h69.175c6.33 0 10.254-6.976 7.028-12.491l-34.588-59.152c-3.163-5.41-10.893-5.41-14.056 0h.002Z"
      />
      <path
        fill="#fff"
        d="M118.829 6.135c2.724 0 5.446 1.353 7.027 4.056l34.588 59.152c3.225 5.517-.7 12.492-7.027 12.492H84.241c-6.33 0-10.254-6.977-7.027-12.492l34.588-59.152c1.581-2.705 4.305-4.056 7.027-4.056Zm0-5.646c-4.905 0-9.325 2.552-11.824 6.827L72.417 66.468a14.053 14.053 0 0 0-1.931 7.209 14.13 14.13 0 0 0 1.814 6.779 13.93 13.93 0 0 0 4.832 5.037 13.59 13.59 0 0 0 7.107 1.991h69.176a13.59 13.59 0 0 0 7.107-1.991 13.897 13.897 0 0 0 4.832-5.037 14.122 14.122 0 0 0 1.815-6.78 14.027 14.027 0 0 0-1.932-7.209L130.65 7.316c-2.5-4.275-6.92-6.827-11.825-6.827h.004Z"
      />
      <path
        fill="#fff"
        d="M119.04 22.923h-.423c-1.728 0-3.13 1.42-3.13 3.17v25.578c0 1.751 1.402 3.17 3.13 3.17h.423c1.729 0 3.13-1.419 3.13-3.17V26.094c0-1.752-1.401-3.171-3.13-3.171ZM120.735 69.781c2.991-1.066 4.562-4.387 3.51-7.417-1.053-3.03-4.331-4.621-7.322-3.555-2.99 1.067-4.562 4.387-3.509 7.417 1.053 3.03 4.331 4.621 7.321 3.555Z"
      />
    </svg>
  );
}

export function ApplicationError(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="213" height="108" viewBox="0 0 303 198" fill="none">
      <path
        fill="#F8FAF9"
        d="M38.896 197.091H289.36s33.455-67.87-4.777-94.526c-38.234-26.656-73.576 8.783-101.003-65.827C164.738-14.514 37.746-19.372 7.102 72.666-18.136 148.465 38.898 197.09 38.898 197.09l-.002.002Z"
      />
      <path
        fill="#fff"
        d="M26.186 68.494h177.489v115.308c0 6.206-5.038 11.244-11.245 11.244h-155c-6.206 0-11.244-5.038-11.244-11.244V68.494Z"
      />
      <path
        fill="#81CDA1"
        d="M109.018 197.653H37.43c-7.638 0-13.85-6.213-13.85-13.851V68.494a2.606 2.606 0 0 1 2.605-2.607h177.489a2.606 2.606 0 0 1 2.607 2.607v46.759a2.607 2.607 0 1 1-5.213 0V71.1H28.79v112.702c0 4.763 3.875 8.638 8.638 8.638h71.588a2.607 2.607 0 1 1 0 5.213h.002Z"
      />
      <path
        fill="#81CDA1"
        d="M203.672 68.494H26.183v-9.066c0-6.207 5.038-11.245 11.245-11.245h155c6.206 0 11.244 5.038 11.244 11.245v9.066Z"
      />
      <path
        fill="#81CDA1"
        d="M203.672 71.1H26.185a2.606 2.606 0 0 1-2.606-2.606v-9.066c0-7.639 6.213-13.851 13.851-13.851h154.998c7.638 0 13.851 6.212 13.851 13.85v9.067a2.606 2.606 0 0 1-2.607 2.606ZM28.79 65.887h172.276v-6.46c0-4.762-3.875-8.638-8.638-8.638H37.43c-4.763 0-8.638 3.876-8.638 8.639v6.46h-.002Z"
      />
      <path
        fill="#fff"
        d="M44.71 61.783a3.446 3.446 0 1 0 0-6.891 3.446 3.446 0 0 0 0 6.891ZM58.616 61.783a3.446 3.446 0 1 0 0-6.891 3.446 3.446 0 0 0 0 6.891ZM72.52 61.783a3.446 3.446 0 1 0 0-6.891 3.446 3.446 0 0 0 0 6.891Z"
      />
      <path
        fill="#FF5360"
        d="m165.125 91.202-45.231 72.152c-9.199 14.675 1.349 33.739 18.668 33.739h90.463c17.319 0 27.869-19.064 18.668-33.739l-45.231-72.152c-8.635-13.775-28.702-13.775-37.339 0h.002Z"
      />
      <path
        fill="#fff"
        d="M183.681 175.396c-2.335 0-4.331-.821-5.988-2.461-1.656-1.641-2.486-3.617-2.486-5.93 0-2.313.828-4.399 2.486-6.04 1.657-1.64 3.653-2.462 5.988-2.462 2.335 0 4.462.822 6.157 2.462 1.694 1.641 2.542 3.655 2.542 6.04 0 2.385-.848 4.289-2.542 5.93-1.695 1.64-3.747 2.461-6.157 2.461Zm.113-24.053c-3.239 0-4.97-1.918-5.197-5.755l-1.468-37.17c-.152-3.901 2.034-5.853 6.552-5.853s6.891 1.952 6.665 5.853l-1.468 37.17c-.153 3.837-1.846 5.755-5.084 5.755Z"
      />
      <path
        fill="#D9F0E3"
        d="M96.497 96.927H42.856a2.606 2.606 0 1 1 0-5.213h53.64a2.606 2.606 0 1 1 0 5.213ZM88.258 107.262H42.854a2.606 2.606 0 0 1 0-5.213h45.404a2.606 2.606 0 1 1 0 5.213ZM106.827 128.469H45.023c-2.687 0-4.865-1.232-4.865-2.751 0-1.52 2.178-2.752 4.865-2.752h61.804c2.688 0 4.865 1.232 4.865 2.752 0 1.519-2.177 2.751-4.865 2.751ZM95.845 138.688H45c-2.674 0-4.842-1.231-4.842-2.751 0-1.52 2.168-2.752 4.842-2.752h50.845c2.675 0 4.842 1.232 4.842 2.752 0 1.52-2.167 2.751-4.842 2.751ZM80.584 159.529H42.856a2.605 2.605 0 1 1 0-5.212h37.728a2.605 2.605 0 1 1 0 5.212ZM92.188 169.864H42.854a2.606 2.606 0 1 1 0-5.212h49.334a2.606 2.606 0 1 1 0 5.212Z"
      />
    </svg>
  );
}

export function ConnectionError(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="306" height="296" fill="none">
      <path
        fill="#F8FAF9"
        d="M153.19 238.588c65.884 0 119.294-53.41 119.294-119.294S219.074 0 153.19 0 33.896 53.41 33.896 119.294s53.41 119.294 119.294 119.294Z"
      />
      <path
        fill="#81CDA1"
        d="M237.309 295.979a2.618 2.618 0 0 1-2.369-1.498l-81.75-172.794-81.75 172.794a2.617 2.617 0 1 1-4.734-2.239l84.117-177.796a2.62 2.62 0 0 1 4.734 0l84.117 177.796a2.617 2.617 0 0 1-2.365 3.739v-.002Z"
      />
      <path
        fill="#81CDA1"
        d="M225.965 272.006H80.415a2.617 2.617 0 0 1-1.232-4.93l68.441-36.493-39.121-20.859a2.619 2.619 0 1 1 2.464-4.621l42.223 22.514 42.223-22.514a2.618 2.618 0 0 1 2.464 4.621l-39.121 20.859 68.44 36.493a2.618 2.618 0 0 1-1.231 4.93Zm-135.072-5.238h124.594l-62.297-33.217-62.297 33.217ZM114.731 199.471a2.62 2.62 0 0 1-1.577-4.711l35.684-26.9-15.464-11.658a2.619 2.619 0 0 1 3.152-4.184l16.662 12.56 16.662-12.56a2.619 2.619 0 0 1 3.151 4.184l-15.464 11.658 35.685 26.9a2.62 2.62 0 0 1-1.577 4.711h-76.916.002Zm38.459-28.331-30.634 23.094h61.266l-30.634-23.094h.002ZM165.219 143.606h-24.057a2.618 2.618 0 0 1 0-5.237h24.057a2.619 2.619 0 0 1 0 5.237Z"
      />
      <path
        fill="#FF5360"
        d="M159.373 80.193a6.217 6.217 0 0 1-6.209 6.21 6.216 6.216 0 0 1-6.209-6.21 6.216 6.216 0 0 1 6.209-6.209 6.217 6.217 0 0 1 6.209 6.21Z"
      />
      <path
        fill="#81CDA1"
        d="m193.005 49.308-.876.867a3.487 3.487 0 0 1-4.922-.026c-8.718-8.727-20.76-14.135-34.043-14.135-13.283 0-25.326 5.406-34.043 14.133a3.487 3.487 0 0 1-4.922.026l-.874-.865c-1.367-1.352-1.386-3.561-.028-4.92l.048-.049a56.077 56.077 0 0 1 17.898-12.066c6.944-2.939 14.321-4.428 21.923-4.428 7.601 0 14.975 1.49 21.92 4.428a56.096 56.096 0 0 1 17.948 12.115c1.358 1.36 1.337 3.57-.027 4.92h-.002Z"
      />
      <path
        fill="#81CDA1"
        d="m182.943 59.264-.897.885a3.483 3.483 0 0 1-4.913-.019c-6.145-6.132-14.623-9.93-23.971-9.93s-17.826 3.796-23.972 9.93a3.483 3.483 0 0 1-4.912.02l-.897-.888c-1.35-1.335-1.374-3.522-.033-4.866l.024-.025c7.957-7.955 18.536-12.338 29.79-12.338 11.254 0 21.829 4.383 29.788 12.338a.544.544 0 0 1 .024.025c1.343 1.344 1.319 3.53-.033 4.868h.002Z"
      />
      <path
        fill="#D9F0E3"
        d="m172.823 69.278-.855.848a3.48 3.48 0 0 1-4.897 0c-3.574-3.543-8.489-5.735-13.907-5.735-5.419 0-10.334 2.19-13.91 5.733a3.48 3.48 0 0 1-4.896 0l-.855-.846c-1.371-1.356-1.386-3.574-.017-4.934 5.052-5.017 12.007-8.122 19.676-8.122 7.669 0 14.623 3.105 19.676 8.124 1.368 1.36 1.354 3.578-.017 4.933l.002-.001Z"
      />
      <path
        fill="#FF5360"
        d="M153.164 68.197a5.057 5.057 0 0 1-5.053-4.825l-1.513-33.035a6.573 6.573 0 1 1 13.132 0l-1.514 33.035a5.057 5.057 0 0 1-5.052 4.825Z"
      />
      <path
        fill="#fff"
        d="M153.164 69.332a6.18 6.18 0 0 1-6.185-5.91l-1.514-33.035a7.644 7.644 0 0 1 2.126-5.677 7.637 7.637 0 0 1 5.573-2.384c2.125 0 4.106.846 5.573 2.384a7.632 7.632 0 0 1 2.125 5.677l-1.513 33.035a6.183 6.183 0 0 1-6.185 5.908v.002Zm0-44.736a5.385 5.385 0 0 0-3.933 1.683 5.389 5.389 0 0 0-1.501 4.006l1.514 33.035a3.917 3.917 0 0 0 3.92 3.743 3.918 3.918 0 0 0 3.92-3.743l1.513-33.035a5.392 5.392 0 0 0-1.5-4.006 5.394 5.394 0 0 0-3.933-1.683Z"
      />
      <path
        fill="#D9F0E3"
        d="M92.842 136.155c3.866 0 7.339-2.027 8.379-5.025.879-2.533-.225-5.108-8.16-5.279-22.612-.487-8.835-9.809-26.731-11.71-21.17-2.246-22.251 12.699-33.918 11.323-12.638-1.491-14.213.881-22.313 3.831-4.305 1.567-12.492 6.858-7.767 6.858H92.84l.002.002ZM296.837 175.088c3.866 0 7.339-2.027 8.379-5.024.879-2.533-.225-5.109-8.16-5.28-22.612-.487-8.835-9.809-26.731-11.709-21.169-2.247-22.251 12.699-33.918 11.323-12.638-1.492-14.213.881-22.313 3.83-4.305 1.568-12.493 6.858-7.767 6.858h90.508l.002.002ZM251.588 104.273c3.014 0 4.684-3.1 2.806-5.2-1.675-1.87-4.481-3.56-9.166-3.687-15.387-.42-5.757-7.703-17.935-9.34-14.406-1.938-22.121 10.123-30.062 8.934-9.258-1.383-13.122 1.23-14.705 4.032-1.326 2.35.372 5.261 3.072 5.261h65.99Z"
      />
      <path fill="#74B991" d="M153.19 115.977a7.635 7.635 0 1 0 0-15.27 7.635 7.635 0 0 0 0 15.27Z" />
    </svg>
  );
}

export function NetworkError(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="129" height="171" viewBox="0 0 239 281" fill="none">
      <path
        fill="#F8FAF9"
        d="M119.294 239.569c65.884 0 119.294-53.409 119.294-119.294 0-65.884-53.41-119.294-119.294-119.294S0 54.391 0 120.275c0 65.885 53.41 119.294 119.294 119.294Z"
      />
      <path fill="#D9F0E3" d="M124.075 74.7h-9.648v44.023h9.648V74.7Z" />
      <path
        fill="#81CDA1"
        d="m151.845 55.792 3.636-3.636c15.954 15.953 15.954 41.914 0 57.867l-3.636-3.635c13.951-13.95 13.951-36.649 0-50.597Z"
      />
      <path
        fill="#81CDA1"
        d="m140.34 67.294 3.635-3.635c9.614 9.613 9.614 25.25 0 34.865l-3.635-3.636c7.605-7.605 7.605-19.986 0-27.59v-.004ZM86.658 55.792l-3.636-3.636c-15.954 15.953-15.954 41.914 0 57.867l3.635-3.635c-13.95-13.95-13.95-36.649 0-50.597Z"
      />
      <path
        fill="#81CDA1"
        d="m98.163 67.294-3.636-3.635c-9.613 9.613-9.613 25.25 0 34.865l3.636-3.636c-7.605-7.605-7.605-19.986 0-27.59v-.004Z"
      />
      <path
        fill="#74B991"
        d="M75.269 265.687a3.405 3.405 0 0 1-3.152-2.12 3.397 3.397 0 0 1 1.87-4.428l72.345-29.402-61.333-17.92a3.4 3.4 0 0 1-.567-6.306l54.523-27.237-43.533-22.02a3.396 3.396 0 0 1-.216-5.946l39.819-23.941a3.399 3.399 0 1 1 3.502 5.827l-34.545 20.772 44.076 22.294a3.4 3.4 0 0 1-.014 6.075L95.225 207.72l62.382 18.224a3.404 3.404 0 0 1 2.442 3.092 3.399 3.399 0 0 1-2.115 3.322l-81.389 33.076a3.378 3.378 0 0 1-1.28.253h.004Z"
      />
      <path
        fill="#81CDA1"
        d="M72.402 280.105a3.401 3.401 0 0 1-3.337-4.063l30.677-154.236a3.404 3.404 0 0 1 3.997-2.67 3.4 3.4 0 0 1 2.67 3.997L75.733 277.369a3.403 3.403 0 0 1-3.33 2.736ZM166.101 280.105a3.404 3.404 0 0 1-3.331-2.735l-30.676-154.236a3.399 3.399 0 0 1 2.669-3.998c1.855-.353 3.633.832 3.998 2.67l30.676 154.236a3.4 3.4 0 0 1-3.336 4.063Z"
      />
      <path
        fill="#81CDA1"
        d="M163.234 265.687c-.379 0-.766-.065-1.145-.199l-82.122-29.38a3.402 3.402 0 0 1-.108-6.363l62.834-24.929L90.282 183.5a3.401 3.401 0 0 1-.442-6.078l44.695-26.282-34.195-20.946a3.397 3.397 0 1 1 3.551-5.795l39.024 23.903a3.403 3.403 0 0 1 1.625 2.929 3.403 3.403 0 0 1-1.676 2.901l-43.646 25.664 53.875 21.912a3.399 3.399 0 0 1-.028 6.308l-62.321 24.727 73.636 26.345a3.4 3.4 0 0 1-1.146 6.602v-.003Z"
      />
      <path fill="#74B991" d="M151.837 112.229H86.669v10.255h65.168v-10.255Z" />
      <path
        fill="#FF5360"
        d="M119.251 65.585c-8.562 0-15.506 6.94-15.506 15.506 0 8.565 6.941 15.506 15.506 15.506 8.566 0 15.507-6.94 15.507-15.506 0-8.565-6.941-15.506-15.507-15.506Z"
      />
    </svg>
  );
}

export function NotFoundError(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="218" height="122" viewBox="0 0 318 222" fill="none">
      <path
        fill="#F8FAF9"
        d="M227.572 34.343H43.616c-10.353 0-18.745 8.407-18.745 18.778 0 10.37 8.392 18.778 18.745 18.778h183.956c10.352 0 18.744-8.407 18.744-18.778 0-10.371-8.392-18.778-18.744-18.778ZM271.756 160.569h-241.1C13.726 160.569 0 174.319 0 191.28s13.725 30.711 30.656 30.711h241.1c16.93 0 30.656-13.75 30.656-30.711s-13.726-30.711-30.656-30.711Z"
      />
      <path
        fill="#F8FAF9"
        d="M266.048 130.056H30.83c8.41 0 15.23 6.831 15.23 15.257 0 8.425-6.82 15.258-15.23 15.258h235.218c-8.411 0-15.231-6.831-15.231-15.256 0-8.426 6.818-15.259 15.231-15.259ZM294.743 83.459H31.662c-12.845 0-23.257 10.43-23.257 23.298 0 12.867 10.412 23.298 23.257 23.298h263.081c12.845 0 23.257-10.431 23.257-23.298 0-12.867-10.412-23.298-23.257-23.298Z"
      />
      <path
        fill="#D9F0E3"
        d="M236.247 58.583H81.755a1.683 1.683 0 0 1-.924-3.086l77.247-50.984a1.68 1.68 0 0 1 1.848 0l77.247 50.984c.618.407.897 1.175.685 1.888a1.678 1.678 0 0 1-1.609 1.198h-.002ZM87.353 55.22h143.294L159 7.933 87.353 55.22Z"
      />
      <path
        fill="#fff"
        d="M261.647 58.486v137.785c0 6.022-4.872 10.903-10.884 10.903H67.237c-6.01 0-10.884-4.881-10.884-10.903V58.486c0-6.022 4.874-10.903 10.884-10.903H250.76c6.012 0 10.884 4.881 10.884 10.903h.002Z"
      />
      <path fill="#EDF8F0" d="M261.647 66.22H56.353v5.679h205.294V66.22Z" />
      <path
        fill="#81CDA1"
        d="M261.645 58.484v7.736H56.355v-7.736c0-6.022 4.874-10.903 10.884-10.903h183.524c6.011 0 10.884 4.881 10.884 10.903h-.002Z"
      />
      <path
        fill="#fff"
        d="M188.634 66.22H56.354v-7.736c0-6.022 4.875-10.903 10.885-10.903H181.4a86.117 86.117 0 0 1 7.235 18.639h-.002Z"
        opacity=".1"
      />
      <path
        fill="#fff"
        d="M72.413 60.046a3.143 3.143 0 0 0 3.14-3.146 3.143 3.143 0 0 0-3.14-3.145 3.143 3.143 0 0 0-3.14 3.145 3.143 3.143 0 0 0 3.14 3.146ZM84.067 60.046a3.143 3.143 0 0 0 3.14-3.146 3.143 3.143 0 0 0-3.14-3.145 3.143 3.143 0 0 0-3.14 3.145 3.143 3.143 0 0 0 3.14 3.146ZM95.814 60.046a3.143 3.143 0 0 0 3.14-3.146 3.143 3.143 0 0 0-3.14-3.145 3.143 3.143 0 0 0-3.14 3.145 3.143 3.143 0 0 0 3.14 3.146Z"
      />
      <path
        fill="#EDF8F0"
        d="M214.155 118.508h-110.31c-16.112 0-29.173 13.084-29.173 29.225 0 16.141 13.061 29.225 29.173 29.225h110.31c16.112 0 29.173-13.084 29.173-29.225 0-16.141-13.061-29.225-29.173-29.225Z"
      />
      <path
        fill="#81CDA1"
        d="M95.01 145.756v-7.526l22.331-32.019h11.132v31.197h6.01v8.346h-6.01v9.715h-9.56v-9.715H95.01v.002Zm24.518-29.281-14 20.935h14v-20.935ZM144.83 111.345c2.845-4.47 7.568-6.704 14.17-6.704s11.325 2.234 14.17 6.704c2.846 4.47 4.268 10.649 4.268 18.541 0 7.891-1.424 14.162-4.268 18.676-2.845 4.516-7.57 6.773-14.17 6.773s-11.326-2.257-14.17-6.773c-2.846-4.516-4.269-10.74-4.269-18.676 0-7.936 1.422-14.069 4.269-18.541Zm22.536 10.022c-.433-2.303-1.298-4.184-2.595-5.643-1.298-1.46-3.222-2.189-5.771-2.189s-4.473.731-5.771 2.189c-1.297 1.459-2.162 3.342-2.595 5.643-.433 2.304-.648 5.143-.648 8.517 0 3.374.205 6.374.615 8.722.409 2.35 1.273 4.242 2.595 5.679 1.32 1.438 3.255 2.155 5.804 2.155 2.549 0 4.484-.717 5.804-2.155 1.32-1.437 2.185-3.329 2.596-5.679.409-2.348.614-5.256.614-8.722 0-3.466-.216-6.213-.648-8.517ZM184.267 145.756v-7.526l22.331-32.019h11.132v31.197h6.009v8.346h-6.009v9.715h-9.56v-9.715h-23.903v.002Zm24.517-29.281-13.999 20.935h13.999v-20.935Z"
      />
      <path
        fill="#D9F0E3"
        d="M160.733 10.109a4.54 4.54 0 0 0 2.451-5.927 4.526 4.526 0 0 0-5.917-2.455 4.54 4.54 0 0 0-2.45 5.927 4.525 4.525 0 0 0 5.916 2.455Z"
      />
    </svg>
  );
}
export function IcSetRoster(props) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.33333 6.66732H12.6667V8.00065H14V4.00065C14 3.26732 13.4 2.66732 12.6667 2.66732H12V1.33398H10.6667V2.66732H5.33333V1.33398H4V2.66732H3.33333C2.59333 2.66732 2.00667 3.26732 2.00667 4.00065L2 13.334C2 14.0673 2.59333 14.6673 3.33333 14.6673H8V13.334H3.33333V6.66732ZM3.33333 4.00065H12.6667V5.33398H3.33333V4.00065Z"
        fill="#009F2B"
      />
      <path
        d="M12.4011 12.2041V13.5166L14.9611 11.2741L12.4011 9.03906V10.3141C9.9131 10.6366 8.9211 12.2341 8.5611 13.8391C9.4491 12.7141 10.6251 12.2041 12.4011 12.2041Z"
        fill="#009F2B"
      />
    </svg>
  );
}

export function IconCampaign(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size || '1em'}
      height={props.size || '1em'}
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <g clipPath="url(#microphone)">
        <path
          fill="currentColor"
          d="M11.333 0a.667.667 0 0 0-.666.667c0 1.966-1.722 2.666-3.334 2.666H2.667A2.667 2.667 0 0 0 0 6v1.333a2.65 2.65 0 0 0 1.01 2.073l2.38 5.315A2.15 2.15 0 0 0 5.36 16a1.988 1.988 0 0 0 1.813-2.8L5.706 10h1.627c1.612 0 3.334.7 3.334 2.667a.667.667 0 0 0 1.333 0v-12A.666.666 0 0 0 11.333 0M5.958 13.746a.655.655 0 0 1-.599.92.82.82 0 0 1-.75-.489L2.737 10h1.502zm4.709-4.013a5.15 5.15 0 0 0-3.334-1.066H2.667a1.333 1.333 0 0 1-1.334-1.334V6a1.333 1.333 0 0 1 1.334-1.333h4.666a5.15 5.15 0 0 0 3.334-1.064zm5.266.568a.666.666 0 0 1-.894.299l-1.334-.667a.667.667 0 0 1 .596-1.193l1.334.667a.666.666 0 0 1 .298.891zm-2.526-6a.664.664 0 0 1 .298-.894l1.334-.667a.667.667 0 0 1 .596 1.193L14.3 4.6a.666.666 0 0 1-.894-.299m-.074 2.366A.667.667 0 0 1 14 6h1.333a.667.667 0 1 1 0 1.333H14a.667.667 0 0 1-.667-.666"
        />
      </g>
    </svg>
  );
}
export function SvgTime(props) {
  return (
    <svg width={props.size || '20px'} height={props.size || '20px'} viewBox="0 0 20 20" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.295 16.567a6.717 6.717 0 0 0 2.69.517 6.915 6.915 0 0 0 2.758-.558 7.311 7.311 0 0 0 2.258-1.515 7.111 7.111 0 0 0 1.526-2.244c.373-.872.563-1.81.558-2.759a6.78 6.78 0 0 0-.558-2.74 7.057 7.057 0 0 0-1.526-2.22 7.258 7.258 0 0 0-2.258-1.5A7.02 7.02 0 0 0 9.985 3a6.689 6.689 0 0 0-2.965.685 7.46 7.46 0 0 0-2.238 1.677v-1.88H3.425v4.211h4.229V6.336h-1.9A6.63 6.63 0 0 1 7.576 4.94a5.169 5.169 0 0 1 2.412-.586 5.672 5.672 0 0 1 4.057 1.621 5.313 5.313 0 0 1 1.686 3.968 5.632 5.632 0 0 1-1.668 4.095 5.534 5.534 0 0 1-4.075 1.687 5.4 5.4 0 0 1-4-1.667 5.588 5.588 0 0 1-1.63-4.038v-.1H3v.1a6.886 6.886 0 0 0 2.034 5 6.718 6.718 0 0 0 2.26 1.547ZM9.384 10.3l1.926 1.882.972-.97-1.541-1.482V7.172H9.384V10.3Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function IconBrowserInternet(props) {
  return (
    <svg width={props.size || '20px'} height={props.size || '20px'} viewBox="0 0 20 20" fill="none" {...props}>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.98 7.252c.335.85.52 1.778.52 2.748 0 .97-.184 1.898-.52 2.748-1.111-.339-2.399-.6-3.802-.76a27.464 27.464 0 0 0 0-3.976c1.403-.16 2.691-.421 3.802-.76ZM3.02 12.748A7.469 7.469 0 0 1 2.5 10c0-.97.184-1.898.52-2.748 1.111.339 2.398.6 3.802.76a27.464 27.464 0 0 0 0 3.976c-1.404.16-2.691.421-3.801.76Zm9.164-.855a28.944 28.944 0 0 0-4.368 0 26.943 26.943 0 0 1 0-3.788 28.944 28.944 0 0 0 4.368 0 26.943 26.943 0 0 1 0 3.788Zm4.335 1.815A7.522 7.522 0 0 1 12.1 17.2c.44-1.052.786-2.494.98-4.162 1.261.143 2.424.372 3.439.67Zm-5.67 3.744a7.555 7.555 0 0 1-1.698 0 5.257 5.257 0 0 1-.32-.634c-.416-.968-.737-2.312-.917-3.873a28.268 28.268 0 0 1 4.172 0c-.18 1.561-.501 2.905-.918 3.873a5.257 5.257 0 0 1-.319.634ZM7.9 17.2a7.522 7.522 0 0 1-4.419-3.492 20.587 20.587 0 0 1 3.44-.67c.193 1.668.539 3.11.979 4.162ZM3.481 6.291A7.522 7.522 0 0 1 7.9 2.798c-.44 1.053-.786 2.495-.98 4.163a20.587 20.587 0 0 1-3.439-.67Zm5.67-3.744a7.555 7.555 0 0 1 1.698 0c.111.185.218.398.32.634.416.968.737 2.312.917 3.873a28.268 28.268 0 0 1-4.173 0c.181-1.561.502-2.905.918-3.873.102-.236.209-.449.32-.634ZM12.1 2.8a7.522 7.522 0 0 1 4.419 3.493 20.587 20.587 0 0 1-3.44.669c-.193-1.668-.539-3.11-.979-4.162Z"
          fill="#0091BA"
        />
      </g>
    </svg>
  );
}

export function IconInstagram(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size || '1em'}
      height={props.size || '1em'}
      viewBox="0 0 16 17"
      fill="none"
      {...props}
    >
      <path
        fill="url(#instagramLogo)"
        d="M12.31.5H3.69A3.69 3.69 0 0 0 0 4.19v8.62a3.69 3.69 0 0 0 3.69 3.69h8.62A3.69 3.69 0 0 0 16 12.81V4.19A3.69 3.69 0 0 0 12.31.5"
      />
      <path
        fill="#fff"
        d="M10.58 3.657a2.303 2.303 0 0 1 2.293 2.293v5.1a2.3 2.3 0 0 1-2.293 2.293H5.42a2.3 2.3 0 0 1-2.293-2.293v-5.1A2.3 2.3 0 0 1 5.42 3.657zm0-1.067H5.42a3.37 3.37 0 0 0-3.36 3.36v5.1a3.37 3.37 0 0 0 3.36 3.36h5.16a3.37 3.37 0 0 0 3.36-3.36v-5.1a3.37 3.37 0 0 0-3.36-3.36"
      />
      <path
        fill="#fff"
        d="M8 6.509a1.991 1.991 0 1 1 0 3.982 1.991 1.991 0 0 1 0-3.982m0-1.067a3.057 3.057 0 1 0 0 6.115 3.057 3.057 0 0 0 0-6.115m3.124.591a.725.725 0 1 0 0-1.45.725.725 0 0 0 0 1.45"
      />
      <defs>
        <linearGradient id="instagramLogo" x1={10.486} x2={5.514} y1={17.172} y2={-0.172} gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFDB73" />
          <stop offset={0.08} stopColor="#FDAD4E" />
          <stop offset={0.15} stopColor="#FB832E" />
          <stop offset={0.19} stopColor="#FA7321" />
          <stop offset={0.23} stopColor="#F6692F" />
          <stop offset={0.37} stopColor="#E84A5A" />
          <stop offset={0.48} stopColor="#E03675" />
          <stop offset={0.55} stopColor="#DD2F7F" />
          <stop offset={0.68} stopColor="#B43D97" />
          <stop offset={0.97} stopColor="#4D60D4" />
          <stop offset={1} stopColor="#4264DB" />
        </linearGradient>
      </defs>
    </svg>
  );
}
export function IconTikTok(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size || '1em'}
      height={props.size || '1em'}
      viewBox="0 0 16 17"
      fill="none"
      {...props}
    >
      <path
        fill="#000"
        d="M13.34.5H2.66A2.66 2.66 0 0 0 0 3.16v10.68a2.66 2.66 0 0 0 2.66 2.66h10.68A2.66 2.66 0 0 0 16 13.84V3.16A2.66 2.66 0 0 0 13.34.5"
      />
      <path
        fill="#00F6EF"
        d="M12.987 7.191V5.057c-2.789-.117-2.879-2.652-2.879-2.89V2.15H7.953v8.31a1.707 1.707 0 1 1-1.21-1.634v-2.2a3.866 3.866 0 1 0 3.368 3.835q0-.083-.003-.163V6.205c.992.909 2.879.986 2.879.986"
      />
      <path
        fill="#fff"
        d="M13.622 7.717V5.583c-2.79-.118-2.879-2.653-2.879-2.89v-.019H8.587v8.31a1.707 1.707 0 1 1-1.21-1.634v-2.2a3.9 3.9 0 0 0-2.646.621 3.866 3.866 0 1 0 6.015 3.213q.001-.081-.004-.161V6.73c.993.908 2.88.986 2.88.986"
      />
      <path
        fill="#FF004F"
        d="M10.162 2.674c.104.566.407 1.451 1.292 1.97-.676-.789-.71-1.805-.71-1.952v-.018zm3.46 5.043V5.583a4 4 0 0 1-.636-.075v1.68s-1.886-.077-2.878-.985v4.09l.003.162a3.867 3.867 0 0 1-6.008 3.22 3.866 3.866 0 0 0 6.643-2.69q.001-.082-.004-.162V6.73c.993.908 2.88.986 2.88.986"
      />
      <path
        fill="#FF004F"
        d="M6.743 8.821a1.708 1.708 0 0 0-1.24 3.172A1.708 1.708 0 0 1 7.377 9.35v-2.2a4 4 0 0 0-.5-.03l-.136.002z"
      />
    </svg>
  );
}
export function SvgIcListingPages(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size || '1em'}
      height={props.size || '1em'}
      viewBox="0 0 20 21"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        d="M16.154 2.5H3.846A1.846 1.846 0 0 0 2 4.346v2.257h16V4.346A1.846 1.846 0 0 0 16.154 2.5M5.487 5.372h-.82a.615.615 0 1 1 0-1.231h.82a.615.615 0 1 1 0 1.23m2.462 0h-.82a.615.615 0 1 1 0-1.231h.82a.615.615 0 1 1 0 1.23M2 16.654A1.846 1.846 0 0 0 3.846 18.5h12.308A1.846 1.846 0 0 0 18 16.654v-8.82H2zm9.641-5.539h3.282a.615.615 0 1 1 0 1.231h-3.282a.615.615 0 0 1 0-1.23m0 2.462h3.282a.615.615 0 0 1 0 1.23h-3.282a.615.615 0 1 1 0-1.23m-7.59-2.257a1.444 1.444 0 0 1 1.436-1.435H8.77a1.444 1.444 0 0 1 1.436 1.435v3.283a1.444 1.444 0 0 1-1.436 1.435H5.487a1.444 1.444 0 0 1-1.436-1.435zm1.231 3.283V11.32a.205.205 0 0 1 .205-.205H8.77a.205.205 0 0 1 .205.205v3.283a.205.205 0 0 1-.205.205H5.487a.205.205 0 0 1-.205-.205"
      />
    </svg>
  );
}
export function BayutLogo(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size}
      height={props.size}
      viewBox="0 0 26 20"
      fill="none"
      {...props}
    >
      <path
        fill="#28B16D"
        fillRule="evenodd"
        d="M15.321 17.641c2.913.129 5.664-1.326 7.16-3.787a7.68 7.68 0 0 0 0-7.996c-1.497-2.461-4.246-3.917-7.16-3.787-4.233.188-7.566 3.618-7.566 7.785s3.333 7.597 7.566 7.785M17.898.345c4.188 1.106 7.173 4.74 7.393 8.999.221 4.259-2.374 8.172-6.426 9.69-4.052 1.52-8.637.298-11.355-3.025l-.048.032-5.493 3.12a.877.877 0 0 1-1.191-.317l-.66-1.124a.84.84 0 0 1-.088-.652.85.85 0 0 1 .409-.52l5.492-3.105.049-.032A9.71 9.71 0 0 1 7.854 3.274C10.373.513 14.255-.62 17.898.344m-2.577 9.501c-.919 0-1.675.744-1.675 1.648v2.06a.607.607 0 0 1-.612.6h-2.239a.76.76 0 0 1-.7-.459.7.7 0 0 1-.057-.285V8.944c0-1.11 0-1.22.435-1.458l3.93-2.233c.354-.206.611-.349.934-.349.322 0 .58.143.934.349l3.93 2.233c.435.254.435.348.435 1.458v4.466a.75.75 0 0 1-.758.745h-2.237a.61.61 0 0 1-.612-.603v-2.059c-.035-.908-.785-1.63-1.708-1.647"
        clipRule="evenodd"
      />
    </svg>
  );
}

export function SnapchatIcon(props) {
  return (
    <svg
      width={props.size || '1em'}
      height={props.size || '1em'}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.5357 0.5H1.96429C1.01786 0.5 0.25 1.26786 0.25 2.21429V14.7857C0.25 15.7321 1.01786 16.5 1.96429 16.5H14.5357C15.4821 16.5 16.25 15.7321 16.25 14.7857V2.21429C16.25 1.26786 15.4821 0.5 14.5357 0.5ZM14.3036 11.7464C14.1786 12.0357 13.6571 12.2464 12.7036 12.3964C12.6536 12.4643 12.6143 12.7464 12.55 12.9643C12.5107 13.0964 12.4179 13.175 12.2607 13.175H12.2536C12.0321 13.175 11.7964 13.0714 11.3321 13.0714C10.7036 13.0714 10.4857 13.2143 9.99643 13.5607C9.47857 13.9286 8.98214 14.2429 8.23929 14.2107C7.48929 14.2679 6.86071 13.8107 6.50714 13.5607C6.01429 13.2143 5.8 13.0714 5.17143 13.0714C4.725 13.0714 4.44286 13.1821 4.25 13.1821C4.05714 13.1821 3.98214 13.0643 3.95357 12.9679C3.88929 12.75 3.85 12.4643 3.8 12.3964C3.30714 12.3214 2.2 12.1286 2.175 11.6321C2.16786 11.5036 2.25714 11.3893 2.38571 11.3679C4.03929 11.0964 4.78214 9.4 4.81429 9.32857C4.81429 9.325 4.81786 9.32143 4.82143 9.31786C4.91071 9.13929 4.92857 8.98929 4.87857 8.87143C4.75714 8.58929 4.23929 8.48929 4.02143 8.4C3.45714 8.17857 3.37857 7.92143 3.41429 7.74643C3.47143 7.44286 3.92857 7.25357 4.19643 7.37857C4.40714 7.47857 4.59643 7.52857 4.75714 7.52857C4.875 7.52857 4.95357 7.5 4.99286 7.47857C4.94286 6.625 4.825 5.40714 5.12857 4.725C5.93214 2.92857 7.63214 2.78571 8.13214 2.78571C8.15357 2.78571 8.35 2.78214 8.37143 2.78214C9.61071 2.78214 10.8 3.41786 11.3821 4.72143C11.6857 5.40357 11.5679 6.61786 11.5179 7.475C11.5571 7.49643 11.6214 7.52143 11.7214 7.525C11.875 7.51786 12.05 7.46786 12.2464 7.375C12.3893 7.30714 12.5893 7.31786 12.7321 7.375C12.9571 7.45714 13.1 7.61786 13.1036 7.8C13.1071 8.03214 12.9 8.23214 12.4893 8.39286C12.4393 8.41429 12.3786 8.43214 12.3143 8.45357C12.0821 8.52857 11.7286 8.63929 11.6357 8.86429C11.5857 8.98214 11.6071 9.13214 11.6929 9.31071C11.6964 9.31429 11.6964 9.31786 11.7 9.32143C11.7321 9.39286 12.475 11.0893 14.1286 11.3607C14.2714 11.3964 14.3821 11.5571 14.3036 11.7464Z"
        fill="#FFFC00"
      />
    </svg>
  );
}

export function LandingPageIcon(props) {
  return (
    <svg
      width={props.size || '1em'}
      height={props.size || '1em'}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.12508 15.8334C12.1752 15.8334 15.4584 12.5501 15.4584 8.50002C15.4584 4.44993 12.1752 1.16669 8.12508 1.16669M8.12508 15.8334C4.07499 15.8334 0.791748 12.5501 0.791748 8.50002C0.791748 4.44993 4.07499 1.16669 8.12508 1.16669M8.12508 15.8334C10.1251 15.8334 10.7917 12.5 10.7917 8.50002C10.7917 4.50002 10.1251 1.16669 8.12508 1.16669M8.12508 15.8334C6.12508 15.8334 5.45841 12.5 5.45841 8.50002C5.45841 4.50002 6.12508 1.16669 8.12508 1.16669M1.45841 11.1667H14.7917M1.45841 5.83335H14.7917"
        stroke="currentColor"
        strokeWidth="1.33333"
      />
    </svg>
  );
}

export function CallCenterIc(props) {
  return (
    <svg
      width={props.size}
      height={props.size}
      viewBox="0 0 17 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.4375 2C5.12187 2 2.3875 4.48125 1.9875 7.6875C2.28125 7.56875 2.6 7.5 2.9375 7.5C3.76562 7.5 4.4375 8.17188 4.4375 9V13C4.4375 13.8281 3.76562 14.5 2.9375 14.5C1.55625 14.5 0.4375 13.3813 0.4375 12V11.5V10V8.5C0.4375 4.08125 4.01875 0.5 8.4375 0.5C12.8562 0.5 16.4375 4.08125 16.4375 8.5V10V11.5V12C16.4375 13.3813 15.3188 14.5 13.9375 14.5C13.1094 14.5 12.4375 13.8281 12.4375 13V9C12.4375 8.17188 13.1094 7.5 13.9375 7.5C14.275 7.5 14.5938 7.56563 14.8875 7.6875C14.4875 4.48125 11.7531 2 8.4375 2Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function SvgIcFetch(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size || '1em'}
      height={props.size || '1em'}
      viewBox=" 0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m5 14-3-3m0 0 3-3m-3 3h9m0-9 3 3m0 0-3 3m3-3H5"
      />
    </svg>
  );
}

export function IconBrowserSafari(props) {
  return (
    <svg width={props.size || '20px'} height={props.size || '20px'} viewBox="0 0 20 20" fill="none" {...props}>
      <g>
        <path d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z" fill="#2196F3" />
        <path d="m9 9-4 6 6-4-2-2Z" fill="#FAFAFA" />
        <path d="m9 9 2 2 4-6-6 4Z" fill="#F44336" />
      </g>
    </svg>
  );
}

export function IconBrowserFirefox(props) {
  return (
    <svg width={props.size || '20px'} height={props.size || '20px'} viewBox="0 0 20 20" fill="none" {...props}>
      <g>
        <circle cx={10} cy={10.297} r={4} fill="#9A3BDA" />
        <path
          d="M17.183 7.365c-.336-.81-1.019-1.685-1.554-1.961.436.855.688 1.712.784 2.352l.002.013c-.876-2.184-2.363-3.065-3.576-4.983a9.891 9.891 0 0 1-.183-.297 2.322 2.322 0 0 1-.085-.16c-.05-.098-.09-.2-.116-.307a.02.02 0 0 0-.018-.02C12.434 2 12.43 1.998 12.425 2l-.006.002-.009.005c-2.002 1.199-2.601 3.244-2.662 4.3.09-.007.18-.014.273-.014a3.91 3.91 0 0 1 3.396 1.983c-.414-.291-1.155-.578-1.87-.454 2.789 1.394 2.04 6.193-1.823 6.012a3.441 3.441 0 0 1-1.008-.195 4.34 4.34 0 0 1-.359-.155l.006.003a4.76 4.76 0 0 1-.113-.056c.036.017.07.036.107.053-.946-.49-1.728-1.414-1.826-2.537 0 0 .358-1.333 2.562-1.333.238 0 .92-.665.932-.857-.003-.063-1.352-.6-1.877-1.118-.281-.277-.415-.41-.533-.51a2.303 2.303 0 0 0-.2-.152 3.59 3.59 0 0 1-.023-1.894c-.796.362-1.415.935-1.865 1.441h-.004c-.307-.389-.286-1.673-.268-1.94-.004-.018-.23.116-.259.136a5.646 5.646 0 0 0-.757.65 6.79 6.79 0 0 0-.724.867 6.542 6.542 0 0 0-1.04 2.348l-.01.052c-.015.068-.08.414-.09.488 0 .006.001-.005 0 0a8.94 8.94 0 0 0-.114 1.082v.04a7.75 7.75 0 0 0 15.39 1.31c.013-.098.024-.198.035-.298.154-1.33-.017-2.726-.503-3.895Zm-.768.398v.009-.009Z"
          fill="#FF850E"
        />
      </g>
    </svg>
  );
}

export function IconBrowserChrome(props) {
  return (
    <svg width={props.size || '20px'} height={props.size || '20px'} viewBox="0 0 20 20" fill="none" {...props}>
      <g>
        <path
          d="M6.85 11.818 10 6.363l.585.01.956.037 3.194 1.106 2.392-1.153A8 8 0 0 0 10 2a7.993 7.993 0 0 0-6.73 3.673v.005l.243 4.095 3.338 2.045Z"
          fill="#DB4437"
        />
        <path
          d="m6.85 11.819-3.58-6.14-.001-.003A8 8 0 0 0 9.62 17.992l2.859-1.896.669-4.276-6.298-.001Z"
          fill="#0F9D58"
        />
        <path d="M17.127 6.363H10l3.15 5.455-.001.001-3.528 6.172h.003a8 8 0 0 0 7.504-11.628Z" fill="#FFCD40" />
        <path d="M10 13.637a3.637 3.637 0 1 0 0-7.274 3.637 3.637 0 0 0 0 7.274Z" fill="#F1F1F1" />
        <path d="M10 12.909a2.91 2.91 0 1 0 0-5.82 2.91 2.91 0 0 0 0 5.82Z" fill="#4285F4" />
      </g>
    </svg>
  );
}

export function SvgManageReservation(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size || '20px'}
      height={props.size || '20px'}
      fill="none"
      {...props}
    >
      <g clipPath="url(#a)">
        <path
          fill="currentColor"
          d="M16.217 2.5h-.875c.625.237.95.858.95 1.78v12.445c0 .92-.292 1.554-.95 1.78h.875c.987 0 1.783-.8 1.783-1.78V4.279C18 3.3 17.204 2.5 16.217 2.5m-2.488.008q-.087-.007-.175-.008H3.78C2.8 2.5 2 3.3 2 4.28v12.445c0 .98.8 1.78 1.78 1.78h9.778q.088-.001.175-.01a1.785 1.785 0 0 0 1.604-1.77V4.279a1.79 1.79 0 0 0-1.608-1.77M8 10.5 5.667 9.167 3.333 10.5V3.833H8z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M2 2.5h16v16H2z" />
        </clipPath>
      </defs>
    </svg>
  );
}
export function SvgIntellicon(props) {
  return (
    <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 20 21" fill="none" {...props}>
      <g fillRule="evenodd" clipRule="evenodd">
        <path
          d="M9.48 4.593c-1 .149-1.798.557-2.475 1.265a4.141 4.141 0 0 0-1.056 2.02c-.08.377-.088 1.215-.014 1.583.115.564.217.806.858 2.024.556 1.058.758 1.513.855 1.93.024.105.054.472.075.932.03.665.041.777.092.905.075.19.214.38.353.48.222.16.236.162 1.902.153 1.514-.007 1.514-.007 1.66-.077a.798.798 0 0 0 .473-.696c.014-.18.014-.18-.24-.18-.255 0-.255 0-.274.113a.364.364 0 0 1-.306.3c-.065.009-.726.013-1.468.008-1.311-.008-1.35-.01-1.424-.062a.567.567 0 0 1-.135-.173c-.053-.106-.062-.183-.085-.704-.047-1.039-.077-1.209-.306-1.772-.114-.278-.257-.564-1.034-2.075-.4-.778-.505-1.166-.508-1.877A3.424 3.424 0 0 1 7.4 6.236c.68-.711 1.485-1.078 2.454-1.117a3.337 3.337 0 0 1 1.705.361 3.499 3.499 0 0 1 1.643 1.631c.39.78.476 1.789.22 2.598-.093.294-.287.753-.386.914-.044.072-.08.136-.08.144 0 .007.137.013.306.013.305 0 .305 0 .372-.131.1-.2.268-.631.33-.854a3.4 3.4 0 0 0 .135-.815c.148-2.048-1.224-3.873-3.254-4.327-.19-.043-.36-.057-.764-.063a8.716 8.716 0 0 0-.6.003Zm.511 1.066c-.01.01-.018.134-.018.276 0 .258 0 .258.233.273a2.473 2.473 0 0 1 1.492.67c.169.157.169.157.36-.036.191-.193.191-.193.008-.365a3.054 3.054 0 0 0-1.76-.808c-.285-.032-.292-.033-.315-.01ZM8.616 16.53c0 .266 0 .266 1.384.266s1.384 0 1.384-.266 0-.266-1.384-.266-1.384 0-1.384.266Zm0 .838c0 .28 0 .28 1.385.28s1.385 0 1.378-.273c-.008-.273-.008-.273-1.386-.28-1.377-.006-1.377-.006-1.377.273Zm.532.853c0 .28 0 .28.845.273.845-.007.845-.007.845-.273 0-.267 0-.267-.845-.274-.845-.007-.845-.007-.845.274Z"
          fill="#FCA41C"
        />
        <path
          d="M9.64 2.518c-2.01.123-3.81 1.197-4.898 2.924-.163.258-.43.791-.51 1.018-.048.14-.048.14-.495.14a4.58 4.58 0 0 0-.446.011c0 .007-.036.153-.08.326-.17.655-.198.904-.198 1.74 0 .847.02 1.03.189 1.71.097.393.097.393 1.224.393.62 0 1.128-.004 1.128-.008s-.043-.109-.095-.233a5.511 5.511 0 0 1-.32-1.193 5.78 5.78 0 0 1 .053-1.643c.365-1.727 1.589-3.11 3.238-3.661a4.869 4.869 0 0 1 3.686.228 4.884 4.884 0 0 1 2.514 2.852 4.861 4.861 0 0 1-.211 3.653c-.244.51-.508.896-.891 1.303-.205.218-.205.218-.316.16-.167-.086-.49-.097-.687-.023a.88.88 0 0 0-.48.448.652.652 0 0 0-.087.378.881.881 0 0 0 .47.787c.117.064.18.079.37.088.207.01.246.004.393-.062a.987.987 0 0 0 .46-.457.976.976 0 0 0 .052-.558c-.031-.13-.031-.13.199-.37a5.734 5.734 0 0 0 1.026-1.489c.09-.2.09-.2.92-.2.83 0 .83 0 .872-.142a7.076 7.076 0 0 0 .012-3.858c-.052-.179-.052-.179-.491-.186-.44-.007-.44-.007-.532-.234a6.218 6.218 0 0 0-4.138-3.644 6.167 6.167 0 0 0-1.93-.198Z"
          fill="#1C74BC"
        />
      </g>
    </svg>
  );
}
export function BillModulesIcon(props) {
  return (
    <svg
      width={props.size || '1em'}
      height={props.size || '1em'}
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_5083_17220)" transform="translate(2,1)">
        <path
          d="M12.0789 14.5138L12.0797 14.5129C12.3378 14.2543 12.4831 13.904 12.4838 13.5384C12.4838 13.5384 12.4838 13.5383 12.4838 13.5383M12.0789 14.5138L12.5838 13.5384L12.4838 13.5383M12.0789 14.5138C11.834 14.765 11.5021 14.9126 11.1519 14.9261C11.1309 14.923 11.1099 14.9215 11.089 14.9213H11.0883H10.97C10.2596 14.8489 9.71724 14.2531 9.71231 13.5385V11.9543C9.71231 11.7056 9.51056 11.5036 9.26159 11.5036H3.04025L3.10093 2.61333C3.10093 2.61325 3.10093 2.61318 3.10093 2.61311C3.10556 2.16115 3.47503 1.79801 3.92711 1.80143V1.80143H3.92786H12.7424C12.5739 2.07837 12.4837 2.3974 12.4838 2.72412L12.0789 14.5138ZM12.4838 13.5383L12.4838 2.72415L12.4838 13.5383ZM-0.1 13.5746L-0.0999999 13.5747C-0.0987098 14.8197 0.910171 15.8286 2.15513 15.83H2.15525C2.18251 15.83 2.20993 15.8275 2.23695 15.8226H10.9375C10.9899 15.8263 11.0435 15.8288 11.098 15.8288L11.0982 15.8288C12.3617 15.8265 13.3848 14.8019 13.3852 13.5385V13.5384V8.38102H15.6492C15.8982 8.38102 16.1 8.17925 16.1 7.9303L16.1 2.72412L16.1 2.72361C16.0955 1.84364 15.4558 1.09687 14.589 0.956185C14.5227 0.919475 14.4479 0.9 14.3717 0.9H3.92786C2.97591 0.9 2.19971 1.66689 2.19951 2.60949C2.19951 2.60961 2.19951 2.60974 2.19951 2.60986L2.13881 11.5036H0.350714C0.101771 11.5036 -0.1 11.7054 -0.1 11.9543L-0.1 13.5746ZM9.27582 14.9212L2.1073 14.9212L2.10647 14.9212C2.08934 14.9213 2.0721 14.9224 2.05477 14.9245C1.34912 14.8713 0.802365 14.2835 0.801428 13.5747V12.4052H8.81088V13.5385V13.5386H8.91088L9.27582 14.9212ZM3.92786 1.70143H12.808H3.92786ZM15.1985 7.47959H13.3852V2.72495C13.3939 2.23042 13.7972 1.83417 14.2919 1.83417C14.7865 1.83417 15.1898 2.23042 15.1985 2.72495V7.47959Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth={0.3}
        />
        <path
          d="M4.50306 4.48824H7.8247C8.04603 4.48824 8.22542 4.30886 8.22542 4.08753C8.22542 3.8662 8.04603 3.68682 7.8247 3.68682H4.50306C4.28173 3.68682 4.10234 3.8662 4.10234 4.08753C4.10234 4.30886 4.28173 4.48824 4.50306 4.48824Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth={0.3}
        />
        <path
          d="M10.6992 6.19438H4.50306C4.28173 6.19438 4.10234 6.37377 4.10234 6.5951C4.10234 6.81628 4.28172 6.99581 4.50306 6.99581H10.6992C10.9205 6.99581 11.0999 6.81628 11.0999 6.5951C11.0999 6.37377 10.9205 6.19438 10.6992 6.19438Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth={0.3}
        />
        <path
          d="M10.6992 8.70195H4.50306C4.28172 8.70195 4.10234 8.88149 4.10234 9.10267C4.10234 9.324 4.28173 9.50338 4.50306 9.50338H10.6992C10.9205 9.50338 11.0999 9.324 11.0999 9.10267C11.0999 8.88149 10.9205 8.70195 10.6992 8.70195Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth={0.3}
        />
      </g>
      <defs>
        <clipPath id="clip0_5083_17220">
          <rect width="22" height="23" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function IconInprogress(props) {
  return (
    <svg
      fill="currentColor"
      viewBox="0 0 24 24"
      width={props.size || '1em'}
      height={props.size || '1em'}
      {...props}
    >
      <path
        d="m21.555 10.265-1-.246a8.5 8.5 0 0 0-1.101-2.671l.504-.844a.58.58 0 0 0-.082-.714l-.82-.82-.844-.844a.58.58 0 0 0-.715-.082l-.843.504a8.5 8.5 0 0 0-2.671-1.102l-.247-1a.58.58 0 0 0-.562-.445h-2.343a.58.58 0 0 0-.562.446l-.246 1c-.95.21-1.852.585-2.672 1.1l-.843-.503a.58.58 0 0 0-.715.082L4.13 5.79a.58.58 0 0 0-.082.714l.504.844a8.5 8.5 0 0 0-1.101 2.671l-1 .246a.58.58 0 0 0-.445.563v2.343c0 .27.187.503.445.562l1 .246a8.8 8.8 0 0 0 1.523 3.28l1.769 1.77a8.8 8.8 0 0 0 3.28 1.523l.246 1a.58.58 0 0 0 .563.445h2.343c.27 0 .504-.188.562-.445l.246-1a8.5 8.5 0 0 0 2.672-1.101l.843.503c.234.14.527.106.715-.082l1.663-1.664a.58.58 0 0 0 .082-.714l-.503-.844c.515-.82.89-1.722 1.101-2.671l1-.246A.58.58 0 0 0 22 13.17v-2.343a.58.58 0 0 0-.445-.563m-9.553 7.006a5.13 5.13 0 0 1-3.55-1.394 1 1 0 0 1-.164-.14 5.24 5.24 0 0 1-1.558-3.738 5.265 5.265 0 0 1 5.272-5.272c1.465 0 2.789.597 3.738 1.558.058.059.105.106.14.164a5.13 5.13 0 0 1 1.394 3.55 5.265 5.265 0 0 1-5.272 5.272"
        fillOpacity={0.8}
      />
      <path d="M15.968 10.942a.585.585 0 0 0-.982-.271l-1.328 1.328c-.221.22-.515.342-.829.342s-.607-.121-.828-.342a1.173 1.173 0 0 1 0-1.657l1.338-1.337a.579.579 0 0 0-.267-.97 4.5 4.5 0 0 0-1.833-.069 4.095 4.095 0 0 0-3.271 3.274 4.15 4.15 0 0 0 .167 2.133l-5.62 5.62a1.767 1.767 0 0 0 .01 2.503 1.776 1.776 0 0 0 2.482-.01l5.62-5.621c.9.321 1.904.315 2.886-.032 1.327-.468 2.245-1.693 2.52-3.072l.001-.003a4.4 4.4 0 0 0-.066-1.816" />
      <path d="m5.007 21.484 5.62-5.62c.9.321 1.904.315 2.886-.032 1.327-.468 2.245-1.693 2.521-3.072v-.003c.12-.668.06-1.326-.069-1.83a.579.579 0 0 0-.97-.266l-1.337 1.337a1.167 1.167 0 0 1-1.644.009l-9.488 9.488c.692.656 1.75.683 2.481-.01" />
    </svg>
  );
}

export function IconNew(props) {
  return (
    <svg
      fill="currentColor"
      viewBox="0 0 24 24"
      width={props.size || '1em'}
      height={props.size || '1em'}
      {...props}
    >
      <path d="M17.436 2H6.564C4.595 2 3 3.537 3 5.44v15.742c0 .668.793 1.059 1.353.653l3.399-2.46h9.684c1.969 0 3.564-1.537 3.564-3.44V5.44C21 3.54 19.407 2 17.436 2M12 15.44c-.467 0-.846-.366-.846-.817s.38-.817.846-.817c.467 0 .846.366.846.817s-.38.817-.846.817m.846-3.611v.17c0 .451-.379.817-.846.817s-.846-.366-.846-.817v-.874c0-.451.379-.817.846-.817.783 0 1.42-.614 1.42-1.37 0-.755-.637-1.37-1.42-1.37-.787 0-1.42.615-1.42 1.37 0 .45-.378.817-.845.817s-.846-.366-.846-.816c0-1.661 1.393-3.003 3.11-3.003s3.112 1.347 3.112 3.003c0 1.372-.96 2.533-2.265 2.89" />
    </svg>
  );
}

export function IconRefreshActions(props) {
  return (
    <svg
      fill="currentColor"
      viewBox="0 0 18 20"
      width={props.size || '1em'}
      height={props.size || '1em'}
      {...props}
    >
      <g>
        <path d="M1.262 10.02a7.582 7.582 0 0 0 3.233 6.214.627.627 0 0 1 .032 1.01l-.01.007a.624.624 0 0 1-.743.023A8.845 8.845 0 0 1 0 10.02a8.943 8.943 0 0 1 8.88-8.853V2.43a7.678 7.678 0 0 0-7.618 7.59Z" />
        <path d="m9.111.037 2.324 1.587a.214.214 0 0 1 0 .353L9.111 3.563a.214.214 0 0 1-.334-.177V.214a.214.214 0 0 1 .335-.177Zm7.511 9.944a7.582 7.582 0 0 0-3.233-6.214.626.626 0 0 1-.032-1.01l.009-.007a.624.624 0 0 1 .743-.023 8.843 8.843 0 0 1 3.772 7.25 8.936 8.936 0 0 1-8.872 8.853v-1.263a7.678 7.678 0 0 0 7.613-7.586Z" />
        <path d="m8.768 19.963-2.324-1.586a.215.215 0 0 1 0-.354l2.324-1.586a.214.214 0 0 1 .334.177v3.173a.214.214 0 0 1-.334.176Zm4.108-10.946-3.8 3.15-.957.795a1.253 1.253 0 0 1-1.804-.214L4.838 10.78a1.01 1.01 0 1 1 1.617-1.212l.997 1.33.008-.007 4.134-3.43a1.01 1.01 0 0 1 1.286 1.551l-.004.006Z" />
        <path d="m12.877 9.017-3.8 3.15a5.105 5.105 0 0 1-1.616-1.272l4.134-3.43a1.01 1.01 0 0 1 1.286 1.552h-.004Z" />
      </g>
    </svg>
  );
}

export const IconWaveHand = (props) => {
  return (
    <svg
      viewBox="0 0 64 64"
      width={props.size || "1em"}
      height={props.size || "1em"}
      {...props}
    >
      <path
        d="M16.1 48.5c-.5-.1-.9-.2-1.4-.4-.5-.2-.9-.3-1.3-.5-.9-.4-1.7-.9-2.5-1.5C9.3 45 8 43.5 7 41.7 6 40 5.4 38 5.3 36.1c-.1-1 0-1.9.1-2.9.1-.5.2-.9.3-1.4.1-.5.3-.9.4-1.4l.1 1.4c0 .5.1.9.2 1.4.1.9.3 1.8.5 2.6.4 1.7 1 3.3 1.9 4.8.9 1.5 1.9 2.9 3.2 4.2.6.6 1.3 1.2 2 1.8.3.3.7.6 1.1.9l1 1m-.3 3.6c-.3.2-.7.3-1.1.4-.4.1-.7.2-1.1.2-.7.1-1.5.2-2.3.1-1.5-.1-3.1-.5-4.4-1.2-1.4-.7-2.6-1.8-3.4-3.1-.4-.6-.8-1.3-1.1-2-.1-.3-.2-.7-.3-1.1 0-.3-.1-.6-.1-1 .3.3.5.6.7.8.3.3.5.6.7.8.5.5.9 1 1.4 1.4 1 .9 2 1.7 3.2 2.3 1.1.6 2.4 1.1 3.6 1.5.6.2 1.3.3 2 .5.3.1.7.1 1 .2.5.1.8.1 1.2.2M38.4 3.5c.5.1.9.3 1.4.5.5.2.9.4 1.3.6.9.5 1.7 1 2.5 1.6 1.6 1.2 2.9 2.8 3.8 4.6.9 1.8 1.4 3.8 1.4 5.7 0 1-.1 1.9-.3 2.9-.1.5-.2.9-.4 1.4-.2.5-.3.9-.5 1.3l-.1-1.4c0-.5 0-.9-.1-1.4l-.3-2.7c-.3-1.7-.9-3.4-1.7-5-.8-1.6-1.8-3-3-4.3-.6-.7-1.3-1.3-1.9-2-.3-.3-.7-.6-1.1-.9l-1-.9m8.7-.4c.4.1.7.2 1 .4.3.1.7.3 1 .5.6.4 1.2.8 1.8 1.3 1.1 1 2 2.2 2.5 3.6.6 1.4.8 2.9.6 4.4-.1.7-.3 1.4-.5 2.1-.1.3-.3.7-.4 1-.2.3-.3.6-.6.9v-2c0-.7-.1-1.3-.1-1.9-.2-1.3-.4-2.5-.9-3.6-.5-1.2-1.1-2.2-1.8-3.3-.4-.5-.8-1.1-1.2-1.6-.2-.3-.4-.5-.7-.8-.2-.5-.5-.8-.7-1"
        fill="#686868"
      />
      <path
        d="M10 18c-2 .9-2.7 3.3-1.8 5.3l12.6 26.3 7-3.3-12.6-26.4c-.9-2-3.2-2.9-5.2-1.9m33.1 20.9 7.4-3.5-14.4-30c-1-2-3.4-2.9-5.5-1.9-2 1-2.9 3.4-1.9 5.5l14.4 29.9"
        fill="#ffcc3e"
      />
      <path
        d="M30.7 3.4c-.2.1-.4.2-.6.4 1.9-.5 3.9.4 4.8 2.2l14.4 30 1.3-.6-14.4-30c-1-2.1-3.4-3-5.5-2"
        fill="#eba352"
      />
      <path
        d="m27.8 46.2 7.7-3.7-14.7-30.6c-1-2.1-3.6-3.1-5.7-2.1s-3 3.6-2 5.7l14.7 30.7"
        fill="#ffcc3e"
      />
      <path
        d="M15.1 9.9c-.2.1-.4.2-.6.4 1.9-.5 4.1.4 5 2.3l9.1 19.1 2.2 1.3-10-21c-1-2.2-3.5-3.1-5.7-2.1"
        fill="#eba352"
      />
      <path
        d="m34.3 40.1 7.7-3.7L27.3 5.8c-1-2.1-3.6-3.1-5.7-2-2.1 1-3 3.6-2 5.7l14.7 30.6"
        fill="#ffcc3e"
      />
      <path
        d="M21.6 3.7c-.2.1-.4.3-.6.4 1.9-.5 4.1.4 5 2.3L36.3 28l2.2 1.3L27.3 5.8c-1-2.2-3.6-3.1-5.7-2.1M10 18c-.2.1-.4.2-.6.4 1.8-.5 3.7.4 4.5 2.2l7.5 15.7 2.2 1.3L15.2 20c-.9-2.1-3.2-3-5.2-2"
        fill="#eba352"
      />
      <path
        d="M60.8 15c-2.7-2.1-7.1.2-9.3 7.4-1.5 5-1.7 6.5-4.9 8l-1.8-3.7S16.4 40.4 17.5 42.6c0 0 3.4 10.6 9.2 15.5 8.6 7.4 28.7-.5 29.6-19.6.5-11.1 7.4-21.2 4.5-23.5"
        fill="#ffcc3e"
      />
      <g fill="#eba352">
        <path d="M60.8 15c-.5-.4-1.1-.6-1.7-.7.1.1.3.1.4.2 3 2.3-.1 7.6-1.8 12.4-1.4 3.8-2.6 7.7-2.4 11.5.8 16.6-15.9 24.5-25.9 21.5 9.8 4.1 28-3.7 27.2-21-.2-3.8.9-7.5 2.4-11.5 1.6-4.8 4.7-10.1 1.8-12.4" />
        <path d="M47.5 30c-6.2.7-15.3 9.6-8.9 19.3-4.7-9.8 3-16.4 7.9-18.7.5-.4 1-.6 1-.6" />
      </g>
    </svg>
  )
}

export function GoogleIcon(props) {
  return (
    <svg
      viewBox="0 0 512 512"
      style={{
        enableBackground: "new 0 0 512 512",
      }}
      className={props.className}
      xmlSpace="preserve"
      width={props.size || "1em"}
      height={props.size || "1em"}
      {...props}
    >
      <path
        style={{
          fill: "#167ee6",
        }}
        d="m492.668 211.489-208.84-.01c-9.222 0-16.697 7.474-16.697 16.696v66.715c0 9.22 7.475 16.696 16.696 16.696h117.606c-12.878 33.421-36.914 61.41-67.58 79.194L384 477.589c80.442-46.523 128-128.152 128-219.53 0-13.011-.959-22.312-2.877-32.785-1.458-7.957-8.366-13.785-16.455-13.785z"
      />
      <path
        style={{
          fill: "#12b347",
        }}
        d="M256 411.826c-57.554 0-107.798-31.446-134.783-77.979l-86.806 50.034C78.586 460.443 161.34 512 256 512c46.437 0 90.254-12.503 128-34.292v-.119l-50.147-86.81c-22.938 13.304-49.482 21.047-77.853 21.047z"
      />
      <path
        style={{
          fill: "#0f993e",
        }}
        d="M384 477.708v-.119l-50.147-86.81c-22.938 13.303-49.48 21.047-77.853 21.047V512c46.437 0 90.256-12.503 128-34.292z"
      />
      <path
        style={{
          fill: "#ffd500",
        }}
        d="M100.174 256c0-28.369 7.742-54.91 21.043-77.847l-86.806-50.034C12.502 165.746 0 209.444 0 256s12.502 90.254 34.411 127.881l86.806-50.034c-13.301-22.937-21.043-49.478-21.043-77.847z"
      />
      <path
        style={{
          fill: "#ff4b26",
        }}
        d="M256 100.174c37.531 0 72.005 13.336 98.932 35.519 6.643 5.472 16.298 5.077 22.383-1.008l47.27-47.27c6.904-6.904 6.412-18.205-.963-24.603C378.507 23.673 319.807 0 256 0 161.34 0 78.586 51.557 34.411 128.119l86.806 50.034c26.985-46.533 77.229-77.979 134.783-77.979z"
      />
      <path
        style={{
          fill: "#d93f21",
        }}
        d="M354.932 135.693c6.643 5.472 16.299 5.077 22.383-1.008l47.27-47.27c6.903-6.904 6.411-18.205-.963-24.603C378.507 23.672 319.807 0 256 0v100.174c37.53 0 72.005 13.336 98.932 35.519z"
      />
    </svg>
  );
}
